// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AccountOpsListOutboxEventsData, AccountOpsListOutboxEventsErrors, AccountOpsListOutboxEventsResponses, AccountOpsReplayOutboxData, AccountOpsReplayOutboxErrors, AccountOpsReplayOutboxResponses, AccountServiceCaptureHoldData, AccountServiceCaptureHoldErrors, AccountServiceCaptureHoldResponses, AccountServiceCloseAccountData, AccountServiceCloseAccountErrors, AccountServiceCloseAccountResponses, AccountServiceCreateAccountData, AccountServiceCreateAccountErrors, AccountServiceCreateAccountResponses, AccountServiceCreditAccountData, AccountServiceCreditAccountErrors, AccountServiceCreditAccountResponses, AccountServiceDebitAccountData, AccountServiceDebitAccountErrors, AccountServiceDebitAccountResponses, AccountServiceGetAccountData, AccountServiceGetAccountEntryData, AccountServiceGetAccountEntryErrors, AccountServiceGetAccountEntryResponses, AccountServiceGetAccountErrors, AccountServiceGetAccountResponses, AccountServiceGetBalanceHoldData, AccountServiceGetBalanceHoldErrors, AccountServiceGetBalanceHoldResponses, AccountServiceGetTransferData, AccountServiceGetTransferErrors, AccountServiceGetTransferResponses, AccountServiceListAccountEntriesData, AccountServiceListAccountEntriesErrors, AccountServiceListAccountEntriesResponses, AccountServiceListAccountsData, AccountServiceListAccountsErrors, AccountServiceListAccountsResponses, AccountServiceListBalanceHoldsData, AccountServiceListBalanceHoldsErrors, AccountServiceListBalanceHoldsResponses, AccountServiceListTransfersData, AccountServiceListTransfersErrors, AccountServiceListTransfersResponses, AccountServicePlaceHoldData, AccountServicePlaceHoldErrors, AccountServicePlaceHoldResponses, AccountServiceReleaseHoldData, AccountServiceReleaseHoldErrors, AccountServiceReleaseHoldResponses, AccountServiceResolveBalanceHoldData, AccountServiceResolveBalanceHoldErrors, AccountServiceResolveBalanceHoldResponses, AccountServiceResolveTransferData, AccountServiceResolveTransferErrors, AccountServiceResolveTransferResponses, AccountServiceResumeAccountData, AccountServiceResumeAccountErrors, AccountServiceResumeAccountResponses, AccountServiceSuspendAccountData, AccountServiceSuspendAccountErrors, AccountServiceSuspendAccountResponses, AccountServiceTransferFundsData, AccountServiceTransferFundsErrors, AccountServiceTransferFundsResponses, AfterSalesServiceApproveCaseData, AfterSalesServiceApproveCaseErrors, AfterSalesServiceApproveCaseResponses, AfterSalesServiceCreateAftersalesCaseData, AfterSalesServiceCreateAftersalesCaseErrors, AfterSalesServiceCreateAftersalesCaseResponses, AfterSalesServiceEscalateCaseData, AfterSalesServiceEscalateCaseErrors, AfterSalesServiceEscalateCaseResponses, AfterSalesServiceGetAftersalesCaseData, AfterSalesServiceGetAftersalesCaseErrors, AfterSalesServiceGetAftersalesCaseResponses, AfterSalesServiceListAftersalesCasesData, AfterSalesServiceListAftersalesCasesErrors, AfterSalesServiceListAftersalesCasesResponses, AfterSalesServiceRecordInspectionData, AfterSalesServiceRecordInspectionErrors, AfterSalesServiceRecordInspectionResponses, AfterSalesServiceRejectCaseData, AfterSalesServiceRejectCaseErrors, AfterSalesServiceRejectCaseResponses, AfterSalesServiceRequestRefundData, AfterSalesServiceRequestRefundErrors, AfterSalesServiceRequestRefundResponses, AfterSalesServiceSubmitReturnShipmentData, AfterSalesServiceSubmitReturnShipmentErrors, AfterSalesServiceSubmitReturnShipmentResponses, AuxiliaryServiceCreateContactData, AuxiliaryServiceCreateContactErrors, AuxiliaryServiceCreateContactResponses, AuxiliaryServiceCreateDepartmentData, AuxiliaryServiceCreateDepartmentErrors, AuxiliaryServiceCreateDepartmentResponses, AuxiliaryServiceCreateProjectData, AuxiliaryServiceCreateProjectErrors, AuxiliaryServiceCreateProjectResponses, AuxiliaryServiceDisableContactData, AuxiliaryServiceDisableContactErrors, AuxiliaryServiceDisableContactResponses, AuxiliaryServiceDisableDepartmentData, AuxiliaryServiceDisableDepartmentErrors, AuxiliaryServiceDisableDepartmentResponses, AuxiliaryServiceDisableProjectData, AuxiliaryServiceDisableProjectErrors, AuxiliaryServiceDisableProjectResponses, AuxiliaryServiceGetContactData, AuxiliaryServiceGetContactErrors, AuxiliaryServiceGetContactResponses, AuxiliaryServiceGetDepartmentData, AuxiliaryServiceGetDepartmentErrors, AuxiliaryServiceGetDepartmentResponses, AuxiliaryServiceGetProjectData, AuxiliaryServiceGetProjectErrors, AuxiliaryServiceGetProjectResponses, AuxiliaryServiceListContactsData, AuxiliaryServiceListContactsErrors, AuxiliaryServiceListContactsResponses, AuxiliaryServiceListDepartmentsData, AuxiliaryServiceListDepartmentsErrors, AuxiliaryServiceListDepartmentsResponses, AuxiliaryServiceListProjectsData, AuxiliaryServiceListProjectsErrors, AuxiliaryServiceListProjectsResponses, BillingServiceCancelSubscriptionData, BillingServiceCancelSubscriptionErrors, BillingServiceCancelSubscriptionResponses, BillingServiceChangeSubscriptionData, BillingServiceChangeSubscriptionErrors, BillingServiceChangeSubscriptionResponses, BillingServiceCreateSubscriptionData, BillingServiceCreateSubscriptionErrors, BillingServiceCreateSubscriptionResponses, BillingServiceGetInvoiceData, BillingServiceGetInvoiceErrors, BillingServiceGetInvoiceResponses, BillingServiceGetSubscriptionData, BillingServiceGetSubscriptionErrors, BillingServiceGetSubscriptionResponses, BillingServiceListInvoicesData, BillingServiceListInvoicesErrors, BillingServiceListInvoicesResponses, BillingServiceListSubscriptionsData, BillingServiceListSubscriptionsErrors, BillingServiceListSubscriptionsResponses, BillingServiceRecordUsageData, BillingServiceRecordUsageErrors, BillingServiceRecordUsageResponses, BillingServiceRetryInvoicePaymentData, BillingServiceRetryInvoicePaymentErrors, BillingServiceRetryInvoicePaymentResponses, CartServiceAcknowledgeCheckoutData, CartServiceAcknowledgeCheckoutErrors, CartServiceAcknowledgeCheckoutResponses, CartServiceAddLineData, CartServiceAddLineErrors, CartServiceAddLineResponses, CartServiceAdjustLineData, CartServiceAdjustLineErrors, CartServiceAdjustLineResponses, CartServiceConsumeCheckoutHandoffData, CartServiceConsumeCheckoutHandoffErrors, CartServiceConsumeCheckoutHandoffResponses, CartServiceDropLineData, CartServiceDropLineErrors, CartServiceDropLineResponses, CartServiceGetCartData, CartServiceGetCartErrors, CartServiceGetCartResponses, CartServiceListCartsData, CartServiceListCartsErrors, CartServiceListCartsResponses, CartServiceMergeGuestCartData, CartServiceMergeGuestCartErrors, CartServiceMergeGuestCartResponses, CartServiceOpenCheckoutHandoffData, CartServiceOpenCheckoutHandoffErrors, CartServiceOpenCheckoutHandoffResponses, CartServiceSelectLinesData, CartServiceSelectLinesErrors, CartServiceSelectLinesResponses, ClearingServiceApplyPostingData, ClearingServiceApplyPostingErrors, ClearingServiceApplyPostingResponses, ClearingServiceCalculateClearingData, ClearingServiceCalculateClearingErrors, ClearingServiceCalculateClearingResponses, ClearingServiceGetClearingAllocationData, ClearingServiceGetClearingAllocationErrors, ClearingServiceGetClearingAllocationResponses, ClearingServiceGetClearingBatchData, ClearingServiceGetClearingBatchErrors, ClearingServiceGetClearingBatchResponses, ClearingServiceListClearingAllocationsData, ClearingServiceListClearingAllocationsErrors, ClearingServiceListClearingAllocationsResponses, ClearingServiceListClearingBatchesData, ClearingServiceListClearingBatchesErrors, ClearingServiceListClearingBatchesResponses, ClearingServicePublishRuleVersionData, ClearingServicePublishRuleVersionErrors, ClearingServicePublishRuleVersionResponses, ClearingServiceRecordAdjustmentData, ClearingServiceRecordAdjustmentErrors, ClearingServiceRecordAdjustmentResponses, ClearingServiceReverseClearingData, ClearingServiceReverseClearingErrors, ClearingServiceReverseClearingResponses, ExchangeRateServiceGetExchangeRateData, ExchangeRateServiceGetExchangeRateErrors, ExchangeRateServiceGetExchangeRateResponses, ExchangeRateServiceListExchangeRatesData, ExchangeRateServiceListExchangeRatesErrors, ExchangeRateServiceListExchangeRatesResponses, ExchangeRateServiceSetExchangeRateData, ExchangeRateServiceSetExchangeRateErrors, ExchangeRateServiceSetExchangeRateResponses, FulfillmentServiceAllocateFulfillmentData, FulfillmentServiceAllocateFulfillmentErrors, FulfillmentServiceAllocateFulfillmentResponses, FulfillmentServiceCancelFulfillmentData, FulfillmentServiceCancelFulfillmentErrors, FulfillmentServiceCancelFulfillmentResponses, FulfillmentServiceGetFulfillmentOrderData, FulfillmentServiceGetFulfillmentOrderErrors, FulfillmentServiceGetFulfillmentOrderResponses, FulfillmentServiceHandoffPackageData, FulfillmentServiceHandoffPackageErrors, FulfillmentServiceHandoffPackageResponses, FulfillmentServiceListFulfillmentOrdersData, FulfillmentServiceListFulfillmentOrdersErrors, FulfillmentServiceListFulfillmentOrdersResponses, FulfillmentServiceMarkPackedData, FulfillmentServiceMarkPackedErrors, FulfillmentServiceMarkPackedResponses, FulfillmentServiceOpenFulfillmentOrderData, FulfillmentServiceOpenFulfillmentOrderErrors, FulfillmentServiceOpenFulfillmentOrderResponses, FulfillmentServiceQuotePromiseData, FulfillmentServiceQuotePromiseErrors, FulfillmentServiceQuotePromiseResponses, FulfillmentServiceRecordReturnReceiptData, FulfillmentServiceRecordReturnReceiptErrors, FulfillmentServiceRecordReturnReceiptResponses, FulfillmentServiceStartPickingData, FulfillmentServiceStartPickingErrors, FulfillmentServiceStartPickingResponses, GlAccountServiceCreateGlAccountData, GlAccountServiceCreateGlAccountErrors, GlAccountServiceCreateGlAccountResponses, GlAccountServiceDisableGlAccountData, GlAccountServiceDisableGlAccountErrors, GlAccountServiceDisableGlAccountResponses, GlAccountServiceGetGlAccountData, GlAccountServiceGetGlAccountErrors, GlAccountServiceGetGlAccountResponses, GlAccountServiceListGlAccountsData, GlAccountServiceListGlAccountsErrors, GlAccountServiceListGlAccountsResponses, InventoryServiceAdjustStockData, InventoryServiceAdjustStockErrors, InventoryServiceAdjustStockResponses, InventoryServiceCheckAvailabilityData, InventoryServiceCheckAvailabilityErrors, InventoryServiceCheckAvailabilityResponses, InventoryServiceCommitReservationData, InventoryServiceCommitReservationErrors, InventoryServiceCommitReservationResponses, InventoryServiceGetReservationData, InventoryServiceGetReservationErrors, InventoryServiceGetReservationResponses, InventoryServiceGetStockItemData, InventoryServiceGetStockItemErrors, InventoryServiceGetStockItemResponses, InventoryServiceListReservationsData, InventoryServiceListReservationsErrors, InventoryServiceListReservationsResponses, InventoryServiceListStockItemsData, InventoryServiceListStockItemsErrors, InventoryServiceListStockItemsResponses, InventoryServiceReleaseReservationData, InventoryServiceReleaseReservationErrors, InventoryServiceReleaseReservationResponses, InventoryServiceReserveStockData, InventoryServiceReserveStockErrors, InventoryServiceReserveStockResponses, InventoryServiceTransferStockData, InventoryServiceTransferStockErrors, InventoryServiceTransferStockResponses, JournalServiceGetJournalData, JournalServiceGetJournalErrors, JournalServiceGetJournalResponses, JournalServiceListJournalsData, JournalServiceListJournalsErrors, JournalServiceListJournalsResponses, JournalServiceReverseJournalData, JournalServiceReverseJournalErrors, JournalServiceReverseJournalResponses, LedgerServiceCreateLedgerData, LedgerServiceCreateLedgerErrors, LedgerServiceCreateLedgerResponses, LedgerServiceDeactivateLedgerData, LedgerServiceDeactivateLedgerErrors, LedgerServiceDeactivateLedgerResponses, LedgerServiceGetLedgerData, LedgerServiceGetLedgerErrors, LedgerServiceGetLedgerResponses, LedgerServiceListLedgersData, LedgerServiceListLedgersErrors, LedgerServiceListLedgersResponses, LedgerServiceSetDefaultLedgerData, LedgerServiceSetDefaultLedgerErrors, LedgerServiceSetDefaultLedgerResponses, LedgerServiceUpdateLedgerData, LedgerServiceUpdateLedgerErrors, LedgerServiceUpdateLedgerResponses, LogisticsServiceApplyCarrierEventData, LogisticsServiceApplyCarrierEventErrors, LogisticsServiceApplyCarrierEventResponses, LogisticsServiceBookShipmentData, LogisticsServiceBookShipmentErrors, LogisticsServiceBookShipmentResponses, LogisticsServiceCancelShipmentData, LogisticsServiceCancelShipmentErrors, LogisticsServiceCancelShipmentResponses, LogisticsServiceGetShipmentData, LogisticsServiceGetShipmentErrors, LogisticsServiceGetShipmentResponses, LogisticsServiceIssueReturnLabelData, LogisticsServiceIssueReturnLabelErrors, LogisticsServiceIssueReturnLabelResponses, LogisticsServiceListShipmentsData, LogisticsServiceListShipmentsErrors, LogisticsServiceListShipmentsResponses, LogisticsServiceQuoteFreightData, LogisticsServiceQuoteFreightErrors, LogisticsServiceQuoteFreightResponses, MemberServiceEnrollMemberData, MemberServiceEnrollMemberErrors, MemberServiceEnrollMemberResponses, MemberServiceGetAddressData, MemberServiceGetAddressErrors, MemberServiceGetAddressResponses, MemberServiceGetMemberData, MemberServiceGetMemberErrors, MemberServiceGetMemberResponses, MemberServiceListAddressesData, MemberServiceListAddressesErrors, MemberServiceListAddressesResponses, MemberServiceListMembersData, MemberServiceListMembersErrors, MemberServiceListMembersResponses, MemberServiceRecordConsentData, MemberServiceRecordConsentErrors, MemberServiceRecordConsentResponses, MemberServiceRequestErasureData, MemberServiceRequestErasureErrors, MemberServiceRequestErasureResponses, MemberServiceResolveSelfData, MemberServiceResolveSelfErrors, MemberServiceResolveSelfResponses, MemberServiceReviseMemberData, MemberServiceReviseMemberErrors, MemberServiceReviseMemberResponses, MemberServiceUpsertAddressData, MemberServiceUpsertAddressErrors, MemberServiceUpsertAddressResponses, MerchantServiceAssignStaffScopeData, MerchantServiceAssignStaffScopeErrors, MerchantServiceAssignStaffScopeResponses, MerchantServiceCreateMerchantData, MerchantServiceCreateMerchantErrors, MerchantServiceCreateMerchantResponses, MerchantServiceFreezeMerchantData, MerchantServiceFreezeMerchantErrors, MerchantServiceFreezeMerchantResponses, MerchantServiceGetLegalProfileRevisionData, MerchantServiceGetLegalProfileRevisionErrors, MerchantServiceGetLegalProfileRevisionResponses, MerchantServiceGetMerchantData, MerchantServiceGetMerchantErrors, MerchantServiceGetMerchantResponses, MerchantServiceListMerchantsData, MerchantServiceListMerchantsErrors, MerchantServiceListMerchantsResponses, MerchantServiceReviewLegalProfileData, MerchantServiceReviewLegalProfileErrors, MerchantServiceReviewLegalProfileResponses, MerchantServiceSubmitLegalProfileData, MerchantServiceSubmitLegalProfileErrors, MerchantServiceSubmitLegalProfileResponses, MerchantServiceUnfreezeMerchantData, MerchantServiceUnfreezeMerchantErrors, MerchantServiceUnfreezeMerchantResponses, MerchantServiceUpdateMerchantData, MerchantServiceUpdateMerchantErrors, MerchantServiceUpdateMerchantResponses, NotificationServiceBatchMarkInboxReadData, NotificationServiceBatchMarkInboxReadErrors, NotificationServiceBatchMarkInboxReadResponses, NotificationServiceBatchSendNotificationsData, NotificationServiceBatchSendNotificationsErrors, NotificationServiceBatchSendNotificationsResponses, NotificationServiceCreateTemplateData, NotificationServiceCreateTemplateErrors, NotificationServiceCreateTemplateResponses, NotificationServiceCreateTemplateVersionData, NotificationServiceCreateTemplateVersionErrors, NotificationServiceCreateTemplateVersionResponses, NotificationServiceDeleteTemplateData, NotificationServiceDeleteTemplateErrors, NotificationServiceDeleteTemplateResponses, NotificationServiceGetInboxItemData, NotificationServiceGetInboxItemErrors, NotificationServiceGetInboxItemResponses, NotificationServiceGetNotificationData, NotificationServiceGetNotificationErrors, NotificationServiceGetNotificationPreferenceData, NotificationServiceGetNotificationPreferenceErrors, NotificationServiceGetNotificationPreferenceResponses, NotificationServiceGetNotificationResponses, NotificationServiceGetTemplateData, NotificationServiceGetTemplateErrors, NotificationServiceGetTemplateResponses, NotificationServiceGetTemplateVersionData, NotificationServiceGetTemplateVersionErrors, NotificationServiceGetTemplateVersionResponses, NotificationServiceListInboxNotificationsData, NotificationServiceListInboxNotificationsErrors, NotificationServiceListInboxNotificationsResponses, NotificationServiceListNotificationsData, NotificationServiceListNotificationsErrors, NotificationServiceListNotificationsResponses, NotificationServiceListTemplatesData, NotificationServiceListTemplatesErrors, NotificationServiceListTemplatesResponses, NotificationServiceMarkInboxNotificationReadData, NotificationServiceMarkInboxNotificationReadErrors, NotificationServiceMarkInboxNotificationReadResponses, NotificationServicePreviewTemplateData, NotificationServicePreviewTemplateErrors, NotificationServicePreviewTemplateResponses, NotificationServicePublishTemplateVersionData, NotificationServicePublishTemplateVersionErrors, NotificationServicePublishTemplateVersionResponses, NotificationServiceSendNotificationData, NotificationServiceSendNotificationErrors, NotificationServiceSendNotificationResponses, NotificationServiceUpdateNotificationPreferenceData, NotificationServiceUpdateNotificationPreferenceErrors, NotificationServiceUpdateNotificationPreferenceResponses, NotificationServiceUpdateTemplateData, NotificationServiceUpdateTemplateErrors, NotificationServiceUpdateTemplateResponses, OrderServiceApplyPaymentFactData, OrderServiceApplyPaymentFactErrors, OrderServiceApplyPaymentFactResponses, OrderServiceAttachCaseData, OrderServiceAttachCaseErrors, OrderServiceAttachCaseResponses, OrderServiceGetOrderData, OrderServiceGetOrderErrors, OrderServiceGetOrderResponses, OrderServiceListOrdersData, OrderServiceListOrdersErrors, OrderServiceListOrdersResponses, OrderServiceMarkFulfillmentProgressData, OrderServiceMarkFulfillmentProgressErrors, OrderServiceMarkFulfillmentProgressResponses, OrderServiceRealizeOrderData, OrderServiceRealizeOrderErrors, OrderServiceRealizeOrderResponses, OrderServiceRequestCancellationData, OrderServiceRequestCancellationErrors, OrderServiceRequestCancellationResponses, ParkedEventServiceAssignEventTargetsData, ParkedEventServiceAssignEventTargetsErrors, ParkedEventServiceAssignEventTargetsResponses, ParkedEventServiceListEventReceiptsData, ParkedEventServiceListEventReceiptsErrors, ParkedEventServiceListEventReceiptsResponses, ParkedEventServiceListParkedEventsData, ParkedEventServiceListParkedEventsErrors, ParkedEventServiceListParkedEventsResponses, ParkedEventServiceRejectParkedEventData, ParkedEventServiceRejectParkedEventErrors, ParkedEventServiceRejectParkedEventResponses, ParkedEventServiceRetryParkedEventData, ParkedEventServiceRetryParkedEventErrors, ParkedEventServiceRetryParkedEventResponses, PaymentServiceApplyProviderNotificationData, PaymentServiceApplyProviderNotificationErrors, PaymentServiceApplyProviderNotificationResponses, PaymentServiceCancelPaymentIntentData, PaymentServiceCancelPaymentIntentErrors, PaymentServiceCancelPaymentIntentResponses, PaymentServiceConfirmPaymentIntentData, PaymentServiceConfirmPaymentIntentErrors, PaymentServiceConfirmPaymentIntentResponses, PaymentServiceExecutePayoutData, PaymentServiceExecutePayoutErrors, PaymentServiceExecutePayoutResponses, PaymentServiceExecuteRefundData, PaymentServiceExecuteRefundErrors, PaymentServiceExecuteRefundResponses, PaymentServiceGetChannelStatementData, PaymentServiceGetChannelStatementErrors, PaymentServiceGetChannelStatementResponses, PaymentServiceGetPaymentIntentData, PaymentServiceGetPaymentIntentErrors, PaymentServiceGetPaymentIntentResponses, PaymentServiceGetPayoutData, PaymentServiceGetPayoutErrors, PaymentServiceGetPayoutResponses, PaymentServiceGetRefundData, PaymentServiceGetRefundErrors, PaymentServiceGetRefundResponses, PaymentServiceListChannelStatementsData, PaymentServiceListChannelStatementsErrors, PaymentServiceListChannelStatementsResponses, PaymentServiceListPaymentIntentsData, PaymentServiceListPaymentIntentsErrors, PaymentServiceListPaymentIntentsResponses, PaymentServiceListPayoutsData, PaymentServiceListPayoutsErrors, PaymentServiceListPayoutsResponses, PaymentServiceListRefundsData, PaymentServiceListRefundsErrors, PaymentServiceListRefundsResponses, PaymentServiceOpenPaymentIntentData, PaymentServiceOpenPaymentIntentErrors, PaymentServiceOpenPaymentIntentResponses, PeriodServiceGetPeriodData, PeriodServiceGetPeriodErrors, PeriodServiceGetPeriodResponses, PeriodServiceHardClosePeriodData, PeriodServiceHardClosePeriodErrors, PeriodServiceHardClosePeriodResponses, PeriodServiceListPeriodsData, PeriodServiceListPeriodsErrors, PeriodServiceListPeriodsResponses, PeriodServiceReopenPeriodData, PeriodServiceReopenPeriodErrors, PeriodServiceReopenPeriodResponses, PeriodServiceRunClosingEntriesData, PeriodServiceRunClosingEntriesErrors, PeriodServiceRunClosingEntriesResponses, PeriodServiceSoftClosePeriodData, PeriodServiceSoftClosePeriodErrors, PeriodServiceSoftClosePeriodResponses, PostingRuleServiceActivatePostingRuleData, PostingRuleServiceActivatePostingRuleErrors, PostingRuleServiceActivatePostingRuleResponses, PostingRuleServiceCreatePostingRuleData, PostingRuleServiceCreatePostingRuleErrors, PostingRuleServiceCreatePostingRuleResponses, PostingRuleServiceGetPostingRuleData, PostingRuleServiceGetPostingRuleErrors, PostingRuleServiceGetPostingRuleResponses, PostingRuleServiceListPostingRulesData, PostingRuleServiceListPostingRulesErrors, PostingRuleServiceListPostingRulesResponses, PostingRuleServiceListPostingRuleVersionsData, PostingRuleServiceListPostingRuleVersionsErrors, PostingRuleServiceListPostingRuleVersionsResponses, PostingRuleServiceRetirePostingRuleData, PostingRuleServiceRetirePostingRuleErrors, PostingRuleServiceRetirePostingRuleResponses, PricingServiceActivatePriceBookData, PricingServiceActivatePriceBookErrors, PricingServiceActivatePriceBookResponses, PricingServiceCalculateOfferPricesData, PricingServiceCalculateOfferPricesErrors, PricingServiceCalculateOfferPricesResponses, PricingServiceDraftPriceBookData, PricingServiceDraftPriceBookErrors, PricingServiceDraftPriceBookResponses, PricingServiceDraftRuleSetData, PricingServiceDraftRuleSetErrors, PricingServiceDraftRuleSetResponses, PricingServiceGetPriceRevisionData, PricingServiceGetPriceRevisionErrors, PricingServiceGetPriceRevisionResponses, PricingServiceListPriceRevisionsData, PricingServiceListPriceRevisionsErrors, PricingServiceListPriceRevisionsResponses, PricingServicePublishRuleSetData, PricingServicePublishRuleSetErrors, PricingServicePublishRuleSetResponses, PricingServiceRevisePriceBookData, PricingServiceRevisePriceBookErrors, PricingServiceRevisePriceBookResponses, ProductServiceAddVariantData, ProductServiceAddVariantErrors, ProductServiceAddVariantResponses, ProductServiceCreateProductData, ProductServiceCreateProductErrors, ProductServiceCreateProductResponses, ProductServiceGetOfferSnapshotData, ProductServiceGetOfferSnapshotErrors, ProductServiceGetOfferSnapshotResponses, ProductServiceGetProductData, ProductServiceGetProductErrors, ProductServiceGetProductResponses, ProductServiceListProductsData, ProductServiceListProductsErrors, ProductServiceListProductsResponses, ProductServicePublishOfferData, ProductServicePublishOfferErrors, ProductServicePublishOfferResponses, ProductServiceSuspendOfferData, ProductServiceSuspendOfferErrors, ProductServiceSuspendOfferResponses, ProductServiceUpdateProductData, ProductServiceUpdateProductErrors, ProductServiceUpdateProductResponses, PromotionServiceConsumePromotionData, PromotionServiceConsumePromotionErrors, PromotionServiceConsumePromotionResponses, PromotionServiceDraftCampaignData, PromotionServiceDraftCampaignErrors, PromotionServiceDraftCampaignResponses, PromotionServiceEvaluatePromotionsData, PromotionServiceEvaluatePromotionsErrors, PromotionServiceEvaluatePromotionsResponses, PromotionServiceGetPromotionReservationData, PromotionServiceGetPromotionReservationErrors, PromotionServiceGetPromotionReservationResponses, PromotionServiceIssueCouponData, PromotionServiceIssueCouponErrors, PromotionServiceIssueCouponResponses, PromotionServiceListPromotionReservationsData, PromotionServiceListPromotionReservationsErrors, PromotionServiceListPromotionReservationsResponses, PromotionServicePublishCampaignData, PromotionServicePublishCampaignErrors, PromotionServicePublishCampaignResponses, PromotionServiceReleasePromotionData, PromotionServiceReleasePromotionErrors, PromotionServiceReleasePromotionResponses, PromotionServiceReservePromotionData, PromotionServiceReservePromotionErrors, PromotionServiceReservePromotionResponses, ReconciliationServiceAssignDiscrepancyData, ReconciliationServiceAssignDiscrepancyErrors, ReconciliationServiceAssignDiscrepancyResponses, ReconciliationServiceExportEvidenceData, ReconciliationServiceExportEvidenceErrors, ReconciliationServiceExportEvidenceResponses, ReconciliationServiceGetDiscrepancyCaseData, ReconciliationServiceGetDiscrepancyCaseErrors, ReconciliationServiceGetDiscrepancyCaseResponses, ReconciliationServiceGetReconciliationRunData, ReconciliationServiceGetReconciliationRunErrors, ReconciliationServiceGetReconciliationRunResponses, ReconciliationServiceListDiscrepancyCasesData, ReconciliationServiceListDiscrepancyCasesErrors, ReconciliationServiceListDiscrepancyCasesResponses, ReconciliationServiceListReconciliationRunsData, ReconciliationServiceListReconciliationRunsErrors, ReconciliationServiceListReconciliationRunsResponses, ReconciliationServiceResolveDiscrepancyData, ReconciliationServiceResolveDiscrepancyErrors, ReconciliationServiceResolveDiscrepancyResponses, ReconciliationServiceStartRunData, ReconciliationServiceStartRunErrors, ReconciliationServiceStartRunResponses, ReportServiceGetBalanceSheetData, ReportServiceGetBalanceSheetErrors, ReportServiceGetBalanceSheetResponses, ReportServiceGetCashFlowStatementData, ReportServiceGetCashFlowStatementErrors, ReportServiceGetCashFlowStatementResponses, ReportServiceGetDetailLedgerData, ReportServiceGetDetailLedgerErrors, ReportServiceGetDetailLedgerResponses, ReportServiceGetEquityChangesData, ReportServiceGetEquityChangesErrors, ReportServiceGetEquityChangesResponses, ReportServiceGetGeneralLedgerData, ReportServiceGetGeneralLedgerErrors, ReportServiceGetGeneralLedgerResponses, ReportServiceGetIncomeStatementData, ReportServiceGetIncomeStatementErrors, ReportServiceGetIncomeStatementResponses, ReportServiceGetStandardBridgeData, ReportServiceGetStandardBridgeErrors, ReportServiceGetStandardBridgeResponses, ReportServiceGetTrialBalanceData, ReportServiceGetTrialBalanceErrors, ReportServiceGetTrialBalanceResponses, ReviewServiceCreateReviewData, ReviewServiceCreateReviewErrors, ReviewServiceCreateReviewResponses, ReviewServiceGetProductReviewSummaryData, ReviewServiceGetProductReviewSummaryErrors, ReviewServiceGetProductReviewSummaryResponses, ReviewServiceGetReviewData, ReviewServiceGetReviewErrors, ReviewServiceGetReviewResponses, ReviewServiceListReviewsData, ReviewServiceListReviewsErrors, ReviewServiceListReviewsResponses, ReviewServiceModerateReviewData, ReviewServiceModerateReviewErrors, ReviewServiceModerateReviewResponses, ReviewServiceReplyReviewData, ReviewServiceReplyReviewErrors, ReviewServiceReplyReviewResponses, RiskServiceEvaluateCheckoutData, RiskServiceEvaluateCheckoutErrors, RiskServiceEvaluateCheckoutResponses, RiskServiceEvaluatePaymentData, RiskServiceEvaluatePaymentErrors, RiskServiceEvaluatePaymentResponses, RiskServiceEvaluatePayoutData, RiskServiceEvaluatePayoutErrors, RiskServiceEvaluatePayoutResponses, RiskServiceEvaluateRefundData, RiskServiceEvaluateRefundErrors, RiskServiceEvaluateRefundResponses, RiskServiceGetRiskDecisionData, RiskServiceGetRiskDecisionErrors, RiskServiceGetRiskDecisionResponses, RiskServiceListRiskDecisionsData, RiskServiceListRiskDecisionsErrors, RiskServiceListRiskDecisionsResponses, RiskServiceOpenCaseData, RiskServiceOpenCaseErrors, RiskServiceOpenCaseResponses, RiskServicePublishRuleSetData, RiskServicePublishRuleSetErrors, RiskServicePublishRuleSetResponses, RiskServiceResolveCaseData, RiskServiceResolveCaseErrors, RiskServiceResolveCaseResponses, SettlementServiceApproveBatchData, SettlementServiceApproveBatchErrors, SettlementServiceApproveBatchResponses, SettlementServiceCalculateWindowData, SettlementServiceCalculateWindowErrors, SettlementServiceCalculateWindowResponses, SettlementServiceGetPayoutInstructionData, SettlementServiceGetPayoutInstructionErrors, SettlementServiceGetPayoutInstructionResponses, SettlementServiceGetSettlementStatementData, SettlementServiceGetSettlementStatementErrors, SettlementServiceGetSettlementStatementResponses, SettlementServiceHoldStatementData, SettlementServiceHoldStatementErrors, SettlementServiceHoldStatementResponses, SettlementServiceListPayoutInstructionsData, SettlementServiceListPayoutInstructionsErrors, SettlementServiceListPayoutInstructionsResponses, SettlementServiceListSettlementStatementsData, SettlementServiceListSettlementStatementsErrors, SettlementServiceListSettlementStatementsResponses, SettlementServicePublishPolicyVersionData, SettlementServicePublishPolicyVersionErrors, SettlementServicePublishPolicyVersionResponses, SettlementServiceReleaseStatementData, SettlementServiceReleaseStatementErrors, SettlementServiceReleaseStatementResponses, SettlementServiceRequestPayoutData, SettlementServiceRequestPayoutErrors, SettlementServiceRequestPayoutResponses, StorefrontServiceOpenOfferViewData, StorefrontServiceOpenOfferViewErrors, StorefrontServiceOpenOfferViewResponses, StorefrontServiceOpenStorefrontHomeData, StorefrontServiceOpenStorefrontHomeErrors, StorefrontServiceOpenStorefrontHomeResponses, StorefrontServiceResolveStoreContextData, StorefrontServiceResolveStoreContextErrors, StorefrontServiceResolveStoreContextResponses, StoreServiceActivateStoreData, StoreServiceActivateStoreErrors, StoreServiceActivateStoreResponses, StoreServiceApplyPolicyOverrideData, StoreServiceApplyPolicyOverrideErrors, StoreServiceApplyPolicyOverrideResponses, StoreServiceCloseStoreData, StoreServiceCloseStoreErrors, StoreServiceCloseStoreResponses, StoreServiceConfigureChannelData, StoreServiceConfigureChannelErrors, StoreServiceConfigureChannelResponses, StoreServiceCreateStoreData, StoreServiceCreateStoreErrors, StoreServiceCreateStoreResponses, StoreServiceGetStoreData, StoreServiceGetStoreErrors, StoreServiceGetStoreResponses, StoreServiceListStoresData, StoreServiceListStoresErrors, StoreServiceListStoresResponses, StoreServicePauseStoreData, StoreServicePauseStoreErrors, StoreServicePauseStoreResponses, StoreServiceResumeStoreData, StoreServiceResumeStoreErrors, StoreServiceResumeStoreResponses, StoreServiceSuspendStoreData, StoreServiceSuspendStoreErrors, StoreServiceSuspendStoreResponses, StoreServiceUpdateStoreData, StoreServiceUpdateStoreErrors, StoreServiceUpdateStoreResponses, TaxServiceCalculateTaxData, TaxServiceCalculateTaxErrors, TaxServiceCalculateTaxResponses, TaxServiceFinalizeTaxTransactionData, TaxServiceFinalizeTaxTransactionErrors, TaxServiceFinalizeTaxTransactionResponses, TaxServiceGetTaxTransactionData, TaxServiceGetTaxTransactionErrors, TaxServiceGetTaxTransactionResponses, TaxServiceIssueCreditNoteData, TaxServiceIssueCreditNoteErrors, TaxServiceIssueCreditNoteResponses, TaxServiceIssueInvoiceData, TaxServiceIssueInvoiceErrors, TaxServiceIssueInvoiceResponses, TaxServiceListTaxTransactionsData, TaxServiceListTaxTransactionsErrors, TaxServiceListTaxTransactionsResponses, TaxServicePublishRuleVersionData, TaxServicePublishRuleVersionErrors, TaxServicePublishRuleVersionResponses, TaxServiceUpsertRegistrationData, TaxServiceUpsertRegistrationErrors, TaxServiceUpsertRegistrationResponses, TenantServiceActivatePolicyVersionData, TenantServiceActivatePolicyVersionErrors, TenantServiceActivatePolicyVersionResponses, TenantServiceCloseTenantData, TenantServiceCloseTenantErrors, TenantServiceCloseTenantResponses, TenantServiceCreatePolicyVersionData, TenantServiceCreatePolicyVersionErrors, TenantServiceCreatePolicyVersionResponses, TenantServiceCreateTenantData, TenantServiceCreateTenantErrors, TenantServiceCreateTenantResponses, TenantServiceGetPolicyVersionData, TenantServiceGetPolicyVersionErrors, TenantServiceGetPolicyVersionResponses, TenantServiceGetTenantData, TenantServiceGetTenantErrors, TenantServiceGetTenantResponses, TenantServiceListPolicyVersionsData, TenantServiceListPolicyVersionsErrors, TenantServiceListPolicyVersionsResponses, TenantServiceListQuotasData, TenantServiceListQuotasErrors, TenantServiceListQuotasResponses, TenantServiceListTenantsData, TenantServiceListTenantsErrors, TenantServiceListTenantsResponses, TenantServiceResumeTenantData, TenantServiceResumeTenantErrors, TenantServiceResumeTenantResponses, TenantServiceSuspendTenantData, TenantServiceSuspendTenantErrors, TenantServiceSuspendTenantResponses, TenantServiceUpdateTenantData, TenantServiceUpdateTenantErrors, TenantServiceUpdateTenantResponses, TodoServiceAssignTodoData, TodoServiceAssignTodoErrors, TodoServiceAssignTodoResponses, TodoServiceBatchUpdateTodosData, TodoServiceBatchUpdateTodosErrors, TodoServiceBatchUpdateTodosResponses, TodoServiceCreateCommentData, TodoServiceCreateCommentErrors, TodoServiceCreateCommentResponses, TodoServiceCreateTodoData, TodoServiceCreateTodoErrors, TodoServiceCreateTodoResponses, TodoServiceDeleteCommentData, TodoServiceDeleteCommentErrors, TodoServiceDeleteCommentResponses, TodoServiceDeleteTodoData, TodoServiceDeleteTodoErrors, TodoServiceDeleteTodoResponses, TodoServiceGetTodoData, TodoServiceGetTodoErrors, TodoServiceGetTodoResponses, TodoServiceListActivityData, TodoServiceListActivityErrors, TodoServiceListActivityResponses, TodoServiceListCommentsData, TodoServiceListCommentsErrors, TodoServiceListCommentsResponses, TodoServiceListTodosData, TodoServiceListTodosErrors, TodoServiceListTodosResponses, TodoServiceUnassignTodoData, TodoServiceUnassignTodoErrors, TodoServiceUnassignTodoResponses, TodoServiceUpdateCommentData, TodoServiceUpdateCommentErrors, TodoServiceUpdateCommentResponses, TodoServiceUpdateTodoData, TodoServiceUpdateTodoErrors, TodoServiceUpdateTodoResponses, TradeServiceApplyOrderFactData, TradeServiceApplyOrderFactErrors, TradeServiceApplyOrderFactResponses, TradeServiceApplyPaymentFactData, TradeServiceApplyPaymentFactErrors, TradeServiceApplyPaymentFactResponses, TradeServiceApplyReservationFactData, TradeServiceApplyReservationFactErrors, TradeServiceApplyReservationFactResponses, TradeServiceCancelTradeData, TradeServiceCancelTradeErrors, TradeServiceCancelTradeResponses, TradeServiceGenerateQuoteData, TradeServiceGenerateQuoteErrors, TradeServiceGenerateQuoteResponses, TradeServiceGetActionOutcomeData, TradeServiceGetActionOutcomeErrors, TradeServiceGetActionOutcomeResponses, TradeServiceGetQuoteData, TradeServiceGetQuoteErrors, TradeServiceGetQuoteResponses, TradeServiceGetTradeData, TradeServiceGetTradeErrors, TradeServiceGetTradeResponses, TradeServiceListTradesData, TradeServiceListTradesErrors, TradeServiceListTradesResponses, TradeServiceResolveManualReviewData, TradeServiceResolveManualReviewErrors, TradeServiceResolveManualReviewResponses, TradeServiceRetryUnknownStepData, TradeServiceRetryUnknownStepErrors, TradeServiceRetryUnknownStepResponses, TradeServiceSubmitTradeData, TradeServiceSubmitTradeErrors, TradeServiceSubmitTradeResponses, VoucherServiceApproveVoucherData, VoucherServiceApproveVoucherErrors, VoucherServiceApproveVoucherResponses, VoucherServiceCreateVoucherData, VoucherServiceCreateVoucherErrors, VoucherServiceCreateVoucherResponses, VoucherServiceGetVoucherData, VoucherServiceGetVoucherErrors, VoucherServiceGetVoucherResponses, VoucherServiceListVouchersData, VoucherServiceListVouchersErrors, VoucherServiceListVouchersResponses, VoucherServiceRejectVoucherData, VoucherServiceRejectVoucherErrors, VoucherServiceRejectVoucherResponses, VoucherServiceSubmitVoucherData, VoucherServiceSubmitVoucherErrors, VoucherServiceSubmitVoucherResponses, VoucherServiceUpdateVoucherDraftData, VoucherServiceUpdateVoucherDraftErrors, VoucherServiceUpdateVoucherDraftResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Lists accounts
 *
 * Lists accounts.
 */
export const accountServiceListAccounts = <ThrowOnError extends boolean = false>(options?: Options<AccountServiceListAccountsData, ThrowOnError>): RequestResult<AccountServiceListAccountsResponses, AccountServiceListAccountsErrors, ThrowOnError> => (options?.client ?? client).get<AccountServiceListAccountsResponses, AccountServiceListAccountsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts',
    ...options
});

/**
 * Creates an account
 *
 * Creates an account.
 */
export const accountServiceCreateAccount = <ThrowOnError extends boolean = false>(options: Options<AccountServiceCreateAccountData, ThrowOnError>): RequestResult<AccountServiceCreateAccountResponses, AccountServiceCreateAccountErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceCreateAccountResponses, AccountServiceCreateAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one account
 *
 * Retrieves one account.
 */
export const accountServiceGetAccount = <ThrowOnError extends boolean = false>(options: Options<AccountServiceGetAccountData, ThrowOnError>): RequestResult<AccountServiceGetAccountResponses, AccountServiceGetAccountErrors, ThrowOnError> => (options.client ?? client).get<AccountServiceGetAccountResponses, AccountServiceGetAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}',
    ...options
});

/**
 * Lists holds under one account
 *
 * Lists holds under one account.
 */
export const accountServiceListBalanceHolds = <ThrowOnError extends boolean = false>(options: Options<AccountServiceListBalanceHoldsData, ThrowOnError>): RequestResult<AccountServiceListBalanceHoldsResponses, AccountServiceListBalanceHoldsErrors, ThrowOnError> => (options.client ?? client).get<AccountServiceListBalanceHoldsResponses, AccountServiceListBalanceHoldsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}/balanceHolds',
    ...options
});

/**
 * Retrieves one hold
 *
 * Retrieves one hold.
 */
export const accountServiceGetBalanceHold = <ThrowOnError extends boolean = false>(options: Options<AccountServiceGetBalanceHoldData, ThrowOnError>): RequestResult<AccountServiceGetBalanceHoldResponses, AccountServiceGetBalanceHoldErrors, ThrowOnError> => (options.client ?? client).get<AccountServiceGetBalanceHoldResponses, AccountServiceGetBalanceHoldErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}/balanceHolds/{balanceHold}',
    ...options
});

/**
 * Consumes reserved funds
 *
 * Consumes reserved funds.
 */
export const accountServiceCaptureHold = <ThrowOnError extends boolean = false>(options: Options<AccountServiceCaptureHoldData, ThrowOnError>): RequestResult<AccountServiceCaptureHoldResponses, AccountServiceCaptureHoldErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceCaptureHoldResponses, AccountServiceCaptureHoldErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}/balanceHolds/{balanceHold}:capture',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns reserved funds to available
 *
 * Returns reserved funds to available.
 */
export const accountServiceReleaseHold = <ThrowOnError extends boolean = false>(options: Options<AccountServiceReleaseHoldData, ThrowOnError>): RequestResult<AccountServiceReleaseHoldResponses, AccountServiceReleaseHoldErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceReleaseHoldResponses, AccountServiceReleaseHoldErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}/balanceHolds/{balanceHold}:release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves the exact hold carrying one stable external key (D35)
 *
 * Resolves the exact hold carrying one stable external key (D35).
 */
export const accountServiceResolveBalanceHold = <ThrowOnError extends boolean = false>(options: Options<AccountServiceResolveBalanceHoldData, ThrowOnError>): RequestResult<AccountServiceResolveBalanceHoldResponses, AccountServiceResolveBalanceHoldErrors, ThrowOnError> => (options.client ?? client).get<AccountServiceResolveBalanceHoldResponses, AccountServiceResolveBalanceHoldErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}/balanceHolds:resolve',
    ...options
});

/**
 * Lists entries in descending sequence order
 *
 * Lists entries in descending sequence order.
 */
export const accountServiceListAccountEntries = <ThrowOnError extends boolean = false>(options: Options<AccountServiceListAccountEntriesData, ThrowOnError>): RequestResult<AccountServiceListAccountEntriesResponses, AccountServiceListAccountEntriesErrors, ThrowOnError> => (options.client ?? client).get<AccountServiceListAccountEntriesResponses, AccountServiceListAccountEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}/entries',
    ...options
});

/**
 * Retrieves one entry
 *
 * Retrieves one entry.
 */
export const accountServiceGetAccountEntry = <ThrowOnError extends boolean = false>(options: Options<AccountServiceGetAccountEntryData, ThrowOnError>): RequestResult<AccountServiceGetAccountEntryResponses, AccountServiceGetAccountEntryErrors, ThrowOnError> => (options.client ?? client).get<AccountServiceGetAccountEntryResponses, AccountServiceGetAccountEntryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}/entries/{entry}',
    ...options
});

/**
 * Permanently closes an empty account
 *
 * Permanently closes an empty account.
 */
export const accountServiceCloseAccount = <ThrowOnError extends boolean = false>(options: Options<AccountServiceCloseAccountData, ThrowOnError>): RequestResult<AccountServiceCloseAccountResponses, AccountServiceCloseAccountErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceCloseAccountResponses, AccountServiceCloseAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}:close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Credits available funds
 *
 * Credits available funds.
 */
export const accountServiceCreditAccount = <ThrowOnError extends boolean = false>(options: Options<AccountServiceCreditAccountData, ThrowOnError>): RequestResult<AccountServiceCreditAccountResponses, AccountServiceCreditAccountErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceCreditAccountResponses, AccountServiceCreditAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}:credit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Debits available funds
 *
 * Debits available funds.
 */
export const accountServiceDebitAccount = <ThrowOnError extends boolean = false>(options: Options<AccountServiceDebitAccountData, ThrowOnError>): RequestResult<AccountServiceDebitAccountResponses, AccountServiceDebitAccountErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceDebitAccountResponses, AccountServiceDebitAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}:debit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reserves available funds
 *
 * Reserves available funds.
 */
export const accountServicePlaceHold = <ThrowOnError extends boolean = false>(options: Options<AccountServicePlaceHoldData, ThrowOnError>): RequestResult<AccountServicePlaceHoldResponses, AccountServicePlaceHoldErrors, ThrowOnError> => (options.client ?? client).post<AccountServicePlaceHoldResponses, AccountServicePlaceHoldErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}:placeHold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resumes ordinary movement
 *
 * Resumes ordinary movement.
 */
export const accountServiceResumeAccount = <ThrowOnError extends boolean = false>(options: Options<AccountServiceResumeAccountData, ThrowOnError>): RequestResult<AccountServiceResumeAccountResponses, AccountServiceResumeAccountErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceResumeAccountResponses, AccountServiceResumeAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}:resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suspends all balance movement
 *
 * Suspends all balance movement.
 */
export const accountServiceSuspendAccount = <ThrowOnError extends boolean = false>(options: Options<AccountServiceSuspendAccountData, ThrowOnError>): RequestResult<AccountServiceSuspendAccountResponses, AccountServiceSuspendAccountErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceSuspendAccountResponses, AccountServiceSuspendAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts/{account}:suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Executes one atomic transfer batch
 *
 * Executes one atomic transfer batch.
 */
export const accountServiceTransferFunds = <ThrowOnError extends boolean = false>(options: Options<AccountServiceTransferFundsData, ThrowOnError>): RequestResult<AccountServiceTransferFundsResponses, AccountServiceTransferFundsErrors, ThrowOnError> => (options.client ?? client).post<AccountServiceTransferFundsResponses, AccountServiceTransferFundsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/accounts:transferFunds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists delivery evidence
 *
 * Lists delivery evidence.
 */
export const accountOpsListOutboxEvents = <ThrowOnError extends boolean = false>(options?: Options<AccountOpsListOutboxEventsData, ThrowOnError>): RequestResult<AccountOpsListOutboxEventsResponses, AccountOpsListOutboxEventsErrors, ThrowOnError> => (options?.client ?? client).get<AccountOpsListOutboxEventsResponses, AccountOpsListOutboxEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/outboxEvents',
    ...options
});

/**
 * Re-publishes committed outbox rows (duplicate-tolerant)
 *
 * Re-publishes committed outbox rows (duplicate-tolerant).
 */
export const accountOpsReplayOutbox = <ThrowOnError extends boolean = false>(options: Options<AccountOpsReplayOutboxData, ThrowOnError>): RequestResult<AccountOpsReplayOutboxResponses, AccountOpsReplayOutboxErrors, ThrowOnError> => (options.client ?? client).post<AccountOpsReplayOutboxResponses, AccountOpsReplayOutboxErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/outboxEvents:replay',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists transfers
 *
 * Lists transfers.
 */
export const accountServiceListTransfers = <ThrowOnError extends boolean = false>(options?: Options<AccountServiceListTransfersData, ThrowOnError>): RequestResult<AccountServiceListTransfersResponses, AccountServiceListTransfersErrors, ThrowOnError> => (options?.client ?? client).get<AccountServiceListTransfersResponses, AccountServiceListTransfersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/transfers',
    ...options
});

/**
 * Retrieves one transfer
 *
 * Retrieves one transfer.
 */
export const accountServiceGetTransfer = <ThrowOnError extends boolean = false>(options: Options<AccountServiceGetTransferData, ThrowOnError>): RequestResult<AccountServiceGetTransferResponses, AccountServiceGetTransferErrors, ThrowOnError> => (options.client ?? client).get<AccountServiceGetTransferResponses, AccountServiceGetTransferErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/transfers/{transfer}',
    ...options
});

/**
 * Unknown-outcome lookup by the source business operation for Clearing and
 *
 * Unknown-outcome lookup by the source business operation for Clearing and
 * Settlement; resolves the transfer produced by one operation_id.
 */
export const accountServiceResolveTransfer = <ThrowOnError extends boolean = false>(options?: Options<AccountServiceResolveTransferData, ThrowOnError>): RequestResult<AccountServiceResolveTransferResponses, AccountServiceResolveTransferErrors, ThrowOnError> => (options?.client ?? client).get<AccountServiceResolveTransferResponses, AccountServiceResolveTransferErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/account/transfers:resolve',
    ...options
});

/**
 * Lists contacts
 *
 * Lists contacts.
 */
export const auxiliaryServiceListContacts = <ThrowOnError extends boolean = false>(options?: Options<AuxiliaryServiceListContactsData, ThrowOnError>): RequestResult<AuxiliaryServiceListContactsResponses, AuxiliaryServiceListContactsErrors, ThrowOnError> => (options?.client ?? client).get<AuxiliaryServiceListContactsResponses, AuxiliaryServiceListContactsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/contacts',
    ...options
});

/**
 * Creates one contact
 *
 * Creates one contact.
 */
export const auxiliaryServiceCreateContact = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceCreateContactData, ThrowOnError>): RequestResult<AuxiliaryServiceCreateContactResponses, AuxiliaryServiceCreateContactErrors, ThrowOnError> => (options.client ?? client).post<AuxiliaryServiceCreateContactResponses, AuxiliaryServiceCreateContactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one contact
 *
 * Retrieves one contact.
 */
export const auxiliaryServiceGetContact = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceGetContactData, ThrowOnError>): RequestResult<AuxiliaryServiceGetContactResponses, AuxiliaryServiceGetContactErrors, ThrowOnError> => (options.client ?? client).get<AuxiliaryServiceGetContactResponses, AuxiliaryServiceGetContactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/contacts/{contact}',
    ...options
});

/**
 * Disables one contact
 *
 * Disables one contact.
 */
export const auxiliaryServiceDisableContact = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceDisableContactData, ThrowOnError>): RequestResult<AuxiliaryServiceDisableContactResponses, AuxiliaryServiceDisableContactErrors, ThrowOnError> => (options.client ?? client).post<AuxiliaryServiceDisableContactResponses, AuxiliaryServiceDisableContactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/contacts/{contact}:disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists departments
 *
 * Lists departments.
 */
export const auxiliaryServiceListDepartments = <ThrowOnError extends boolean = false>(options?: Options<AuxiliaryServiceListDepartmentsData, ThrowOnError>): RequestResult<AuxiliaryServiceListDepartmentsResponses, AuxiliaryServiceListDepartmentsErrors, ThrowOnError> => (options?.client ?? client).get<AuxiliaryServiceListDepartmentsResponses, AuxiliaryServiceListDepartmentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/departments',
    ...options
});

/**
 * Creates one department
 *
 * Creates one department.
 */
export const auxiliaryServiceCreateDepartment = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceCreateDepartmentData, ThrowOnError>): RequestResult<AuxiliaryServiceCreateDepartmentResponses, AuxiliaryServiceCreateDepartmentErrors, ThrowOnError> => (options.client ?? client).post<AuxiliaryServiceCreateDepartmentResponses, AuxiliaryServiceCreateDepartmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/departments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one department
 *
 * Retrieves one department.
 */
export const auxiliaryServiceGetDepartment = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceGetDepartmentData, ThrowOnError>): RequestResult<AuxiliaryServiceGetDepartmentResponses, AuxiliaryServiceGetDepartmentErrors, ThrowOnError> => (options.client ?? client).get<AuxiliaryServiceGetDepartmentResponses, AuxiliaryServiceGetDepartmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/departments/{department}',
    ...options
});

/**
 * Disables one department
 *
 * Disables one department.
 */
export const auxiliaryServiceDisableDepartment = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceDisableDepartmentData, ThrowOnError>): RequestResult<AuxiliaryServiceDisableDepartmentResponses, AuxiliaryServiceDisableDepartmentErrors, ThrowOnError> => (options.client ?? client).post<AuxiliaryServiceDisableDepartmentResponses, AuxiliaryServiceDisableDepartmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/departments/{department}:disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists first-receipt evidence
 *
 * Lists first-receipt evidence.
 */
export const parkedEventServiceListEventReceipts = <ThrowOnError extends boolean = false>(options?: Options<ParkedEventServiceListEventReceiptsData, ThrowOnError>): RequestResult<ParkedEventServiceListEventReceiptsResponses, ParkedEventServiceListEventReceiptsErrors, ThrowOnError> => (options?.client ?? client).get<ParkedEventServiceListEventReceiptsResponses, ParkedEventServiceListEventReceiptsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/eventReceipts',
    ...options
});

/**
 * Assigns explicit targets to an awaiting receipt
 *
 * Assigns explicit targets to an awaiting receipt.
 */
export const parkedEventServiceAssignEventTargets = <ThrowOnError extends boolean = false>(options: Options<ParkedEventServiceAssignEventTargetsData, ThrowOnError>): RequestResult<ParkedEventServiceAssignEventTargetsResponses, ParkedEventServiceAssignEventTargetsErrors, ThrowOnError> => (options.client ?? client).post<ParkedEventServiceAssignEventTargetsResponses, ParkedEventServiceAssignEventTargetsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/eventReceipts/{eventReceipt}:assignTargets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists one direction's history
 *
 * Lists one direction's history.
 */
export const exchangeRateServiceListExchangeRates = <ThrowOnError extends boolean = false>(options?: Options<ExchangeRateServiceListExchangeRatesData, ThrowOnError>): RequestResult<ExchangeRateServiceListExchangeRatesResponses, ExchangeRateServiceListExchangeRatesErrors, ThrowOnError> => (options?.client ?? client).get<ExchangeRateServiceListExchangeRatesResponses, ExchangeRateServiceListExchangeRatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/exchangeRates',
    ...options
});

/**
 * Retrieves one rate
 *
 * Retrieves one rate.
 */
export const exchangeRateServiceGetExchangeRate = <ThrowOnError extends boolean = false>(options: Options<ExchangeRateServiceGetExchangeRateData, ThrowOnError>): RequestResult<ExchangeRateServiceGetExchangeRateResponses, ExchangeRateServiceGetExchangeRateErrors, ThrowOnError> => (options.client ?? client).get<ExchangeRateServiceGetExchangeRateResponses, ExchangeRateServiceGetExchangeRateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/exchangeRates/{exchangeRate}',
    ...options
});

/**
 * Upserts one direction
 *
 * Upserts one direction.
 */
export const exchangeRateServiceSetExchangeRate = <ThrowOnError extends boolean = false>(options: Options<ExchangeRateServiceSetExchangeRateData, ThrowOnError>): RequestResult<ExchangeRateServiceSetExchangeRateResponses, ExchangeRateServiceSetExchangeRateErrors, ThrowOnError> => (options.client ?? client).post<ExchangeRateServiceSetExchangeRateResponses, ExchangeRateServiceSetExchangeRateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/exchangeRates:set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists ledgers
 *
 * Lists ledgers.
 */
export const ledgerServiceListLedgers = <ThrowOnError extends boolean = false>(options?: Options<LedgerServiceListLedgersData, ThrowOnError>): RequestResult<LedgerServiceListLedgersResponses, LedgerServiceListLedgersErrors, ThrowOnError> => (options?.client ?? client).get<LedgerServiceListLedgersResponses, LedgerServiceListLedgersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers',
    ...options
});

/**
 * Creates a ledger with its seeded chart
 *
 * Creates a ledger with its seeded chart.
 */
export const ledgerServiceCreateLedger = <ThrowOnError extends boolean = false>(options: Options<LedgerServiceCreateLedgerData, ThrowOnError>): RequestResult<LedgerServiceCreateLedgerResponses, LedgerServiceCreateLedgerErrors, ThrowOnError> => (options.client ?? client).post<LedgerServiceCreateLedgerResponses, LedgerServiceCreateLedgerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one ledger
 *
 * Retrieves one ledger.
 */
export const ledgerServiceGetLedger = <ThrowOnError extends boolean = false>(options: Options<LedgerServiceGetLedgerData, ThrowOnError>): RequestResult<LedgerServiceGetLedgerResponses, LedgerServiceGetLedgerErrors, ThrowOnError> => (options.client ?? client).get<LedgerServiceGetLedgerResponses, LedgerServiceGetLedgerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}',
    ...options
});

/**
 * Updates the editable ledger fields
 *
 * Updates the editable ledger fields.
 */
export const ledgerServiceUpdateLedger = <ThrowOnError extends boolean = false>(options: Options<LedgerServiceUpdateLedgerData, ThrowOnError>): RequestResult<LedgerServiceUpdateLedgerResponses, LedgerServiceUpdateLedgerErrors, ThrowOnError> => (options.client ?? client).patch<LedgerServiceUpdateLedgerResponses, LedgerServiceUpdateLedgerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists chart accounts
 *
 * Lists chart accounts.
 */
export const glAccountServiceListGlAccounts = <ThrowOnError extends boolean = false>(options: Options<GlAccountServiceListGlAccountsData, ThrowOnError>): RequestResult<GlAccountServiceListGlAccountsResponses, GlAccountServiceListGlAccountsErrors, ThrowOnError> => (options.client ?? client).get<GlAccountServiceListGlAccountsResponses, GlAccountServiceListGlAccountsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/glAccounts',
    ...options
});

/**
 * Creates one chart account
 *
 * Creates one chart account.
 */
export const glAccountServiceCreateGlAccount = <ThrowOnError extends boolean = false>(options: Options<GlAccountServiceCreateGlAccountData, ThrowOnError>): RequestResult<GlAccountServiceCreateGlAccountResponses, GlAccountServiceCreateGlAccountErrors, ThrowOnError> => (options.client ?? client).post<GlAccountServiceCreateGlAccountResponses, GlAccountServiceCreateGlAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/glAccounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one chart account
 *
 * Retrieves one chart account.
 */
export const glAccountServiceGetGlAccount = <ThrowOnError extends boolean = false>(options: Options<GlAccountServiceGetGlAccountData, ThrowOnError>): RequestResult<GlAccountServiceGetGlAccountResponses, GlAccountServiceGetGlAccountErrors, ThrowOnError> => (options.client ?? client).get<GlAccountServiceGetGlAccountResponses, GlAccountServiceGetGlAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/glAccounts/{glAccount}',
    ...options
});

/**
 * Disables one chart account
 *
 * Disables one chart account.
 */
export const glAccountServiceDisableGlAccount = <ThrowOnError extends boolean = false>(options: Options<GlAccountServiceDisableGlAccountData, ThrowOnError>): RequestResult<GlAccountServiceDisableGlAccountResponses, GlAccountServiceDisableGlAccountErrors, ThrowOnError> => (options.client ?? client).post<GlAccountServiceDisableGlAccountResponses, GlAccountServiceDisableGlAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/glAccounts/{glAccount}:disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists journals
 *
 * Lists journals.
 */
export const journalServiceListJournals = <ThrowOnError extends boolean = false>(options: Options<JournalServiceListJournalsData, ThrowOnError>): RequestResult<JournalServiceListJournalsResponses, JournalServiceListJournalsErrors, ThrowOnError> => (options.client ?? client).get<JournalServiceListJournalsResponses, JournalServiceListJournalsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/journalEntries',
    ...options
});

/**
 * Retrieves one journal
 *
 * Retrieves one journal.
 */
export const journalServiceGetJournal = <ThrowOnError extends boolean = false>(options: Options<JournalServiceGetJournalData, ThrowOnError>): RequestResult<JournalServiceGetJournalResponses, JournalServiceGetJournalErrors, ThrowOnError> => (options.client ?? client).get<JournalServiceGetJournalResponses, JournalServiceGetJournalErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/journalEntries/{journalEntry}',
    ...options
});

/**
 * Creates a Reversal-intent draft voucher
 *
 * Creates a Reversal-intent draft voucher.
 */
export const journalServiceReverseJournal = <ThrowOnError extends boolean = false>(options: Options<JournalServiceReverseJournalData, ThrowOnError>): RequestResult<JournalServiceReverseJournalResponses, JournalServiceReverseJournalErrors, ThrowOnError> => (options.client ?? client).post<JournalServiceReverseJournalResponses, JournalServiceReverseJournalErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/journalEntries/{journalEntry}:reverse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists periods
 *
 * Lists periods.
 */
export const periodServiceListPeriods = <ThrowOnError extends boolean = false>(options: Options<PeriodServiceListPeriodsData, ThrowOnError>): RequestResult<PeriodServiceListPeriodsResponses, PeriodServiceListPeriodsErrors, ThrowOnError> => (options.client ?? client).get<PeriodServiceListPeriodsResponses, PeriodServiceListPeriodsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/periods',
    ...options
});

/**
 * Retrieves one period
 *
 * Retrieves one period.
 */
export const periodServiceGetPeriod = <ThrowOnError extends boolean = false>(options: Options<PeriodServiceGetPeriodData, ThrowOnError>): RequestResult<PeriodServiceGetPeriodResponses, PeriodServiceGetPeriodErrors, ThrowOnError> => (options.client ?? client).get<PeriodServiceGetPeriodResponses, PeriodServiceGetPeriodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/periods/{period}',
    ...options
});

/**
 * Hard-closes one period
 *
 * Hard-closes one period.
 */
export const periodServiceHardClosePeriod = <ThrowOnError extends boolean = false>(options: Options<PeriodServiceHardClosePeriodData, ThrowOnError>): RequestResult<PeriodServiceHardClosePeriodResponses, PeriodServiceHardClosePeriodErrors, ThrowOnError> => (options.client ?? client).post<PeriodServiceHardClosePeriodResponses, PeriodServiceHardClosePeriodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/periods/{period}:hardClose',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reopens one period
 *
 * Reopens one period.
 */
export const periodServiceReopenPeriod = <ThrowOnError extends boolean = false>(options: Options<PeriodServiceReopenPeriodData, ThrowOnError>): RequestResult<PeriodServiceReopenPeriodResponses, PeriodServiceReopenPeriodErrors, ThrowOnError> => (options.client ?? client).post<PeriodServiceReopenPeriodResponses, PeriodServiceReopenPeriodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/periods/{period}:reopen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Runs the idempotent closing entries and soft-closes the period
 *
 * Runs the idempotent closing entries and soft-closes the period.
 */
export const periodServiceRunClosingEntries = <ThrowOnError extends boolean = false>(options: Options<PeriodServiceRunClosingEntriesData, ThrowOnError>): RequestResult<PeriodServiceRunClosingEntriesResponses, PeriodServiceRunClosingEntriesErrors, ThrowOnError> => (options.client ?? client).post<PeriodServiceRunClosingEntriesResponses, PeriodServiceRunClosingEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/periods/{period}:runClosingEntries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-closes one period
 *
 * Soft-closes one period.
 */
export const periodServiceSoftClosePeriod = <ThrowOnError extends boolean = false>(options: Options<PeriodServiceSoftClosePeriodData, ThrowOnError>): RequestResult<PeriodServiceSoftClosePeriodResponses, PeriodServiceSoftClosePeriodErrors, ThrowOnError> => (options.client ?? client).post<PeriodServiceSoftClosePeriodResponses, PeriodServiceSoftClosePeriodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/periods/{period}:softClose',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists vouchers
 *
 * Lists vouchers.
 */
export const voucherServiceListVouchers = <ThrowOnError extends boolean = false>(options: Options<VoucherServiceListVouchersData, ThrowOnError>): RequestResult<VoucherServiceListVouchersResponses, VoucherServiceListVouchersErrors, ThrowOnError> => (options.client ?? client).get<VoucherServiceListVouchersResponses, VoucherServiceListVouchersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/vouchers',
    ...options
});

/**
 * Creates a Draft voucher
 *
 * Creates a Draft voucher.
 */
export const voucherServiceCreateVoucher = <ThrowOnError extends boolean = false>(options: Options<VoucherServiceCreateVoucherData, ThrowOnError>): RequestResult<VoucherServiceCreateVoucherResponses, VoucherServiceCreateVoucherErrors, ThrowOnError> => (options.client ?? client).post<VoucherServiceCreateVoucherResponses, VoucherServiceCreateVoucherErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/vouchers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one voucher
 *
 * Retrieves one voucher.
 */
export const voucherServiceGetVoucher = <ThrowOnError extends boolean = false>(options: Options<VoucherServiceGetVoucherData, ThrowOnError>): RequestResult<VoucherServiceGetVoucherResponses, VoucherServiceGetVoucherErrors, ThrowOnError> => (options.client ?? client).get<VoucherServiceGetVoucherResponses, VoucherServiceGetVoucherErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/vouchers/{voucher}',
    ...options
});

/**
 * Approves and posts the journal entry
 *
 * Approves and posts the journal entry.
 */
export const voucherServiceApproveVoucher = <ThrowOnError extends boolean = false>(options: Options<VoucherServiceApproveVoucherData, ThrowOnError>): RequestResult<VoucherServiceApproveVoucherResponses, VoucherServiceApproveVoucherErrors, ThrowOnError> => (options.client ?? client).post<VoucherServiceApproveVoucherResponses, VoucherServiceApproveVoucherErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/vouchers/{voucher}:approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rejects with a bounded reason
 *
 * Rejects with a bounded reason.
 */
export const voucherServiceRejectVoucher = <ThrowOnError extends boolean = false>(options: Options<VoucherServiceRejectVoucherData, ThrowOnError>): RequestResult<VoucherServiceRejectVoucherResponses, VoucherServiceRejectVoucherErrors, ThrowOnError> => (options.client ?? client).post<VoucherServiceRejectVoucherResponses, VoucherServiceRejectVoucherErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/vouchers/{voucher}:reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submits for review
 *
 * Submits for review.
 */
export const voucherServiceSubmitVoucher = <ThrowOnError extends boolean = false>(options: Options<VoucherServiceSubmitVoucherData, ThrowOnError>): RequestResult<VoucherServiceSubmitVoucherResponses, VoucherServiceSubmitVoucherErrors, ThrowOnError> => (options.client ?? client).post<VoucherServiceSubmitVoucherResponses, VoucherServiceSubmitVoucherErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/vouchers/{voucher}:submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replaces the editable fields
 *
 * Replaces the editable fields.
 */
export const voucherServiceUpdateVoucherDraft = <ThrowOnError extends boolean = false>(options: Options<VoucherServiceUpdateVoucherDraftData, ThrowOnError>): RequestResult<VoucherServiceUpdateVoucherDraftResponses, VoucherServiceUpdateVoucherDraftErrors, ThrowOnError> => (options.client ?? client).post<VoucherServiceUpdateVoucherDraftResponses, VoucherServiceUpdateVoucherDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}/vouchers/{voucher}:updateDraft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivates one ledger
 *
 * Deactivates one ledger.
 */
export const ledgerServiceDeactivateLedger = <ThrowOnError extends boolean = false>(options: Options<LedgerServiceDeactivateLedgerData, ThrowOnError>): RequestResult<LedgerServiceDeactivateLedgerResponses, LedgerServiceDeactivateLedgerErrors, ThrowOnError> => (options.client ?? client).post<LedgerServiceDeactivateLedgerResponses, LedgerServiceDeactivateLedgerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:deactivate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Balance sheet with the net-income bridge
 *
 * Balance sheet with the net-income bridge.
 */
export const reportServiceGetBalanceSheet = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetBalanceSheetData, ThrowOnError>): RequestResult<ReportServiceGetBalanceSheetResponses, ReportServiceGetBalanceSheetErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetBalanceSheetResponses, ReportServiceGetBalanceSheetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getBalanceSheet',
    ...options
});

/**
 * Cash-flow statement from classified cash-side facts
 *
 * Cash-flow statement from classified cash-side facts.
 */
export const reportServiceGetCashFlowStatement = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetCashFlowStatementData, ThrowOnError>): RequestResult<ReportServiceGetCashFlowStatementResponses, ReportServiceGetCashFlowStatementErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetCashFlowStatementResponses, ReportServiceGetCashFlowStatementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getCashFlowStatement',
    ...options
});

/**
 * Detail-ledger line join for one range
 *
 * Detail-ledger line join for one range.
 */
export const reportServiceGetDetailLedger = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetDetailLedgerData, ThrowOnError>): RequestResult<ReportServiceGetDetailLedgerResponses, ReportServiceGetDetailLedgerErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetDetailLedgerResponses, ReportServiceGetDetailLedgerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getDetailLedger',
    ...options
});

/**
 * Equity-changes statement
 *
 * Equity-changes statement.
 */
export const reportServiceGetEquityChanges = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetEquityChangesData, ThrowOnError>): RequestResult<ReportServiceGetEquityChangesResponses, ReportServiceGetEquityChangesErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetEquityChangesResponses, ReportServiceGetEquityChangesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getEquityChanges',
    ...options
});

/**
 * General-ledger month rows
 *
 * General-ledger month rows.
 */
export const reportServiceGetGeneralLedger = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetGeneralLedgerData, ThrowOnError>): RequestResult<ReportServiceGetGeneralLedgerResponses, ReportServiceGetGeneralLedgerErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetGeneralLedgerResponses, ReportServiceGetGeneralLedgerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getGeneralLedger',
    ...options
});

/**
 * Income statement excluding Closing activity
 *
 * Income statement excluding Closing activity.
 */
export const reportServiceGetIncomeStatement = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetIncomeStatementData, ThrowOnError>): RequestResult<ReportServiceGetIncomeStatementResponses, ReportServiceGetIncomeStatementErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetIncomeStatementResponses, ReportServiceGetIncomeStatementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getIncomeStatement',
    ...options
});

/**
 * Standard-bridge facts from StandardBridge Adjustment journals
 *
 * Standard-bridge facts from StandardBridge Adjustment journals.
 */
export const reportServiceGetStandardBridge = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetStandardBridgeData, ThrowOnError>): RequestResult<ReportServiceGetStandardBridgeResponses, ReportServiceGetStandardBridgeErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetStandardBridgeResponses, ReportServiceGetStandardBridgeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getStandardBridge',
    ...options
});

/**
 * Trial balance over one range
 *
 * Trial balance over one range.
 */
export const reportServiceGetTrialBalance = <ThrowOnError extends boolean = false>(options: Options<ReportServiceGetTrialBalanceData, ThrowOnError>): RequestResult<ReportServiceGetTrialBalanceResponses, ReportServiceGetTrialBalanceErrors, ThrowOnError> => (options.client ?? client).get<ReportServiceGetTrialBalanceResponses, ReportServiceGetTrialBalanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:getTrialBalance',
    ...options
});

/**
 * Makes one ledger the standard default
 *
 * Makes one ledger the standard default.
 */
export const ledgerServiceSetDefaultLedger = <ThrowOnError extends boolean = false>(options: Options<LedgerServiceSetDefaultLedgerData, ThrowOnError>): RequestResult<LedgerServiceSetDefaultLedgerResponses, LedgerServiceSetDefaultLedgerErrors, ThrowOnError> => (options.client ?? client).post<LedgerServiceSetDefaultLedgerResponses, LedgerServiceSetDefaultLedgerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/ledgers/{ledger}:setDefault',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists parked events with filters
 *
 * Lists parked events with filters.
 */
export const parkedEventServiceListParkedEvents = <ThrowOnError extends boolean = false>(options?: Options<ParkedEventServiceListParkedEventsData, ThrowOnError>): RequestResult<ParkedEventServiceListParkedEventsResponses, ParkedEventServiceListParkedEventsErrors, ThrowOnError> => (options?.client ?? client).get<ParkedEventServiceListParkedEventsResponses, ParkedEventServiceListParkedEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/parkedEvents',
    ...options
});

/**
 * Rejects one parked disposition terminally
 *
 * Rejects one parked disposition terminally.
 */
export const parkedEventServiceRejectParkedEvent = <ThrowOnError extends boolean = false>(options: Options<ParkedEventServiceRejectParkedEventData, ThrowOnError>): RequestResult<ParkedEventServiceRejectParkedEventResponses, ParkedEventServiceRejectParkedEventErrors, ThrowOnError> => (options.client ?? client).post<ParkedEventServiceRejectParkedEventResponses, ParkedEventServiceRejectParkedEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/parkedEvents/{parkedEvent}:reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retries one parked disposition
 *
 * Retries one parked disposition.
 */
export const parkedEventServiceRetryParkedEvent = <ThrowOnError extends boolean = false>(options: Options<ParkedEventServiceRetryParkedEventData, ThrowOnError>): RequestResult<ParkedEventServiceRetryParkedEventResponses, ParkedEventServiceRetryParkedEventErrors, ThrowOnError> => (options.client ?? client).post<ParkedEventServiceRetryParkedEventResponses, ParkedEventServiceRetryParkedEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/parkedEvents/{parkedEvent}:retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists rules, optionally one standard's
 *
 * Lists rules, optionally one standard's.
 */
export const postingRuleServiceListPostingRules = <ThrowOnError extends boolean = false>(options?: Options<PostingRuleServiceListPostingRulesData, ThrowOnError>): RequestResult<PostingRuleServiceListPostingRulesResponses, PostingRuleServiceListPostingRulesErrors, ThrowOnError> => (options?.client ?? client).get<PostingRuleServiceListPostingRulesResponses, PostingRuleServiceListPostingRulesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/postingRules',
    ...options
});

/**
 * Creates a Draft rule
 *
 * Creates a Draft rule.
 */
export const postingRuleServiceCreatePostingRule = <ThrowOnError extends boolean = false>(options: Options<PostingRuleServiceCreatePostingRuleData, ThrowOnError>): RequestResult<PostingRuleServiceCreatePostingRuleResponses, PostingRuleServiceCreatePostingRuleErrors, ThrowOnError> => (options.client ?? client).post<PostingRuleServiceCreatePostingRuleResponses, PostingRuleServiceCreatePostingRuleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/postingRules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one rule
 *
 * Retrieves one rule.
 */
export const postingRuleServiceGetPostingRule = <ThrowOnError extends boolean = false>(options: Options<PostingRuleServiceGetPostingRuleData, ThrowOnError>): RequestResult<PostingRuleServiceGetPostingRuleResponses, PostingRuleServiceGetPostingRuleErrors, ThrowOnError> => (options.client ?? client).get<PostingRuleServiceGetPostingRuleResponses, PostingRuleServiceGetPostingRuleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/postingRules/{postingRule}',
    ...options
});

/**
 * Lists immutable versions
 *
 * Lists immutable versions.
 */
export const postingRuleServiceListPostingRuleVersions = <ThrowOnError extends boolean = false>(options: Options<PostingRuleServiceListPostingRuleVersionsData, ThrowOnError>): RequestResult<PostingRuleServiceListPostingRuleVersionsResponses, PostingRuleServiceListPostingRuleVersionsErrors, ThrowOnError> => (options.client ?? client).get<PostingRuleServiceListPostingRuleVersionsResponses, PostingRuleServiceListPostingRuleVersionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/postingRules/{postingRule}/versions',
    ...options
});

/**
 * Activates as a new version
 *
 * Activates as a new version.
 */
export const postingRuleServiceActivatePostingRule = <ThrowOnError extends boolean = false>(options: Options<PostingRuleServiceActivatePostingRuleData, ThrowOnError>): RequestResult<PostingRuleServiceActivatePostingRuleResponses, PostingRuleServiceActivatePostingRuleErrors, ThrowOnError> => (options.client ?? client).post<PostingRuleServiceActivatePostingRuleResponses, PostingRuleServiceActivatePostingRuleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/postingRules/{postingRule}:activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retires one rule
 *
 * Retires one rule.
 */
export const postingRuleServiceRetirePostingRule = <ThrowOnError extends boolean = false>(options: Options<PostingRuleServiceRetirePostingRuleData, ThrowOnError>): RequestResult<PostingRuleServiceRetirePostingRuleResponses, PostingRuleServiceRetirePostingRuleErrors, ThrowOnError> => (options.client ?? client).post<PostingRuleServiceRetirePostingRuleResponses, PostingRuleServiceRetirePostingRuleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/postingRules/{postingRule}:retire',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists projects
 *
 * Lists projects.
 */
export const auxiliaryServiceListProjects = <ThrowOnError extends boolean = false>(options?: Options<AuxiliaryServiceListProjectsData, ThrowOnError>): RequestResult<AuxiliaryServiceListProjectsResponses, AuxiliaryServiceListProjectsErrors, ThrowOnError> => (options?.client ?? client).get<AuxiliaryServiceListProjectsResponses, AuxiliaryServiceListProjectsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/projects',
    ...options
});

/**
 * Creates one project
 *
 * Creates one project.
 */
export const auxiliaryServiceCreateProject = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceCreateProjectData, ThrowOnError>): RequestResult<AuxiliaryServiceCreateProjectResponses, AuxiliaryServiceCreateProjectErrors, ThrowOnError> => (options.client ?? client).post<AuxiliaryServiceCreateProjectResponses, AuxiliaryServiceCreateProjectErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves one project
 *
 * Retrieves one project.
 */
export const auxiliaryServiceGetProject = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceGetProjectData, ThrowOnError>): RequestResult<AuxiliaryServiceGetProjectResponses, AuxiliaryServiceGetProjectErrors, ThrowOnError> => (options.client ?? client).get<AuxiliaryServiceGetProjectResponses, AuxiliaryServiceGetProjectErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/projects/{project}',
    ...options
});

/**
 * Disables one project
 *
 * Disables one project.
 */
export const auxiliaryServiceDisableProject = <ThrowOnError extends boolean = false>(options: Options<AuxiliaryServiceDisableProjectData, ThrowOnError>): RequestResult<AuxiliaryServiceDisableProjectResponses, AuxiliaryServiceDisableProjectErrors, ThrowOnError> => (options.client ?? client).post<AuxiliaryServiceDisableProjectResponses, AuxiliaryServiceDisableProjectErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounting/projects/{project}:disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists after-sales cases with filter and keyset order (AIP-132/158)
 *
 * Lists after-sales cases with filter and keyset order (AIP-132/158).
 */
export const afterSalesServiceListAftersalesCases = <ThrowOnError extends boolean = false>(options?: Options<AfterSalesServiceListAftersalesCasesData, ThrowOnError>): RequestResult<AfterSalesServiceListAftersalesCasesResponses, AfterSalesServiceListAftersalesCasesErrors, ThrowOnError> => (options?.client ?? client).get<AfterSalesServiceListAftersalesCasesResponses, AfterSalesServiceListAftersalesCasesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases',
    ...options
});

/**
 * Buyer creates an after-sales case (AIP-133)
 *
 * Buyer creates an after-sales case (AIP-133).
 */
export const afterSalesServiceCreateAftersalesCase = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceCreateAftersalesCaseData, ThrowOnError>): RequestResult<AfterSalesServiceCreateAftersalesCaseResponses, AfterSalesServiceCreateAftersalesCaseErrors, ThrowOnError> => (options.client ?? client).post<AfterSalesServiceCreateAftersalesCaseResponses, AfterSalesServiceCreateAftersalesCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves an after-sales case by resource name (AIP-131)
 *
 * Retrieves an after-sales case by resource name (AIP-131).
 */
export const afterSalesServiceGetAftersalesCase = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceGetAftersalesCaseData, ThrowOnError>): RequestResult<AfterSalesServiceGetAftersalesCaseResponses, AfterSalesServiceGetAftersalesCaseErrors, ThrowOnError> => (options.client ?? client).get<AfterSalesServiceGetAftersalesCaseResponses, AfterSalesServiceGetAftersalesCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases/{aftersalesCase}',
    ...options
});

/**
 * Merchant approves an after-sales case (AIP-136)
 *
 * Merchant approves an after-sales case (AIP-136).
 */
export const afterSalesServiceApproveCase = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceApproveCaseData, ThrowOnError>): RequestResult<AfterSalesServiceApproveCaseResponses, AfterSalesServiceApproveCaseErrors, ThrowOnError> => (options.client ?? client).post<AfterSalesServiceApproveCaseResponses, AfterSalesServiceApproveCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases/{aftersalesCase}:approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Escalates the case to platform customer support (AIP-136)
 *
 * Escalates the case to platform customer support (AIP-136).
 */
export const afterSalesServiceEscalateCase = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceEscalateCaseData, ThrowOnError>): RequestResult<AfterSalesServiceEscalateCaseResponses, AfterSalesServiceEscalateCaseErrors, ThrowOnError> => (options.client ?? client).post<AfterSalesServiceEscalateCaseResponses, AfterSalesServiceEscalateCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases/{aftersalesCase}:escalate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Warehouse staff records the returned item quality inspection (AIP-136)
 *
 * Warehouse staff records the returned item quality inspection (AIP-136).
 */
export const afterSalesServiceRecordInspection = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceRecordInspectionData, ThrowOnError>): RequestResult<AfterSalesServiceRecordInspectionResponses, AfterSalesServiceRecordInspectionErrors, ThrowOnError> => (options.client ?? client).post<AfterSalesServiceRecordInspectionResponses, AfterSalesServiceRecordInspectionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases/{aftersalesCase}:recordInspection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Merchant rejects an after-sales case (AIP-136)
 *
 * Merchant rejects an after-sales case (AIP-136).
 */
export const afterSalesServiceRejectCase = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceRejectCaseData, ThrowOnError>): RequestResult<AfterSalesServiceRejectCaseResponses, AfterSalesServiceRejectCaseErrors, ThrowOnError> => (options.client ?? client).post<AfterSalesServiceRejectCaseResponses, AfterSalesServiceRejectCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases/{aftersalesCase}:reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Staff or system requests refund execution from Pay (AIP-136)
 *
 * Staff or system requests refund execution from Pay (AIP-136).
 */
export const afterSalesServiceRequestRefund = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceRequestRefundData, ThrowOnError>): RequestResult<AfterSalesServiceRequestRefundResponses, AfterSalesServiceRequestRefundErrors, ThrowOnError> => (options.client ?? client).post<AfterSalesServiceRequestRefundResponses, AfterSalesServiceRequestRefundErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases/{aftersalesCase}:requestRefund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Buyer submits the return tracking number for shipment (AIP-136)
 *
 * Buyer submits the return tracking number for shipment (AIP-136).
 */
export const afterSalesServiceSubmitReturnShipment = <ThrowOnError extends boolean = false>(options: Options<AfterSalesServiceSubmitReturnShipmentData, ThrowOnError>): RequestResult<AfterSalesServiceSubmitReturnShipmentResponses, AfterSalesServiceSubmitReturnShipmentErrors, ThrowOnError> => (options.client ?? client).post<AfterSalesServiceSubmitReturnShipmentResponses, AfterSalesServiceSubmitReturnShipmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/aftersales/aftersalesCases/{aftersalesCase}:submitReturnShipment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the tenant's invoices (AIP-132/158)
 *
 * Lists the tenant's invoices (AIP-132/158).
 */
export const billingServiceListInvoices = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListInvoicesData, ThrowOnError>): RequestResult<BillingServiceListInvoicesResponses, BillingServiceListInvoicesErrors, ThrowOnError> => (options?.client ?? client).get<BillingServiceListInvoicesResponses, BillingServiceListInvoicesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/invoices',
    ...options
});

/**
 * Reads an invoice by resource name (AIP-131)
 *
 * Reads an invoice by resource name (AIP-131).
 */
export const billingServiceGetInvoice = <ThrowOnError extends boolean = false>(options: Options<BillingServiceGetInvoiceData, ThrowOnError>): RequestResult<BillingServiceGetInvoiceResponses, BillingServiceGetInvoiceErrors, ThrowOnError> => (options.client ?? client).get<BillingServiceGetInvoiceResponses, BillingServiceGetInvoiceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/invoices/{invoice}',
    ...options
});

/**
 * Retries payment for a past-due invoice (AIP-136)
 *
 * Retries payment for a past-due invoice (AIP-136).
 */
export const billingServiceRetryInvoicePayment = <ThrowOnError extends boolean = false>(options: Options<BillingServiceRetryInvoicePaymentData, ThrowOnError>): RequestResult<BillingServiceRetryInvoicePaymentResponses, BillingServiceRetryInvoicePaymentErrors, ThrowOnError> => (options.client ?? client).post<BillingServiceRetryInvoicePaymentResponses, BillingServiceRetryInvoicePaymentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/invoices/{invoice}:retryPayment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the tenant's subscriptions in creation order (AIP-132/158)
 *
 * Lists the tenant's subscriptions in creation order (AIP-132/158).
 */
export const billingServiceListSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListSubscriptionsData, ThrowOnError>): RequestResult<BillingServiceListSubscriptionsResponses, BillingServiceListSubscriptionsErrors, ThrowOnError> => (options?.client ?? client).get<BillingServiceListSubscriptionsResponses, BillingServiceListSubscriptionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/subscriptions',
    ...options
});

/**
 * Creates a new SaaS subscription for a tenant (AIP-133)
 *
 * Creates a new SaaS subscription for a tenant (AIP-133).
 */
export const billingServiceCreateSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCreateSubscriptionData, ThrowOnError>): RequestResult<BillingServiceCreateSubscriptionResponses, BillingServiceCreateSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<BillingServiceCreateSubscriptionResponses, BillingServiceCreateSubscriptionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reads a subscription by resource name (AIP-131)
 *
 * Reads a subscription by resource name (AIP-131).
 */
export const billingServiceGetSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceGetSubscriptionData, ThrowOnError>): RequestResult<BillingServiceGetSubscriptionResponses, BillingServiceGetSubscriptionErrors, ThrowOnError> => (options.client ?? client).get<BillingServiceGetSubscriptionResponses, BillingServiceGetSubscriptionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/subscriptions/{subscription}',
    ...options
});

/**
 * Cancels the subscription at period end or immediately (AIP-136)
 *
 * Cancels the subscription at period end or immediately (AIP-136).
 */
export const billingServiceCancelSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCancelSubscriptionData, ThrowOnError>): RequestResult<BillingServiceCancelSubscriptionResponses, BillingServiceCancelSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<BillingServiceCancelSubscriptionResponses, BillingServiceCancelSubscriptionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/subscriptions/{subscription}:cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upgrades or downgrades the subscription plan (AIP-136)
 *
 * Upgrades or downgrades the subscription plan (AIP-136).
 */
export const billingServiceChangeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceChangeSubscriptionData, ThrowOnError>): RequestResult<BillingServiceChangeSubscriptionResponses, BillingServiceChangeSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<BillingServiceChangeSubscriptionResponses, BillingServiceChangeSubscriptionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/subscriptions/{subscription}:change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingests one metered usage record (workload/telemetry only, AIP-136)
 *
 * Ingests one metered usage record (workload/telemetry only, AIP-136).
 */
export const billingServiceRecordUsage = <ThrowOnError extends boolean = false>(options: Options<BillingServiceRecordUsageData, ThrowOnError>): RequestResult<BillingServiceRecordUsageResponses, BillingServiceRecordUsageErrors, ThrowOnError> => (options.client ?? client).post<BillingServiceRecordUsageResponses, BillingServiceRecordUsageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/usage:record',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's carts (`cart:read`); `filter` supports exact
 *
 * Lists the caller tenant's carts (`cart:read`); `filter` supports exact
 * `member_id = "<uuid>"` matches.
 */
export const cartServiceListCarts = <ThrowOnError extends boolean = false>(options?: Options<CartServiceListCartsData, ThrowOnError>): RequestResult<CartServiceListCartsResponses, CartServiceListCartsErrors, ThrowOnError> => (options?.client ?? client).get<CartServiceListCartsResponses, CartServiceListCartsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts',
    ...options
});

/**
 * Reads one cart; cross-tenant and cross-owner reads are NOT_FOUND
 *
 * Reads one cart; cross-tenant and cross-owner reads are NOT_FOUND
 * (`cart:read`).
 */
export const cartServiceGetCart = <ThrowOnError extends boolean = false>(options: Options<CartServiceGetCartData, ThrowOnError>): RequestResult<CartServiceGetCartResponses, CartServiceGetCartErrors, ThrowOnError> => (options.client ?? client).get<CartServiceGetCartResponses, CartServiceGetCartErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts/{cart}',
    ...options
});

/**
 * Adjusts quantity and selection of one line (`cart:write`, CAS)
 *
 * Adjusts quantity and selection of one line (`cart:write`, CAS).
 * AIP-136 custom method: not an AIP-134 Update of a Line resource.
 */
export const cartServiceAdjustLine = <ThrowOnError extends boolean = false>(options: Options<CartServiceAdjustLineData, ThrowOnError>): RequestResult<CartServiceAdjustLineResponses, CartServiceAdjustLineErrors, ThrowOnError> => (options.client ?? client).post<CartServiceAdjustLineResponses, CartServiceAdjustLineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts/{cart}/lines/{line}:adjust',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Drops one line (`cart:write`, CAS)
 *
 * Drops one line (`cart:write`, CAS).
 * AIP-136 custom method: not an AIP-135 Delete of a Line resource.
 */
export const cartServiceDropLine = <ThrowOnError extends boolean = false>(options: Options<CartServiceDropLineData, ThrowOnError>): RequestResult<CartServiceDropLineResponses, CartServiceDropLineErrors, ThrowOnError> => (options.client ?? client).post<CartServiceDropLineResponses, CartServiceDropLineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts/{cart}/lines/{line}:drop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Records which frozen handoff Trade accepted (`cart:handoff.write`, CAS)
 *
 * Records which frozen handoff Trade accepted (`cart:handoff.write`, CAS).
 */
export const cartServiceAcknowledgeCheckout = <ThrowOnError extends boolean = false>(options: Options<CartServiceAcknowledgeCheckoutData, ThrowOnError>): RequestResult<CartServiceAcknowledgeCheckoutResponses, CartServiceAcknowledgeCheckoutErrors, ThrowOnError> => (options.client ?? client).post<CartServiceAcknowledgeCheckoutResponses, CartServiceAcknowledgeCheckoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts:acknowledgeCheckout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Adds a line; adding the same offer updates quantity with checked
 *
 * Adds a line; adding the same offer updates quantity with checked
 * arithmetic (`cart:write`). Carts are created lazily: when the named cart
 * does not exist, the service creates it with a client-determined id
 * (AIP-133), the caller-derived owner and the `currency_code` display hint,
 * then adds the line. The cart owner always derives from the verified
 * caller principal; authority fields never ride the request body.
 */
export const cartServiceAddLine = <ThrowOnError extends boolean = false>(options: Options<CartServiceAddLineData, ThrowOnError>): RequestResult<CartServiceAddLineResponses, CartServiceAddLineErrors, ThrowOnError> => (options.client ?? client).post<CartServiceAddLineResponses, CartServiceAddLineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts:addLine',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Merges a guest cart into a member cart (`cart:write`)
 *
 * Merges a guest cart into a member cart (`cart:write`).
 */
export const cartServiceMergeGuestCart = <ThrowOnError extends boolean = false>(options: Options<CartServiceMergeGuestCartData, ThrowOnError>): RequestResult<CartServiceMergeGuestCartResponses, CartServiceMergeGuestCartErrors, ThrowOnError> => (options.client ?? client).post<CartServiceMergeGuestCartResponses, CartServiceMergeGuestCartErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts:mergeGuestCart',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Freezes selected lines into a single-use handoff (`cart:handoff`);
 *
 * Freezes selected lines into a single-use handoff (`cart:handoff`);
 * rejects zero selected lines.
 */
export const cartServiceOpenCheckoutHandoff = <ThrowOnError extends boolean = false>(options: Options<CartServiceOpenCheckoutHandoffData, ThrowOnError>): RequestResult<CartServiceOpenCheckoutHandoffResponses, CartServiceOpenCheckoutHandoffErrors, ThrowOnError> => (options.client ?? client).post<CartServiceOpenCheckoutHandoffResponses, CartServiceOpenCheckoutHandoffErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts:openCheckoutHandoff',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Selects lines for checkout; all other lines are deselected
 *
 * Selects lines for checkout; all other lines are deselected
 * (`cart:write`, CAS).
 */
export const cartServiceSelectLines = <ThrowOnError extends boolean = false>(options: Options<CartServiceSelectLinesData, ThrowOnError>): RequestResult<CartServiceSelectLinesResponses, CartServiceSelectLinesErrors, ThrowOnError> => (options.client ?? client).post<CartServiceSelectLinesResponses, CartServiceSelectLinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/carts:selectLines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Workload-only: Trade consumes the handoff exactly once by token
 *
 * Workload-only: Trade consumes the handoff exactly once by token
 * (`cart:handoff.read`).
 */
export const cartServiceConsumeCheckoutHandoff = <ThrowOnError extends boolean = false>(options: Options<CartServiceConsumeCheckoutHandoffData, ThrowOnError>): RequestResult<CartServiceConsumeCheckoutHandoffResponses, CartServiceConsumeCheckoutHandoffErrors, ThrowOnError> => (options.client ?? client).post<CartServiceConsumeCheckoutHandoffResponses, CartServiceConsumeCheckoutHandoffErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cart/checkoutHandoffs:consumeCheckoutHandoff',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Records an operator adjustment with maker-checker
 *
 * Records an operator adjustment with maker-checker
 * (`clearing:adjust`).
 */
export const clearingServiceRecordAdjustment = <ThrowOnError extends boolean = false>(options: Options<ClearingServiceRecordAdjustmentData, ThrowOnError>): RequestResult<ClearingServiceRecordAdjustmentResponses, ClearingServiceRecordAdjustmentErrors, ThrowOnError> => (options.client ?? client).post<ClearingServiceRecordAdjustmentResponses, ClearingServiceRecordAdjustmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/adjustments:recordAdjustment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's batches in creation order, optionally
 *
 * Lists the caller tenant's batches in creation order, optionally
 * filtered by source payment (`clearing:read`).
 */
export const clearingServiceListClearingBatches = <ThrowOnError extends boolean = false>(options?: Options<ClearingServiceListClearingBatchesData, ThrowOnError>): RequestResult<ClearingServiceListClearingBatchesResponses, ClearingServiceListClearingBatchesErrors, ThrowOnError> => (options?.client ?? client).get<ClearingServiceListClearingBatchesResponses, ClearingServiceListClearingBatchesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingBatches',
    ...options
});

/**
 * Retrieves user notification preferences (AIP-131)
 *
 * Retrieves user notification preferences (AIP-131).
 */
export const notificationServiceGetNotificationPreference = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceGetNotificationPreferenceData, ThrowOnError>): RequestResult<NotificationServiceGetNotificationPreferenceResponses, NotificationServiceGetNotificationPreferenceErrors, ThrowOnError> => (options.client ?? client).get<NotificationServiceGetNotificationPreferenceResponses, NotificationServiceGetNotificationPreferenceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user}/notificationPreferences',
    ...options
});

/**
 * Updates user notification preferences (AIP-134)
 *
 * Updates user notification preferences (AIP-134).
 */
export const notificationServiceUpdateNotificationPreference = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceUpdateNotificationPreferenceData, ThrowOnError>): RequestResult<NotificationServiceUpdateNotificationPreferenceResponses, NotificationServiceUpdateNotificationPreferenceErrors, ThrowOnError> => (options.client ?? client).patch<NotificationServiceUpdateNotificationPreferenceResponses, NotificationServiceUpdateNotificationPreferenceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user}/notificationPreferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reads one batch (`clearing:read`)
 *
 * Reads one batch (`clearing:read`).
 */
export const clearingServiceGetClearingBatch = <ThrowOnError extends boolean = false>(options: Options<ClearingServiceGetClearingBatchData, ThrowOnError>): RequestResult<ClearingServiceGetClearingBatchResponses, ClearingServiceGetClearingBatchErrors, ThrowOnError> => (options.client ?? client).get<ClearingServiceGetClearingBatchResponses, ClearingServiceGetClearingBatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingBatches/{clearingBatch}',
    ...options
});

/**
 * Lists the allocation lines of one batch (`clearing:read`)
 *
 * Lists the allocation lines of one batch (`clearing:read`).
 */
export const clearingServiceListClearingAllocations = <ThrowOnError extends boolean = false>(options: Options<ClearingServiceListClearingAllocationsData, ThrowOnError>): RequestResult<ClearingServiceListClearingAllocationsResponses, ClearingServiceListClearingAllocationsErrors, ThrowOnError> => (options.client ?? client).get<ClearingServiceListClearingAllocationsResponses, ClearingServiceListClearingAllocationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingBatches/{clearingBatch}/clearingAllocations',
    ...options
});

/**
 * Reads one allocation line (`clearing:read`)
 *
 * Reads one allocation line (`clearing:read`).
 */
export const clearingServiceGetClearingAllocation = <ThrowOnError extends boolean = false>(options: Options<ClearingServiceGetClearingAllocationData, ThrowOnError>): RequestResult<ClearingServiceGetClearingAllocationResponses, ClearingServiceGetClearingAllocationErrors, ThrowOnError> => (options.client ?? client).get<ClearingServiceGetClearingAllocationResponses, ClearingServiceGetClearingAllocationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingBatches/{clearingBatch}/clearingAllocations/{clearingAllocation}',
    ...options
});

/**
 * Records the Account posting of a calculated batch (`clearing:post`)
 *
 * Records the Account posting of a calculated batch (`clearing:post`).
 */
export const clearingServiceApplyPosting = <ThrowOnError extends boolean = false>(options: Options<ClearingServiceApplyPostingData, ThrowOnError>): RequestResult<ClearingServiceApplyPostingResponses, ClearingServiceApplyPostingErrors, ThrowOnError> => (options.client ?? client).post<ClearingServiceApplyPostingResponses, ClearingServiceApplyPostingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingBatches/{clearingBatch}:applyPosting',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Calculates a batch from immutable source facts
 *
 * Calculates a batch from immutable source facts
 * (`clearing:calculate`).
 */
export const clearingServiceCalculateClearing = <ThrowOnError extends boolean = false>(options: Options<ClearingServiceCalculateClearingData, ThrowOnError>): RequestResult<ClearingServiceCalculateClearingResponses, ClearingServiceCalculateClearingErrors, ThrowOnError> => (options.client ?? client).post<ClearingServiceCalculateClearingResponses, ClearingServiceCalculateClearingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingBatches:calculateClearing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publishes a frozen rule version (`clearing:calculate`)
 *
 * Publishes a frozen rule version (`clearing:calculate`).
 */
export const clearingServicePublishRuleVersion = <ThrowOnError extends boolean = false>(options: Options<ClearingServicePublishRuleVersionData, ThrowOnError>): RequestResult<ClearingServicePublishRuleVersionResponses, ClearingServicePublishRuleVersionErrors, ThrowOnError> => (options.client ?? client).post<ClearingServicePublishRuleVersionResponses, ClearingServicePublishRuleVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingRuleVersions:publishRuleVersion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists fulfillment orders (`fulfillment:order.write`); `filter` supports
 *
 * Lists fulfillment orders (`fulfillment:order.write`); `filter` supports
 * exact `source_order_id = "<uuid>"` matches.
 */
export const fulfillmentServiceListFulfillmentOrders = <ThrowOnError extends boolean = false>(options?: Options<FulfillmentServiceListFulfillmentOrdersData, ThrowOnError>): RequestResult<FulfillmentServiceListFulfillmentOrdersResponses, FulfillmentServiceListFulfillmentOrdersErrors, ThrowOnError> => (options?.client ?? client).get<FulfillmentServiceListFulfillmentOrdersResponses, FulfillmentServiceListFulfillmentOrdersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders',
    ...options
});

/**
 * Reads one fulfillment order (`fulfillment:order.write`)
 *
 * Reads one fulfillment order (`fulfillment:order.write`).
 */
export const fulfillmentServiceGetFulfillmentOrder = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceGetFulfillmentOrderData, ThrowOnError>): RequestResult<FulfillmentServiceGetFulfillmentOrderResponses, FulfillmentServiceGetFulfillmentOrderErrors, ThrowOnError> => (options.client ?? client).get<FulfillmentServiceGetFulfillmentOrderResponses, FulfillmentServiceGetFulfillmentOrderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders/{fulfillmentOrder}',
    ...options
});

/**
 * Commits an allocation revision (`fulfillment:order.write`)
 *
 * Commits an allocation revision (`fulfillment:order.write`).
 */
export const fulfillmentServiceAllocateFulfillment = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceAllocateFulfillmentData, ThrowOnError>): RequestResult<FulfillmentServiceAllocateFulfillmentResponses, FulfillmentServiceAllocateFulfillmentErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceAllocateFulfillmentResponses, FulfillmentServiceAllocateFulfillmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders/{fulfillmentOrder}:allocateFulfillment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancels before handoff (`fulfillment:order.write`)
 *
 * Cancels before handoff (`fulfillment:order.write`).
 */
export const fulfillmentServiceCancelFulfillment = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceCancelFulfillmentData, ThrowOnError>): RequestResult<FulfillmentServiceCancelFulfillmentResponses, FulfillmentServiceCancelFulfillmentErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceCancelFulfillmentResponses, FulfillmentServiceCancelFulfillmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders/{fulfillmentOrder}:cancelFulfillment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hands packages to Logistics (`fulfillment:work.execute`)
 *
 * Hands packages to Logistics (`fulfillment:work.execute`).
 */
export const fulfillmentServiceHandoffPackage = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceHandoffPackageData, ThrowOnError>): RequestResult<FulfillmentServiceHandoffPackageResponses, FulfillmentServiceHandoffPackageErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceHandoffPackageResponses, FulfillmentServiceHandoffPackageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders/{fulfillmentOrder}:handoffPackage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Marks work packed with the frozen package plan (`fulfillment:work.execute`)
 *
 * Marks work packed with the frozen package plan (`fulfillment:work.execute`).
 */
export const fulfillmentServiceMarkPacked = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceMarkPackedData, ThrowOnError>): RequestResult<FulfillmentServiceMarkPackedResponses, FulfillmentServiceMarkPackedErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceMarkPackedResponses, FulfillmentServiceMarkPackedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders/{fulfillmentOrder}:markPacked',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Starts picking at a location (`fulfillment:work.execute`)
 *
 * Starts picking at a location (`fulfillment:work.execute`).
 */
export const fulfillmentServiceStartPicking = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceStartPickingData, ThrowOnError>): RequestResult<FulfillmentServiceStartPickingResponses, FulfillmentServiceStartPickingErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceStartPickingResponses, FulfillmentServiceStartPickingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders/{fulfillmentOrder}:startPicking',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Opens a fulfillment order from an accepted Order; idempotent by source key
 *
 * Opens a fulfillment order from an accepted Order; idempotent by source key
 * (`fulfillment:order.write`).
 */
export const fulfillmentServiceOpenFulfillmentOrder = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceOpenFulfillmentOrderData, ThrowOnError>): RequestResult<FulfillmentServiceOpenFulfillmentOrderResponses, FulfillmentServiceOpenFulfillmentOrderErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceOpenFulfillmentOrderResponses, FulfillmentServiceOpenFulfillmentOrderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentOrders:openFulfillmentOrder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quotes a bounded delivery promise for Trade (`fulfillment:promise.read`)
 *
 * Quotes a bounded delivery promise for Trade (`fulfillment:promise.read`).
 */
export const fulfillmentServiceQuotePromise = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceQuotePromiseData, ThrowOnError>): RequestResult<FulfillmentServiceQuotePromiseResponses, FulfillmentServiceQuotePromiseErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceQuotePromiseResponses, FulfillmentServiceQuotePromiseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/fulfillmentPromises:quotePromise',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Receives a return with an inspection disposition
 *
 * Receives a return with an inspection disposition
 * (`fulfillment:return.receive`).
 */
export const fulfillmentServiceRecordReturnReceipt = <ThrowOnError extends boolean = false>(options: Options<FulfillmentServiceRecordReturnReceiptData, ThrowOnError>): RequestResult<FulfillmentServiceRecordReturnReceiptResponses, FulfillmentServiceRecordReturnReceiptErrors, ThrowOnError> => (options.client ?? client).post<FulfillmentServiceRecordReturnReceiptResponses, FulfillmentServiceRecordReturnReceiptErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fulfillment/returnReceipts:recordReturnReceipt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists reservations (`inventory:reserve`); `filter` supports exact
 *
 * Lists reservations (`inventory:reserve`); `filter` supports exact
 * `source_id = "<key>"` matches for unknown-outcome reconciliation.
 */
export const inventoryServiceListReservations = <ThrowOnError extends boolean = false>(options?: Options<InventoryServiceListReservationsData, ThrowOnError>): RequestResult<InventoryServiceListReservationsResponses, InventoryServiceListReservationsErrors, ThrowOnError> => (options?.client ?? client).get<InventoryServiceListReservationsResponses, InventoryServiceListReservationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/reservations',
    ...options
});

/**
 * Reads one reservation (`inventory:reserve`)
 *
 * Reads one reservation (`inventory:reserve`).
 */
export const inventoryServiceGetReservation = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceGetReservationData, ThrowOnError>): RequestResult<InventoryServiceGetReservationResponses, InventoryServiceGetReservationErrors, ThrowOnError> => (options.client ?? client).get<InventoryServiceGetReservationResponses, InventoryServiceGetReservationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/reservations/{reservation}',
    ...options
});

/**
 * Terminal commit reducing on-hand and reserved (`inventory:commit`, CAS)
 *
 * Terminal commit reducing on-hand and reserved (`inventory:commit`, CAS).
 */
export const inventoryServiceCommitReservation = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceCommitReservationData, ThrowOnError>): RequestResult<InventoryServiceCommitReservationResponses, InventoryServiceCommitReservationErrors, ThrowOnError> => (options.client ?? client).post<InventoryServiceCommitReservationResponses, InventoryServiceCommitReservationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/reservations/{reservation}:commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Terminal release returning held stock (`inventory:reserve`, CAS)
 *
 * Terminal release returning held stock (`inventory:reserve`, CAS).
 */
export const inventoryServiceReleaseReservation = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceReleaseReservationData, ThrowOnError>): RequestResult<InventoryServiceReleaseReservationResponses, InventoryServiceReleaseReservationErrors, ThrowOnError> => (options.client ?? client).post<InventoryServiceReleaseReservationResponses, InventoryServiceReleaseReservationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/reservations/{reservation}:release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Holds stock under a Trade source key with canonical UUID-order locking
 *
 * Holds stock under a Trade source key with canonical UUID-order locking
 * (`inventory:reserve`); all lines commit or none do.
 */
export const inventoryServiceReserveStock = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceReserveStockData, ThrowOnError>): RequestResult<InventoryServiceReserveStockResponses, InventoryServiceReserveStockErrors, ThrowOnError> => (options.client ?? client).post<InventoryServiceReserveStockResponses, InventoryServiceReserveStockErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/reservations:reserveStock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists stock items (`inventory:read`); `filter` supports exact
 *
 * Lists stock items (`inventory:read`); `filter` supports exact
 * `owner`, `sku` and `location` matches combined with `AND`.
 */
export const inventoryServiceListStockItems = <ThrowOnError extends boolean = false>(options?: Options<InventoryServiceListStockItemsData, ThrowOnError>): RequestResult<InventoryServiceListStockItemsResponses, InventoryServiceListStockItemsErrors, ThrowOnError> => (options?.client ?? client).get<InventoryServiceListStockItemsResponses, InventoryServiceListStockItemsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/stockItems',
    ...options
});

/**
 * Reads one stock item (`inventory:read`)
 *
 * Reads one stock item (`inventory:read`).
 */
export const inventoryServiceGetStockItem = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceGetStockItemData, ThrowOnError>): RequestResult<InventoryServiceGetStockItemResponses, InventoryServiceGetStockItemErrors, ThrowOnError> => (options.client ?? client).get<InventoryServiceGetStockItemResponses, InventoryServiceGetStockItemErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/stockItems/{stockItem}',
    ...options
});

/**
 * Operator adjustment with reason and approval reference
 *
 * Operator adjustment with reason and approval reference
 * (`inventory:adjust`).
 */
export const inventoryServiceAdjustStock = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceAdjustStockData, ThrowOnError>): RequestResult<InventoryServiceAdjustStockResponses, InventoryServiceAdjustStockErrors, ThrowOnError> => (options.client ?? client).post<InventoryServiceAdjustStockResponses, InventoryServiceAdjustStockErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/stockItems:adjustStock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Checks availability for 1..=100 natural stock keys
 *
 * Checks availability for 1..=100 natural stock keys
 * (`inventory:read`); keys are (owner, sku, location), not resource names.
 */
export const inventoryServiceCheckAvailability = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceCheckAvailabilityData, ThrowOnError>): RequestResult<InventoryServiceCheckAvailabilityResponses, InventoryServiceCheckAvailabilityErrors, ThrowOnError> => (options.client ?? client).post<InventoryServiceCheckAvailabilityResponses, InventoryServiceCheckAvailabilityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/stockItems:checkAvailability',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Atomic location transfer pairing out/in ledger entries
 *
 * Atomic location transfer pairing out/in ledger entries
 * (`inventory:transfer`).
 */
export const inventoryServiceTransferStock = <ThrowOnError extends boolean = false>(options: Options<InventoryServiceTransferStockData, ThrowOnError>): RequestResult<InventoryServiceTransferStockResponses, InventoryServiceTransferStockErrors, ThrowOnError> => (options.client ?? client).post<InventoryServiceTransferStockResponses, InventoryServiceTransferStockErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/inventory/stockTransfers:transferStock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Applies a verified carrier event; adapter-only
 *
 * Applies a verified carrier event; adapter-only
 * (`logistics:provider.event.apply`).
 */
export const logisticsServiceApplyCarrierEvent = <ThrowOnError extends boolean = false>(options: Options<LogisticsServiceApplyCarrierEventData, ThrowOnError>): RequestResult<LogisticsServiceApplyCarrierEventResponses, LogisticsServiceApplyCarrierEventErrors, ThrowOnError> => (options.client ?? client).post<LogisticsServiceApplyCarrierEventResponses, LogisticsServiceApplyCarrierEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/logistics/events:applyCarrierEvent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quotes freight for one carrier product (`logistics:quote`)
 *
 * Quotes freight for one carrier product (`logistics:quote`).
 */
export const logisticsServiceQuoteFreight = <ThrowOnError extends boolean = false>(options: Options<LogisticsServiceQuoteFreightData, ThrowOnError>): RequestResult<LogisticsServiceQuoteFreightResponses, LogisticsServiceQuoteFreightErrors, ThrowOnError> => (options.client ?? client).post<LogisticsServiceQuoteFreightResponses, LogisticsServiceQuoteFreightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/logistics/freightQuotes:quoteFreight',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's shipments (`logistics:read`); `filter`
 *
 * Lists the caller tenant's shipments (`logistics:read`); `filter`
 * supports exact `source_fulfillment_id = "<uuid>"` matches.
 */
export const logisticsServiceListShipments = <ThrowOnError extends boolean = false>(options?: Options<LogisticsServiceListShipmentsData, ThrowOnError>): RequestResult<LogisticsServiceListShipmentsResponses, LogisticsServiceListShipmentsErrors, ThrowOnError> => (options?.client ?? client).get<LogisticsServiceListShipmentsResponses, LogisticsServiceListShipmentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/logistics/shipments',
    ...options
});

/**
 * Reads one shipment (`logistics:read`)
 *
 * Reads one shipment (`logistics:read`).
 */
export const logisticsServiceGetShipment = <ThrowOnError extends boolean = false>(options: Options<LogisticsServiceGetShipmentData, ThrowOnError>): RequestResult<LogisticsServiceGetShipmentResponses, LogisticsServiceGetShipmentErrors, ThrowOnError> => (options.client ?? client).get<LogisticsServiceGetShipmentResponses, LogisticsServiceGetShipmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/logistics/shipments/{shipment}',
    ...options
});

/**
 * Cancels a shipment before carrier handoff (`logistics:shipment.cancel`)
 *
 * Cancels a shipment before carrier handoff (`logistics:shipment.cancel`).
 */
export const logisticsServiceCancelShipment = <ThrowOnError extends boolean = false>(options: Options<LogisticsServiceCancelShipmentData, ThrowOnError>): RequestResult<LogisticsServiceCancelShipmentResponses, LogisticsServiceCancelShipmentErrors, ThrowOnError> => (options.client ?? client).post<LogisticsServiceCancelShipmentResponses, LogisticsServiceCancelShipmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/logistics/shipments/{shipment}:cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issues a return label for the addressed original shipment
 *
 * Issues a return label for the addressed original shipment
 * (`logistics:return.create`).
 */
export const logisticsServiceIssueReturnLabel = <ThrowOnError extends boolean = false>(options: Options<LogisticsServiceIssueReturnLabelData, ThrowOnError>): RequestResult<LogisticsServiceIssueReturnLabelResponses, LogisticsServiceIssueReturnLabelErrors, ThrowOnError> => (options.client ?? client).post<LogisticsServiceIssueReturnLabelResponses, LogisticsServiceIssueReturnLabelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/logistics/shipments/{shipment}:issueReturnLabel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Books a shipment; idempotent by source fulfillment key
 *
 * Books a shipment; idempotent by source fulfillment key
 * (`logistics:create`).
 */
export const logisticsServiceBookShipment = <ThrowOnError extends boolean = false>(options: Options<LogisticsServiceBookShipmentData, ThrowOnError>): RequestResult<LogisticsServiceBookShipmentResponses, LogisticsServiceBookShipmentErrors, ThrowOnError> => (options.client ?? client).post<LogisticsServiceBookShipmentResponses, LogisticsServiceBookShipmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/logistics/shipments:bookShipment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists members (tenant support role, masked PII)
 *
 * Lists members (tenant support role, masked PII).
 */
export const memberServiceListMembers = <ThrowOnError extends boolean = false>(options?: Options<MemberServiceListMembersData, ThrowOnError>): RequestResult<MemberServiceListMembersResponses, MemberServiceListMembersErrors, ThrowOnError> => (options?.client ?? client).get<MemberServiceListMembersResponses, MemberServiceListMembersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members',
    ...options
});

/**
 * Reads one member; cross-owner/tenant access is `NOT_FOUND`
 *
 * Reads one member; cross-owner/tenant access is `NOT_FOUND`.
 */
export const memberServiceGetMember = <ThrowOnError extends boolean = false>(options: Options<MemberServiceGetMemberData, ThrowOnError>): RequestResult<MemberServiceGetMemberResponses, MemberServiceGetMemberErrors, ThrowOnError> => (options.client ?? client).get<MemberServiceGetMemberResponses, MemberServiceGetMemberErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members/{member}',
    ...options
});

/**
 * Lists the member's addresses (owner or tenant support)
 *
 * Lists the member's addresses (owner or tenant support).
 */
export const memberServiceListAddresses = <ThrowOnError extends boolean = false>(options: Options<MemberServiceListAddressesData, ThrowOnError>): RequestResult<MemberServiceListAddressesResponses, MemberServiceListAddressesErrors, ThrowOnError> => (options.client ?? client).get<MemberServiceListAddressesResponses, MemberServiceListAddressesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members/{member}/addresses',
    ...options
});

/**
 * Reverses posted lines (`clearing:recover`)
 *
 * Reverses posted lines (`clearing:recover`).
 */
export const clearingServiceReverseClearing = <ThrowOnError extends boolean = false>(options: Options<ClearingServiceReverseClearingData, ThrowOnError>): RequestResult<ClearingServiceReverseClearingResponses, ClearingServiceReverseClearingErrors, ThrowOnError> => (options.client ?? client).post<ClearingServiceReverseClearingResponses, ClearingServiceReverseClearingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clearing/clearingBatches/{clearingBatch}:reverse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Idempotently inserts or updates one address (bounded at 50 per member)
 *
 * Idempotently inserts or updates one address (bounded at 50 per member).
 */
export const memberServiceUpsertAddress = <ThrowOnError extends boolean = false>(options: Options<MemberServiceUpsertAddressData, ThrowOnError>): RequestResult<MemberServiceUpsertAddressResponses, MemberServiceUpsertAddressErrors, ThrowOnError> => (options.client ?? client).post<MemberServiceUpsertAddressResponses, MemberServiceUpsertAddressErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members/{member}/addresses:upsert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Appends an immutable consent record; no backdating or overwrite
 *
 * Appends an immutable consent record; no backdating or overwrite.
 */
export const memberServiceRecordConsent = <ThrowOnError extends boolean = false>(options: Options<MemberServiceRecordConsentData, ThrowOnError>): RequestResult<MemberServiceRecordConsentResponses, MemberServiceRecordConsentErrors, ThrowOnError> => (options.client ?? client).post<MemberServiceRecordConsentResponses, MemberServiceRecordConsentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members/{member}/consentRecords:recordConsent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Requests profile erasure; retention holds block completion
 *
 * Requests profile erasure; retention holds block completion.
 */
export const memberServiceRequestErasure = <ThrowOnError extends boolean = false>(options: Options<MemberServiceRequestErasureData, ThrowOnError>): RequestResult<MemberServiceRequestErasureResponses, MemberServiceRequestErasureErrors, ThrowOnError> => (options.client ?? client).post<MemberServiceRequestErasureResponses, MemberServiceRequestErasureErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members/{member}:requestErasure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates locale/time_zone/contact-ref/default address under a field mask
 *
 * Updates locale/time_zone/contact-ref/default address under a field mask
 * and expected version.
 */
export const memberServiceReviseMember = <ThrowOnError extends boolean = false>(options: Options<MemberServiceReviseMemberData, ThrowOnError>): RequestResult<MemberServiceReviseMemberResponses, MemberServiceReviseMemberErrors, ThrowOnError> => (options.client ?? client).post<MemberServiceReviseMemberResponses, MemberServiceReviseMemberErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members/{member}:revise',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Registers a buyer profile for one IDAAS subject (tenant-unique)
 *
 * Registers a buyer profile for one IDAAS subject (tenant-unique).
 */
export const memberServiceEnrollMember = <ThrowOnError extends boolean = false>(options: Options<MemberServiceEnrollMemberData, ThrowOnError>): RequestResult<MemberServiceEnrollMemberResponses, MemberServiceEnrollMemberErrors, ThrowOnError> => (options.client ?? client).post<MemberServiceEnrollMemberResponses, MemberServiceEnrollMemberErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members:enrollMember',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves the caller's own member profile in the caller's tenant scope
 *
 * Resolves the caller's own member profile in the caller's tenant scope
 * (`member:self.read`). The member resource always derives from the
 * verified principal; unknown profiles are `MEMBER_NOT_FOUND` and enroll
 * through `EnrollMember` on first login.
 */
export const memberServiceResolveSelf = <ThrowOnError extends boolean = false>(options?: Options<MemberServiceResolveSelfData, ThrowOnError>): RequestResult<MemberServiceResolveSelfResponses, MemberServiceResolveSelfErrors, ThrowOnError> => (options?.client ?? client).get<MemberServiceResolveSelfResponses, MemberServiceResolveSelfErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members:resolveSelf',
    ...options
});

/**
 * List merchants within tenant with filtering and pagination (AIP-132 / AIP-158)
 *
 * List merchants within tenant with filtering and pagination (AIP-132 / AIP-158).
 */
export const merchantServiceListMerchants = <ThrowOnError extends boolean = false>(options?: Options<MerchantServiceListMerchantsData, ThrowOnError>): RequestResult<MerchantServiceListMerchantsResponses, MerchantServiceListMerchantsErrors, ThrowOnError> => (options?.client ?? client).get<MerchantServiceListMerchantsResponses, MerchantServiceListMerchantsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants',
    ...options
});

/**
 * Register an initial merchant entity (AIP-133)
 *
 * Register an initial merchant entity (AIP-133).
 */
export const merchantServiceCreateMerchant = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceCreateMerchantData, ThrowOnError>): RequestResult<MerchantServiceCreateMerchantResponses, MerchantServiceCreateMerchantErrors, ThrowOnError> => (options.client ?? client).post<MerchantServiceCreateMerchantResponses, MerchantServiceCreateMerchantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get merchant details by resource name (AIP-131)
 *
 * Get merchant details by resource name (AIP-131).
 */
export const merchantServiceGetMerchant = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceGetMerchantData, ThrowOnError>): RequestResult<MerchantServiceGetMerchantResponses, MerchantServiceGetMerchantErrors, ThrowOnError> => (options.client ?? client).get<MerchantServiceGetMerchantResponses, MerchantServiceGetMerchantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}',
    ...options
});

/**
 * Partially update merchant details (AIP-134)
 *
 * Partially update merchant details (AIP-134).
 */
export const merchantServiceUpdateMerchant = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceUpdateMerchantData, ThrowOnError>): RequestResult<MerchantServiceUpdateMerchantResponses, MerchantServiceUpdateMerchantErrors, ThrowOnError> => (options.client ?? client).patch<MerchantServiceUpdateMerchantResponses, MerchantServiceUpdateMerchantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit legal profile revision for KYB/KYC verification (AIP-136 Custom Method)
 *
 * Submit legal profile revision for KYB/KYC verification (AIP-136 Custom Method).
 */
export const merchantServiceSubmitLegalProfile = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceSubmitLegalProfileData, ThrowOnError>): RequestResult<MerchantServiceSubmitLegalProfileResponses, MerchantServiceSubmitLegalProfileErrors, ThrowOnError> => (options.client ?? client).post<MerchantServiceSubmitLegalProfileResponses, MerchantServiceSubmitLegalProfileErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}/legalProfiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a specific legal profile revision (AIP-131)
 *
 * Get a specific legal profile revision (AIP-131).
 */
export const merchantServiceGetLegalProfileRevision = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceGetLegalProfileRevisionData, ThrowOnError>): RequestResult<MerchantServiceGetLegalProfileRevisionResponses, MerchantServiceGetLegalProfileRevisionErrors, ThrowOnError> => (options.client ?? client).get<MerchantServiceGetLegalProfileRevisionResponses, MerchantServiceGetLegalProfileRevisionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}/legalProfiles/{legalProfile}',
    ...options
});

/**
 * Approve or reject merchant verification application (AIP-136 Custom Method)
 *
 * Approve or reject merchant verification application (AIP-136 Custom Method).
 */
export const merchantServiceReviewLegalProfile = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceReviewLegalProfileData, ThrowOnError>): RequestResult<MerchantServiceReviewLegalProfileResponses, MerchantServiceReviewLegalProfileErrors, ThrowOnError> => (options.client ?? client).post<MerchantServiceReviewLegalProfileResponses, MerchantServiceReviewLegalProfileErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}/legalProfiles/{legalProfile}:review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign or update staff access scope under merchant
 *
 * Assign or update staff access scope under merchant.
 */
export const merchantServiceAssignStaffScope = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceAssignStaffScopeData, ThrowOnError>): RequestResult<MerchantServiceAssignStaffScopeResponses, MerchantServiceAssignStaffScopeErrors, ThrowOnError> => (options.client ?? client).post<MerchantServiceAssignStaffScopeResponses, MerchantServiceAssignStaffScopeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}/staffScopes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Freeze merchant account due to compliance or risk triggers (AIP-136 Custom Method)
 *
 * Freeze merchant account due to compliance or risk triggers (AIP-136 Custom Method).
 */
export const merchantServiceFreezeMerchant = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceFreezeMerchantData, ThrowOnError>): RequestResult<MerchantServiceFreezeMerchantResponses, MerchantServiceFreezeMerchantErrors, ThrowOnError> => (options.client ?? client).post<MerchantServiceFreezeMerchantResponses, MerchantServiceFreezeMerchantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}:freeze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unfreeze merchant account back to VERIFIED state (AIP-136 Custom Method)
 *
 * Unfreeze merchant account back to VERIFIED state (AIP-136 Custom Method).
 */
export const merchantServiceUnfreezeMerchant = <ThrowOnError extends boolean = false>(options: Options<MerchantServiceUnfreezeMerchantData, ThrowOnError>): RequestResult<MerchantServiceUnfreezeMerchantResponses, MerchantServiceUnfreezeMerchantErrors, ThrowOnError> => (options.client ?? client).post<MerchantServiceUnfreezeMerchantResponses, MerchantServiceUnfreezeMerchantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/merchant/merchants/{merchant}:unfreeze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists notifications with cursor pagination (AIP-132, AIP-158)
 *
 * Lists notifications with cursor pagination (AIP-132, AIP-158).
 */
export const notificationServiceListNotifications = <ThrowOnError extends boolean = false>(options?: Options<NotificationServiceListNotificationsData, ThrowOnError>): RequestResult<NotificationServiceListNotificationsResponses, NotificationServiceListNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<NotificationServiceListNotificationsResponses, NotificationServiceListNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications',
    ...options
});

/**
 * Retrieves one notification by resource name (AIP-131)
 *
 * Retrieves one notification by resource name (AIP-131).
 */
export const notificationServiceGetNotification = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceGetNotificationData, ThrowOnError>): RequestResult<NotificationServiceGetNotificationResponses, NotificationServiceGetNotificationErrors, ThrowOnError> => (options.client ?? client).get<NotificationServiceGetNotificationResponses, NotificationServiceGetNotificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/{notification}',
    ...options
});

/**
 * Dispatches a batch of notifications with chunked execution (AIP-136)
 *
 * Dispatches a batch of notifications with chunked execution (AIP-136).
 */
export const notificationServiceBatchSendNotifications = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceBatchSendNotificationsData, ThrowOnError>): RequestResult<NotificationServiceBatchSendNotificationsResponses, NotificationServiceBatchSendNotificationsErrors, ThrowOnError> => (options.client ?? client).post<NotificationServiceBatchSendNotificationsResponses, NotificationServiceBatchSendNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications:batchSend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingests and dispatches a single notification (AIP-136)
 *
 * Ingests and dispatches a single notification (AIP-136).
 */
export const notificationServiceSendNotification = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceSendNotificationData, ThrowOnError>): RequestResult<NotificationServiceSendNotificationResponses, NotificationServiceSendNotificationErrors, ThrowOnError> => (options.client ?? client).post<NotificationServiceSendNotificationResponses, NotificationServiceSendNotificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications:send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists orders in creation order (`order:read`); `filter` supports exact
 *
 * Lists orders in creation order (`order:read`); `filter` supports exact
 * `buyer = "<principal>"` matches.
 */
export const orderServiceListOrders = <ThrowOnError extends boolean = false>(options?: Options<OrderServiceListOrdersData, ThrowOnError>): RequestResult<OrderServiceListOrdersResponses, OrderServiceListOrdersErrors, ThrowOnError> => (options?.client ?? client).get<OrderServiceListOrdersResponses, OrderServiceListOrdersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/order/orders',
    ...options
});

/**
 * Reads one order (`order:read`)
 *
 * Reads one order (`order:read`).
 */
export const orderServiceGetOrder = <ThrowOnError extends boolean = false>(options: Options<OrderServiceGetOrderData, ThrowOnError>): RequestResult<OrderServiceGetOrderResponses, OrderServiceGetOrderErrors, ThrowOnError> => (options.client ?? client).get<OrderServiceGetOrderResponses, OrderServiceGetOrderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/order/orders/{order}',
    ...options
});

/**
 * Applies a payment fact from Pay (inbox, exactly-once)
 *
 * Applies a payment fact from Pay (inbox, exactly-once).
 */
export const orderServiceApplyPaymentFact = <ThrowOnError extends boolean = false>(options: Options<OrderServiceApplyPaymentFactData, ThrowOnError>): RequestResult<OrderServiceApplyPaymentFactResponses, OrderServiceApplyPaymentFactErrors, ThrowOnError> => (options.client ?? client).post<OrderServiceApplyPaymentFactResponses, OrderServiceApplyPaymentFactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/order/orders/{order}:applyPaymentFact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attaches an AfterSales case reference (`order:write`, CAS)
 *
 * Attaches an AfterSales case reference (`order:write`, CAS).
 */
export const orderServiceAttachCase = <ThrowOnError extends boolean = false>(options: Options<OrderServiceAttachCaseData, ThrowOnError>): RequestResult<OrderServiceAttachCaseResponses, OrderServiceAttachCaseErrors, ThrowOnError> => (options.client ?? client).post<OrderServiceAttachCaseResponses, OrderServiceAttachCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/order/orders/{order}:attachCase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Marks fulfillment progress from Fulfillment facts
 *
 * Marks fulfillment progress from Fulfillment facts
 * (`order:write`, inbox exactly-once).
 */
export const orderServiceMarkFulfillmentProgress = <ThrowOnError extends boolean = false>(options: Options<OrderServiceMarkFulfillmentProgressData, ThrowOnError>): RequestResult<OrderServiceMarkFulfillmentProgressResponses, OrderServiceMarkFulfillmentProgressErrors, ThrowOnError> => (options.client ?? client).post<OrderServiceMarkFulfillmentProgressResponses, OrderServiceMarkFulfillmentProgressErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/order/orders/{order}:markFulfillmentProgress',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Requests cancellation with a reason (`order:write`, CAS)
 *
 * Requests cancellation with a reason (`order:write`, CAS).
 */
export const orderServiceRequestCancellation = <ThrowOnError extends boolean = false>(options: Options<OrderServiceRequestCancellationData, ThrowOnError>): RequestResult<OrderServiceRequestCancellationResponses, OrderServiceRequestCancellationErrors, ThrowOnError> => (options.client ?? client).post<OrderServiceRequestCancellationResponses, OrderServiceRequestCancellationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/order/orders/{order}:requestCancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Realizes an order from an accepted Trade plan; idempotent by source key
 *
 * Realizes an order from an accepted Trade plan; idempotent by source key
 * (`order:create`, Trade workload).
 */
export const orderServiceRealizeOrder = <ThrowOnError extends boolean = false>(options: Options<OrderServiceRealizeOrderData, ThrowOnError>): RequestResult<OrderServiceRealizeOrderResponses, OrderServiceRealizeOrderErrors, ThrowOnError> => (options.client ?? client).post<OrderServiceRealizeOrderResponses, OrderServiceRealizeOrderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/order/orders:realizeOrder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists provider statements (`pay:statement.read`); `filter` supports
 *
 * Lists provider statements (`pay:statement.read`); `filter` supports
 * exact `provider_account = "<ref>"` matches.
 */
export const paymentServiceListChannelStatements = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceListChannelStatementsData, ThrowOnError>): RequestResult<PaymentServiceListChannelStatementsResponses, PaymentServiceListChannelStatementsErrors, ThrowOnError> => (options?.client ?? client).get<PaymentServiceListChannelStatementsResponses, PaymentServiceListChannelStatementsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/channelStatements',
    ...options
});

/**
 * Reads one immutable provider statement (`pay:statement.read`)
 *
 * Reads one immutable provider statement (`pay:statement.read`).
 */
export const paymentServiceGetChannelStatement = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceGetChannelStatementData, ThrowOnError>): RequestResult<PaymentServiceGetChannelStatementResponses, PaymentServiceGetChannelStatementErrors, ThrowOnError> => (options.client ?? client).get<PaymentServiceGetChannelStatementResponses, PaymentServiceGetChannelStatementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/channelStatements/{channelStatement}',
    ...options
});

/**
 * Applies a verified provider notification; adapter-only
 *
 * Applies a verified provider notification; adapter-only
 * (`pay:provider.apply`).
 */
export const paymentServiceApplyProviderNotification = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceApplyProviderNotificationData, ThrowOnError>): RequestResult<PaymentServiceApplyProviderNotificationResponses, PaymentServiceApplyProviderNotificationErrors, ThrowOnError> => (options.client ?? client).post<PaymentServiceApplyProviderNotificationResponses, PaymentServiceApplyProviderNotificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/notifications:applyProviderNotification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists payment intents (`pay:intent.read`); `filter` supports exact
 *
 * Lists payment intents (`pay:intent.read`); `filter` supports exact
 * `source = "<key>"` matches for unknown-outcome recovery. Human-principal
 * callers must pass a `source` filter carrying their own `:buyer:` suffix
 * (specs/pay/13 §3.4).
 */
export const paymentServiceListPaymentIntents = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceListPaymentIntentsData, ThrowOnError>): RequestResult<PaymentServiceListPaymentIntentsResponses, PaymentServiceListPaymentIntentsErrors, ThrowOnError> => (options?.client ?? client).get<PaymentServiceListPaymentIntentsResponses, PaymentServiceListPaymentIntentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/paymentIntents',
    ...options
});

/**
 * Reads one intent (`pay:intent.read`). Human-principal callers must own
 *
 * Reads one intent (`pay:intent.read`). Human-principal callers must own
 * the intent via the `:buyer:{principal}` source suffix (specs/pay/13 §3.4).
 */
export const paymentServiceGetPaymentIntent = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceGetPaymentIntentData, ThrowOnError>): RequestResult<PaymentServiceGetPaymentIntentResponses, PaymentServiceGetPaymentIntentErrors, ThrowOnError> => (options.client ?? client).get<PaymentServiceGetPaymentIntentResponses, PaymentServiceGetPaymentIntentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/paymentIntents/{paymentIntent}',
    ...options
});

/**
 * Cancels an intent before capture (`pay:intent.create`). Workload-only:
 *
 * Cancels an intent before capture (`pay:intent.create`). Workload-only:
 * human-principal callers are rejected (specs/pay/13 §3.2).
 */
export const paymentServiceCancelPaymentIntent = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceCancelPaymentIntentData, ThrowOnError>): RequestResult<PaymentServiceCancelPaymentIntentResponses, PaymentServiceCancelPaymentIntentErrors, ThrowOnError> => (options.client ?? client).post<PaymentServiceCancelPaymentIntentResponses, PaymentServiceCancelPaymentIntentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/paymentIntents/{paymentIntent}:cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Records the confirmed method and starts provider execution
 *
 * Records the confirmed method and starts provider execution
 * (`pay:intent.create`). Human-principal callers must own the intent via
 * the `:buyer:{principal}` source suffix (specs/pay/13 §3.4).
 */
export const paymentServiceConfirmPaymentIntent = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceConfirmPaymentIntentData, ThrowOnError>): RequestResult<PaymentServiceConfirmPaymentIntentResponses, PaymentServiceConfirmPaymentIntentErrors, ThrowOnError> => (options.client ?? client).post<PaymentServiceConfirmPaymentIntentResponses, PaymentServiceConfirmPaymentIntentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/paymentIntents/{paymentIntent}:confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Opens a payment intent; idempotent by source key (`pay:intent.create`)
 *
 * Opens a payment intent; idempotent by source key (`pay:intent.create`).
 * Workload-only: human-principal callers are rejected (specs/pay/13 §3.2).
 */
export const paymentServiceOpenPaymentIntent = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceOpenPaymentIntentData, ThrowOnError>): RequestResult<PaymentServiceOpenPaymentIntentResponses, PaymentServiceOpenPaymentIntentErrors, ThrowOnError> => (options.client ?? client).post<PaymentServiceOpenPaymentIntentResponses, PaymentServiceOpenPaymentIntentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/paymentIntents:openPaymentIntent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists payouts (`pay:payout.read`); `filter` supports exact
 *
 * Lists payouts (`pay:payout.read`); `filter` supports exact
 * `source = "<key>"` matches.
 */
export const paymentServiceListPayouts = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceListPayoutsData, ThrowOnError>): RequestResult<PaymentServiceListPayoutsResponses, PaymentServiceListPayoutsErrors, ThrowOnError> => (options?.client ?? client).get<PaymentServiceListPayoutsResponses, PaymentServiceListPayoutsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/payouts',
    ...options
});

/**
 * Reads one payout (`pay:payout.read`)
 *
 * Reads one payout (`pay:payout.read`).
 */
export const paymentServiceGetPayout = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceGetPayoutData, ThrowOnError>): RequestResult<PaymentServiceGetPayoutResponses, PaymentServiceGetPayoutErrors, ThrowOnError> => (options.client ?? client).get<PaymentServiceGetPayoutResponses, PaymentServiceGetPayoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/payouts/{payout}',
    ...options
});

/**
 * Executes a Settlement-sourced payout (`pay:payout.create`)
 *
 * Executes a Settlement-sourced payout (`pay:payout.create`).
 */
export const paymentServiceExecutePayout = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceExecutePayoutData, ThrowOnError>): RequestResult<PaymentServiceExecutePayoutResponses, PaymentServiceExecutePayoutErrors, ThrowOnError> => (options.client ?? client).post<PaymentServiceExecutePayoutResponses, PaymentServiceExecutePayoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/payouts:executePayout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists refunds (`pay:refund.read`); `filter` supports exact
 *
 * Lists refunds (`pay:refund.read`); `filter` supports exact
 * `source = "<key>"` matches.
 */
export const paymentServiceListRefunds = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceListRefundsData, ThrowOnError>): RequestResult<PaymentServiceListRefundsResponses, PaymentServiceListRefundsErrors, ThrowOnError> => (options?.client ?? client).get<PaymentServiceListRefundsResponses, PaymentServiceListRefundsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/refunds',
    ...options
});

/**
 * Reads one refund (`pay:refund.read`)
 *
 * Reads one refund (`pay:refund.read`).
 */
export const paymentServiceGetRefund = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceGetRefundData, ThrowOnError>): RequestResult<PaymentServiceGetRefundResponses, PaymentServiceGetRefundErrors, ThrowOnError> => (options.client ?? client).get<PaymentServiceGetRefundResponses, PaymentServiceGetRefundErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/refunds/{refund}',
    ...options
});

/**
 * Executes a refund capped by captured units (`pay:refund.create`)
 *
 * Executes a refund capped by captured units (`pay:refund.create`).
 */
export const paymentServiceExecuteRefund = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceExecuteRefundData, ThrowOnError>): RequestResult<PaymentServiceExecuteRefundResponses, PaymentServiceExecuteRefundErrors, ThrowOnError> => (options.client ?? client).post<PaymentServiceExecuteRefundResponses, PaymentServiceExecuteRefundErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pay/refunds:executeRefund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Compiles and publishes an immutable revision and activates it
 *
 * Compiles and publishes an immutable revision and activates it
 * (`pricing:publish`, CAS).
 */
export const pricingServiceActivatePriceBook = <ThrowOnError extends boolean = false>(options: Options<PricingServiceActivatePriceBookData, ThrowOnError>): RequestResult<PricingServiceActivatePriceBookResponses, PricingServiceActivatePriceBookErrors, ThrowOnError> => (options.client ?? client).post<PricingServiceActivatePriceBookResponses, PricingServiceActivatePriceBookErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/priceBooks/{priceBook}:activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replaces priority and entries while the book is DRAFT
 *
 * Replaces priority and entries while the book is DRAFT
 * (`pricing:manage`, CAS).
 */
export const pricingServiceRevisePriceBook = <ThrowOnError extends boolean = false>(options: Options<PricingServiceRevisePriceBookData, ThrowOnError>): RequestResult<PricingServiceRevisePriceBookResponses, PricingServiceRevisePriceBookErrors, ThrowOnError> => (options.client ?? client).post<PricingServiceRevisePriceBookResponses, PricingServiceRevisePriceBookErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/priceBooks/{priceBook}:revise',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Drafts a price book with its bounded base-price entries
 *
 * Drafts a price book with its bounded base-price entries
 * (`pricing:manage`).
 */
export const pricingServiceDraftPriceBook = <ThrowOnError extends boolean = false>(options: Options<PricingServiceDraftPriceBookData, ThrowOnError>): RequestResult<PricingServiceDraftPriceBookResponses, PricingServiceDraftPriceBookErrors, ThrowOnError> => (options.client ?? client).post<PricingServiceDraftPriceBookResponses, PricingServiceDraftPriceBookErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/priceBooks:draftPriceBook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists immutable revisions of the caller tenant in creation order
 *
 * Lists immutable revisions of the caller tenant in creation order
 * (`pricing:calculate`).
 */
export const pricingServiceListPriceRevisions = <ThrowOnError extends boolean = false>(options?: Options<PricingServiceListPriceRevisionsData, ThrowOnError>): RequestResult<PricingServiceListPriceRevisionsResponses, PricingServiceListPriceRevisionsErrors, ThrowOnError> => (options?.client ?? client).get<PricingServiceListPriceRevisionsResponses, PricingServiceListPriceRevisionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/priceRevisions',
    ...options
});

/**
 * Reads one immutable revision (`pricing:calculate`)
 *
 * Reads one immutable revision (`pricing:calculate`).
 */
export const pricingServiceGetPriceRevision = <ThrowOnError extends boolean = false>(options: Options<PricingServiceGetPriceRevisionData, ThrowOnError>): RequestResult<PricingServiceGetPriceRevisionResponses, PricingServiceGetPriceRevisionErrors, ThrowOnError> => (options.client ?? client).get<PricingServiceGetPriceRevisionResponses, PricingServiceGetPriceRevisionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/priceRevisions/{priceRevision}',
    ...options
});

/**
 * Resolves one deterministic price per requested line
 *
 * Resolves one deterministic price per requested line
 * (`pricing:calculate`); missing or ambiguous prices fail the whole
 * request — never a zero or fallback price.
 */
export const pricingServiceCalculateOfferPrices = <ThrowOnError extends boolean = false>(options: Options<PricingServiceCalculateOfferPricesData, ThrowOnError>): RequestResult<PricingServiceCalculateOfferPricesResponses, PricingServiceCalculateOfferPricesErrors, ThrowOnError> => (options.client ?? client).post<PricingServiceCalculateOfferPricesResponses, PricingServiceCalculateOfferPricesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/prices:calculate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publishes an immutable rule revision and activates it
 *
 * Publishes an immutable rule revision and activates it
 * (`pricing:publish`, CAS).
 */
export const pricingServicePublishRuleSet = <ThrowOnError extends boolean = false>(options: Options<PricingServicePublishRuleSetData, ThrowOnError>): RequestResult<PricingServicePublishRuleSetResponses, PricingServicePublishRuleSetErrors, ThrowOnError> => (options.client ?? client).post<PricingServicePublishRuleSetResponses, PricingServicePublishRuleSetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/ruleSets/{ruleSet}:publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Drafts a typed rule set (`pricing:manage`)
 *
 * Drafts a typed rule set (`pricing:manage`).
 */
export const pricingServiceDraftRuleSet = <ThrowOnError extends boolean = false>(options: Options<PricingServiceDraftRuleSetData, ThrowOnError>): RequestResult<PricingServiceDraftRuleSetResponses, PricingServiceDraftRuleSetErrors, ThrowOnError> => (options.client ?? client).post<PricingServiceDraftRuleSetResponses, PricingServiceDraftRuleSetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pricing/ruleSets:draftRuleSet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns the current immutable snapshot (`product:read`)
 *
 * Returns the current immutable snapshot (`product:read`).
 */
export const productServiceGetOfferSnapshot = <ThrowOnError extends boolean = false>(options: Options<ProductServiceGetOfferSnapshotData, ThrowOnError>): RequestResult<ProductServiceGetOfferSnapshotResponses, ProductServiceGetOfferSnapshotErrors, ThrowOnError> => (options.client ?? client).get<ProductServiceGetOfferSnapshotResponses, ProductServiceGetOfferSnapshotErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/offers/{offer}/snapshot',
    ...options
});

/**
 * Suspends an active offer (`offer:publish`)
 *
 * Suspends an active offer (`offer:publish`).
 */
export const productServiceSuspendOffer = <ThrowOnError extends boolean = false>(options: Options<ProductServiceSuspendOfferData, ThrowOnError>): RequestResult<ProductServiceSuspendOfferResponses, ProductServiceSuspendOfferErrors, ThrowOnError> => (options.client ?? client).post<ProductServiceSuspendOfferResponses, ProductServiceSuspendOfferErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/offers/{offer}:suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publishes an offer on an active store (`offer:publish`)
 *
 * Publishes an offer on an active store (`offer:publish`).
 */
export const productServicePublishOffer = <ThrowOnError extends boolean = false>(options: Options<ProductServicePublishOfferData, ThrowOnError>): RequestResult<ProductServicePublishOfferResponses, ProductServicePublishOfferErrors, ThrowOnError> => (options.client ?? client).post<ProductServicePublishOfferResponses, ProductServicePublishOfferErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/offers:publishOffer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists products ordered by (create_time, product_id)
 *
 * Lists products ordered by (create_time, product_id).
 */
export const productServiceListProducts = <ThrowOnError extends boolean = false>(options?: Options<ProductServiceListProductsData, ThrowOnError>): RequestResult<ProductServiceListProductsResponses, ProductServiceListProductsErrors, ThrowOnError> => (options?.client ?? client).get<ProductServiceListProductsResponses, ProductServiceListProductsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/products',
    ...options
});

/**
 * Creates a DRAFT product (`product:write`)
 *
 * Creates a DRAFT product (`product:write`).
 */
export const productServiceCreateProduct = <ThrowOnError extends boolean = false>(options: Options<ProductServiceCreateProductData, ThrowOnError>): RequestResult<ProductServiceCreateProductResponses, ProductServiceCreateProductErrors, ThrowOnError> => (options.client ?? client).post<ProductServiceCreateProductResponses, ProductServiceCreateProductErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reads one product; cross-scope access is `NOT_FOUND`
 *
 * Reads one product; cross-scope access is `NOT_FOUND`.
 */
export const productServiceGetProduct = <ThrowOnError extends boolean = false>(options: Options<ProductServiceGetProductData, ThrowOnError>): RequestResult<ProductServiceGetProductResponses, ProductServiceGetProductErrors, ThrowOnError> => (options.client ?? client).get<ProductServiceGetProductResponses, ProductServiceGetProductErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/products/{product}',
    ...options
});

/**
 * Updates the draft title (creates a new revision on publish)
 *
 * Updates the draft title (creates a new revision on publish).
 */
export const productServiceUpdateProduct = <ThrowOnError extends boolean = false>(options: Options<ProductServiceUpdateProductData, ThrowOnError>): RequestResult<ProductServiceUpdateProductResponses, ProductServiceUpdateProductErrors, ThrowOnError> => (options.client ?? client).patch<ProductServiceUpdateProductResponses, ProductServiceUpdateProductErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/products/{product}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Adds a variant under a product (`product:write`)
 *
 * Adds a variant under a product (`product:write`).
 */
export const productServiceAddVariant = <ThrowOnError extends boolean = false>(options: Options<ProductServiceAddVariantData, ThrowOnError>): RequestResult<ProductServiceAddVariantResponses, ProductServiceAddVariantErrors, ThrowOnError> => (options.client ?? client).post<ProductServiceAddVariantResponses, ProductServiceAddVariantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/product/products/{product}/variants:addVariant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Seals the benefit/eligibility into an immutable revision, opens the
 *
 * Seals the benefit/eligibility into an immutable revision, opens the
 * budget position and activates it (`promotion:manage`, CAS).
 */
export const promotionServicePublishCampaign = <ThrowOnError extends boolean = false>(options: Options<PromotionServicePublishCampaignData, ThrowOnError>): RequestResult<PromotionServicePublishCampaignResponses, PromotionServicePublishCampaignErrors, ThrowOnError> => (options.client ?? client).post<PromotionServicePublishCampaignResponses, PromotionServicePublishCampaignErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/campaigns/{campaign}:publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Drafts a campaign (`promotion:manage`)
 *
 * Drafts a campaign (`promotion:manage`).
 */
export const promotionServiceDraftCampaign = <ThrowOnError extends boolean = false>(options: Options<PromotionServiceDraftCampaignData, ThrowOnError>): RequestResult<PromotionServiceDraftCampaignResponses, PromotionServiceDraftCampaignErrors, ThrowOnError> => (options.client ?? client).post<PromotionServiceDraftCampaignResponses, PromotionServiceDraftCampaignErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/campaigns:draftCampaign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issues coupon grants bound to the active revision; cleartext codes are
 *
 * Issues coupon grants bound to the active revision; cleartext codes are
 * returned exactly once (`promotion:manage`).
 */
export const promotionServiceIssueCoupon = <ThrowOnError extends boolean = false>(options: Options<PromotionServiceIssueCouponData, ThrowOnError>): RequestResult<PromotionServiceIssueCouponResponses, PromotionServiceIssueCouponErrors, ThrowOnError> => (options.client ?? client).post<PromotionServiceIssueCouponResponses, PromotionServiceIssueCouponErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/coupons:issueCoupon',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's reservations in creation order, optionally
 *
 * Lists the caller tenant's reservations in creation order, optionally
 * filtered by Trade source key (`promotion:reservation.read`).
 */
export const promotionServiceListPromotionReservations = <ThrowOnError extends boolean = false>(options?: Options<PromotionServiceListPromotionReservationsData, ThrowOnError>): RequestResult<PromotionServiceListPromotionReservationsResponses, PromotionServiceListPromotionReservationsErrors, ThrowOnError> => (options?.client ?? client).get<PromotionServiceListPromotionReservationsResponses, PromotionServiceListPromotionReservationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/promotionReservations',
    ...options
});

/**
 * Reads one reservation (`promotion:reservation.read`)
 *
 * Reads one reservation (`promotion:reservation.read`).
 */
export const promotionServiceGetPromotionReservation = <ThrowOnError extends boolean = false>(options: Options<PromotionServiceGetPromotionReservationData, ThrowOnError>): RequestResult<PromotionServiceGetPromotionReservationResponses, PromotionServiceGetPromotionReservationErrors, ThrowOnError> => (options.client ?? client).get<PromotionServiceGetPromotionReservationResponses, PromotionServiceGetPromotionReservationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/promotionReservations/{promotionReservation}',
    ...options
});

/**
 * Terminal consumption after the trade completes
 *
 * Terminal consumption after the trade completes
 * (`promotion:reservation.write`, CAS).
 */
export const promotionServiceConsumePromotion = <ThrowOnError extends boolean = false>(options: Options<PromotionServiceConsumePromotionData, ThrowOnError>): RequestResult<PromotionServiceConsumePromotionResponses, PromotionServiceConsumePromotionErrors, ThrowOnError> => (options.client ?? client).post<PromotionServiceConsumePromotionResponses, PromotionServiceConsumePromotionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/promotionReservations/{promotionReservation}:consume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Terminal release; returns budget and re-issues held coupons
 *
 * Terminal release; returns budget and re-issues held coupons
 * (`promotion:reservation.write`, CAS).
 */
export const promotionServiceReleasePromotion = <ThrowOnError extends boolean = false>(options: Options<PromotionServiceReleasePromotionData, ThrowOnError>): RequestResult<PromotionServiceReleasePromotionResponses, PromotionServiceReleasePromotionErrors, ThrowOnError> => (options.client ?? client).post<PromotionServiceReleasePromotionResponses, PromotionServiceReleasePromotionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/promotionReservations/{promotionReservation}:release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claims the Trade source key, revalidates the quote and freezes the
 *
 * Claims the Trade source key, revalidates the quote and freezes the
 * allocation (`promotion:reservation.write`).
 */
export const promotionServiceReservePromotion = <ThrowOnError extends boolean = false>(options: Options<PromotionServiceReservePromotionData, ThrowOnError>): RequestResult<PromotionServiceReservePromotionResponses, PromotionServiceReservePromotionErrors, ThrowOnError> => (options.client ?? client).post<PromotionServiceReservePromotionResponses, PromotionServiceReservePromotionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/promotionReservations:reservePromotion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pure deterministic evaluation over the active revision set
 *
 * Pure deterministic evaluation over the active revision set
 * (`promotion:evaluate`); no budget or coupon state changes.
 */
export const promotionServiceEvaluatePromotions = <ThrowOnError extends boolean = false>(options: Options<PromotionServiceEvaluatePromotionsData, ThrowOnError>): RequestResult<PromotionServiceEvaluatePromotionsResponses, PromotionServiceEvaluatePromotionsErrors, ThrowOnError> => (options.client ?? client).post<PromotionServiceEvaluatePromotionsResponses, PromotionServiceEvaluatePromotionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/promotion/promotions:evaluate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's runs in creation order (`reconciliation:read`)
 *
 * Lists the caller tenant's runs in creation order (`reconciliation:read`).
 */
export const reconciliationServiceListReconciliationRuns = <ThrowOnError extends boolean = false>(options?: Options<ReconciliationServiceListReconciliationRunsData, ThrowOnError>): RequestResult<ReconciliationServiceListReconciliationRunsResponses, ReconciliationServiceListReconciliationRunsErrors, ThrowOnError> => (options?.client ?? client).get<ReconciliationServiceListReconciliationRunsResponses, ReconciliationServiceListReconciliationRunsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns',
    ...options
});

/**
 * Reads one run (`reconciliation:read`)
 *
 * Reads one run (`reconciliation:read`).
 */
export const reconciliationServiceGetReconciliationRun = <ThrowOnError extends boolean = false>(options: Options<ReconciliationServiceGetReconciliationRunData, ThrowOnError>): RequestResult<ReconciliationServiceGetReconciliationRunResponses, ReconciliationServiceGetReconciliationRunErrors, ThrowOnError> => (options.client ?? client).get<ReconciliationServiceGetReconciliationRunResponses, ReconciliationServiceGetReconciliationRunErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns/{reconciliationRun}',
    ...options
});

/**
 * Lists the discrepancy cases of one run (`reconciliation:read`)
 *
 * Lists the discrepancy cases of one run (`reconciliation:read`).
 */
export const reconciliationServiceListDiscrepancyCases = <ThrowOnError extends boolean = false>(options: Options<ReconciliationServiceListDiscrepancyCasesData, ThrowOnError>): RequestResult<ReconciliationServiceListDiscrepancyCasesResponses, ReconciliationServiceListDiscrepancyCasesErrors, ThrowOnError> => (options.client ?? client).get<ReconciliationServiceListDiscrepancyCasesResponses, ReconciliationServiceListDiscrepancyCasesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns/{reconciliationRun}/discrepancyCases',
    ...options
});

/**
 * Reads one discrepancy case (`reconciliation:read`)
 *
 * Reads one discrepancy case (`reconciliation:read`).
 */
export const reconciliationServiceGetDiscrepancyCase = <ThrowOnError extends boolean = false>(options: Options<ReconciliationServiceGetDiscrepancyCaseData, ThrowOnError>): RequestResult<ReconciliationServiceGetDiscrepancyCaseResponses, ReconciliationServiceGetDiscrepancyCaseErrors, ThrowOnError> => (options.client ?? client).get<ReconciliationServiceGetDiscrepancyCaseResponses, ReconciliationServiceGetDiscrepancyCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns/{reconciliationRun}/discrepancyCases/{discrepancyCase}',
    ...options
});

/**
 * Assigns a case to an operator (`reconciliation:case.assign`)
 *
 * Assigns a case to an operator (`reconciliation:case.assign`).
 */
export const reconciliationServiceAssignDiscrepancy = <ThrowOnError extends boolean = false>(options: Options<ReconciliationServiceAssignDiscrepancyData, ThrowOnError>): RequestResult<ReconciliationServiceAssignDiscrepancyResponses, ReconciliationServiceAssignDiscrepancyErrors, ThrowOnError> => (options.client ?? client).post<ReconciliationServiceAssignDiscrepancyResponses, ReconciliationServiceAssignDiscrepancyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns/{reconciliationRun}/discrepancyCases/{discrepancyCase}:assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves or accepts a case (`reconciliation:case.resolve`)
 *
 * Resolves or accepts a case (`reconciliation:case.resolve`).
 */
export const reconciliationServiceResolveDiscrepancy = <ThrowOnError extends boolean = false>(options: Options<ReconciliationServiceResolveDiscrepancyData, ThrowOnError>): RequestResult<ReconciliationServiceResolveDiscrepancyResponses, ReconciliationServiceResolveDiscrepancyErrors, ThrowOnError> => (options.client ?? client).post<ReconciliationServiceResolveDiscrepancyResponses, ReconciliationServiceResolveDiscrepancyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns/{reconciliationRun}/discrepancyCases/{discrepancyCase}:resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports run evidence as a short-lived ZAsset reference
 *
 * Exports run evidence as a short-lived ZAsset reference
 * (`reconciliation:evidence.export`).
 */
export const reconciliationServiceExportEvidence = <ThrowOnError extends boolean = false>(options: Options<ReconciliationServiceExportEvidenceData, ThrowOnError>): RequestResult<ReconciliationServiceExportEvidenceResponses, ReconciliationServiceExportEvidenceErrors, ThrowOnError> => (options.client ?? client).post<ReconciliationServiceExportEvidenceResponses, ReconciliationServiceExportEvidenceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns/{reconciliationRun}:exportEvidence',
    ...options
});

/**
 * Starts a reconciliation run; idempotent per source/date/rule revision
 *
 * Starts a reconciliation run; idempotent per source/date/rule revision
 * (`reconciliation:run`).
 */
export const reconciliationServiceStartRun = <ThrowOnError extends boolean = false>(options: Options<ReconciliationServiceStartRunData, ThrowOnError>): RequestResult<ReconciliationServiceStartRunResponses, ReconciliationServiceStartRunErrors, ThrowOnError> => (options.client ?? client).post<ReconciliationServiceStartRunResponses, ReconciliationServiceStartRunErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reconciliation/reconciliationRuns:startRun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reads the aggregated review summary and rating distribution of one
 *
 * Reads the aggregated review summary and rating distribution of one
 * product (AIP-131).
 */
export const reviewServiceGetProductReviewSummary = <ThrowOnError extends boolean = false>(options: Options<ReviewServiceGetProductReviewSummaryData, ThrowOnError>): RequestResult<ReviewServiceGetProductReviewSummaryResponses, ReviewServiceGetProductReviewSummaryErrors, ThrowOnError> => (options.client ?? client).get<ReviewServiceGetProductReviewSummaryResponses, ReviewServiceGetProductReviewSummaryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/review/products/{product}/reviewSummary',
    ...options
});

/**
 * Lists published reviews for a product or store (AIP-132 / AIP-158)
 *
 * Lists published reviews for a product or store (AIP-132 / AIP-158).
 */
export const reviewServiceListReviews = <ThrowOnError extends boolean = false>(options?: Options<ReviewServiceListReviewsData, ThrowOnError>): RequestResult<ReviewServiceListReviewsResponses, ReviewServiceListReviewsErrors, ThrowOnError> => (options?.client ?? client).get<ReviewServiceListReviewsResponses, ReviewServiceListReviewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/review/reviews',
    ...options
});

/**
 * Submits a customer review for a verified completed order line
 *
 * Submits a customer review for a verified completed order line
 * (AIP-133).
 */
export const reviewServiceCreateReview = <ThrowOnError extends boolean = false>(options: Options<ReviewServiceCreateReviewData, ThrowOnError>): RequestResult<ReviewServiceCreateReviewResponses, ReviewServiceCreateReviewErrors, ThrowOnError> => (options.client ?? client).post<ReviewServiceCreateReviewResponses, ReviewServiceCreateReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/review/reviews',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reads one review by resource name (AIP-131)
 *
 * Reads one review by resource name (AIP-131).
 */
export const reviewServiceGetReview = <ThrowOnError extends boolean = false>(options: Options<ReviewServiceGetReviewData, ThrowOnError>): RequestResult<ReviewServiceGetReviewResponses, ReviewServiceGetReviewErrors, ThrowOnError> => (options.client ?? client).get<ReviewServiceGetReviewResponses, ReviewServiceGetReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/review/reviews/{review}',
    ...options
});

/**
 * Moderates a review (approve/reject) via AI agent or human moderator
 *
 * Moderates a review (approve/reject) via AI agent or human moderator
 * (AIP-136).
 */
export const reviewServiceModerateReview = <ThrowOnError extends boolean = false>(options: Options<ReviewServiceModerateReviewData, ThrowOnError>): RequestResult<ReviewServiceModerateReviewResponses, ReviewServiceModerateReviewErrors, ThrowOnError> => (options.client ?? client).post<ReviewServiceModerateReviewResponses, ReviewServiceModerateReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/review/reviews/{review}:moderate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Appends the merchant official reply to a review (AIP-136)
 *
 * Appends the merchant official reply to a review (AIP-136).
 */
export const reviewServiceReplyReview = <ThrowOnError extends boolean = false>(options: Options<ReviewServiceReplyReviewData, ThrowOnError>): RequestResult<ReviewServiceReplyReviewResponses, ReviewServiceReplyReviewErrors, ThrowOnError> => (options.client ?? client).post<ReviewServiceReplyReviewResponses, ReviewServiceReplyReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/review/reviews/{review}:reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves a case (`risk:case.resolve`)
 *
 * Resolves a case (`risk:case.resolve`).
 */
export const riskServiceResolveCase = <ThrowOnError extends boolean = false>(options: Options<RiskServiceResolveCaseData, ThrowOnError>): RequestResult<RiskServiceResolveCaseResponses, RiskServiceResolveCaseErrors, ThrowOnError> => (options.client ?? client).post<RiskServiceResolveCaseResponses, RiskServiceResolveCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/cases/{case}:resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Opens an investigation case (`risk:case.manage`)
 *
 * Opens an investigation case (`risk:case.manage`).
 */
export const riskServiceOpenCase = <ThrowOnError extends boolean = false>(options: Options<RiskServiceOpenCaseData, ThrowOnError>): RequestResult<RiskServiceOpenCaseResponses, RiskServiceOpenCaseErrors, ThrowOnError> => (options.client ?? client).post<RiskServiceOpenCaseResponses, RiskServiceOpenCaseErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/cases:openCase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's decisions in creation order, optionally
 *
 * Lists the caller tenant's decisions in creation order, optionally
 * filtered by source key (`risk:evaluate.checkout` or the action-specific
 * scope).
 */
export const riskServiceListRiskDecisions = <ThrowOnError extends boolean = false>(options?: Options<RiskServiceListRiskDecisionsData, ThrowOnError>): RequestResult<RiskServiceListRiskDecisionsResponses, RiskServiceListRiskDecisionsErrors, ThrowOnError> => (options?.client ?? client).get<RiskServiceListRiskDecisionsResponses, RiskServiceListRiskDecisionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/riskDecisions',
    ...options
});

/**
 * Reads one immutable decision (`risk:evaluate.checkout` or the
 *
 * Reads one immutable decision (`risk:evaluate.checkout` or the
 * action-specific scope).
 */
export const riskServiceGetRiskDecision = <ThrowOnError extends boolean = false>(options: Options<RiskServiceGetRiskDecisionData, ThrowOnError>): RequestResult<RiskServiceGetRiskDecisionResponses, RiskServiceGetRiskDecisionErrors, ThrowOnError> => (options.client ?? client).get<RiskServiceGetRiskDecisionResponses, RiskServiceGetRiskDecisionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/riskDecisions/{riskDecision}',
    ...options
});

/**
 * Evaluates checkout under the active rule set
 *
 * Evaluates checkout under the active rule set
 * (`risk:evaluate.checkout`).
 */
export const riskServiceEvaluateCheckout = <ThrowOnError extends boolean = false>(options: Options<RiskServiceEvaluateCheckoutData, ThrowOnError>): RequestResult<RiskServiceEvaluateCheckoutResponses, RiskServiceEvaluateCheckoutErrors, ThrowOnError> => (options.client ?? client).post<RiskServiceEvaluateCheckoutResponses, RiskServiceEvaluateCheckoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/riskDecisions:evaluateCheckout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Evaluates payment capture (`risk:evaluate.payment`)
 *
 * Evaluates payment capture (`risk:evaluate.payment`).
 */
export const riskServiceEvaluatePayment = <ThrowOnError extends boolean = false>(options: Options<RiskServiceEvaluatePaymentData, ThrowOnError>): RequestResult<RiskServiceEvaluatePaymentResponses, RiskServiceEvaluatePaymentErrors, ThrowOnError> => (options.client ?? client).post<RiskServiceEvaluatePaymentResponses, RiskServiceEvaluatePaymentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/riskDecisions:evaluatePayment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Evaluates settlement payout (`risk:evaluate.payout`)
 *
 * Evaluates settlement payout (`risk:evaluate.payout`).
 */
export const riskServiceEvaluatePayout = <ThrowOnError extends boolean = false>(options: Options<RiskServiceEvaluatePayoutData, ThrowOnError>): RequestResult<RiskServiceEvaluatePayoutResponses, RiskServiceEvaluatePayoutErrors, ThrowOnError> => (options.client ?? client).post<RiskServiceEvaluatePayoutResponses, RiskServiceEvaluatePayoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/riskDecisions:evaluatePayout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Evaluates refund (M1) (`risk:evaluate.refund`)
 *
 * Evaluates refund (M1) (`risk:evaluate.refund`).
 */
export const riskServiceEvaluateRefund = <ThrowOnError extends boolean = false>(options: Options<RiskServiceEvaluateRefundData, ThrowOnError>): RequestResult<RiskServiceEvaluateRefundResponses, RiskServiceEvaluateRefundErrors, ThrowOnError> => (options.client ?? client).post<RiskServiceEvaluateRefundResponses, RiskServiceEvaluateRefundErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/riskDecisions:evaluateRefund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publishes an immutable rule set version (`risk:rule.publish`)
 *
 * Publishes an immutable rule set version (`risk:rule.publish`).
 */
export const riskServicePublishRuleSet = <ThrowOnError extends boolean = false>(options: Options<RiskServicePublishRuleSetData, ThrowOnError>): RequestResult<RiskServicePublishRuleSetResponses, RiskServicePublishRuleSetErrors, ThrowOnError> => (options.client ?? client).post<RiskServicePublishRuleSetResponses, RiskServicePublishRuleSetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/risk/ruleSets:publishRuleSet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's payout instructions in creation order,
 *
 * Lists the caller tenant's payout instructions in creation order,
 * optionally filtered by payout source key (`settlement:payout`).
 */
export const settlementServiceListPayoutInstructions = <ThrowOnError extends boolean = false>(options?: Options<SettlementServiceListPayoutInstructionsData, ThrowOnError>): RequestResult<SettlementServiceListPayoutInstructionsResponses, SettlementServiceListPayoutInstructionsErrors, ThrowOnError> => (options?.client ?? client).get<SettlementServiceListPayoutInstructionsResponses, SettlementServiceListPayoutInstructionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/payoutInstructions',
    ...options
});

/**
 * Reads one payout instruction (`settlement:payout`)
 *
 * Reads one payout instruction (`settlement:payout`).
 */
export const settlementServiceGetPayoutInstruction = <ThrowOnError extends boolean = false>(options: Options<SettlementServiceGetPayoutInstructionData, ThrowOnError>): RequestResult<SettlementServiceGetPayoutInstructionResponses, SettlementServiceGetPayoutInstructionErrors, ThrowOnError> => (options.client ?? client).get<SettlementServiceGetPayoutInstructionResponses, SettlementServiceGetPayoutInstructionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/payoutInstructions/{payoutInstruction}',
    ...options
});

/**
 * Requests a Pay payout for an approved batch (`settlement:payout`)
 *
 * Requests a Pay payout for an approved batch (`settlement:payout`).
 */
export const settlementServiceRequestPayout = <ThrowOnError extends boolean = false>(options: Options<SettlementServiceRequestPayoutData, ThrowOnError>): RequestResult<SettlementServiceRequestPayoutResponses, SettlementServiceRequestPayoutErrors, ThrowOnError> => (options.client ?? client).post<SettlementServiceRequestPayoutResponses, SettlementServiceRequestPayoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/payoutInstructions:requestPayout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approves statements into a batch (`settlement:approve`)
 *
 * Approves statements into a batch (`settlement:approve`).
 */
export const settlementServiceApproveBatch = <ThrowOnError extends boolean = false>(options: Options<SettlementServiceApproveBatchData, ThrowOnError>): RequestResult<SettlementServiceApproveBatchResponses, SettlementServiceApproveBatchErrors, ThrowOnError> => (options.client ?? client).post<SettlementServiceApproveBatchResponses, SettlementServiceApproveBatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/settlementBatches:approveBatch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publishes an immutable policy version (`settlement:calculate`)
 *
 * Publishes an immutable policy version (`settlement:calculate`).
 */
export const settlementServicePublishPolicyVersion = <ThrowOnError extends boolean = false>(options: Options<SettlementServicePublishPolicyVersionData, ThrowOnError>): RequestResult<SettlementServicePublishPolicyVersionResponses, SettlementServicePublishPolicyVersionErrors, ThrowOnError> => (options.client ?? client).post<SettlementServicePublishPolicyVersionResponses, SettlementServicePublishPolicyVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/settlementPolicyVersions:publishPolicyVersion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's statements in creation order
 *
 * Lists the caller tenant's statements in creation order
 * (`settlement:calculate/read`).
 */
export const settlementServiceListSettlementStatements = <ThrowOnError extends boolean = false>(options?: Options<SettlementServiceListSettlementStatementsData, ThrowOnError>): RequestResult<SettlementServiceListSettlementStatementsResponses, SettlementServiceListSettlementStatementsErrors, ThrowOnError> => (options?.client ?? client).get<SettlementServiceListSettlementStatementsResponses, SettlementServiceListSettlementStatementsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/settlementStatements',
    ...options
});

/**
 * Reads one statement (`settlement:calculate/read`)
 *
 * Reads one statement (`settlement:calculate/read`).
 */
export const settlementServiceGetSettlementStatement = <ThrowOnError extends boolean = false>(options: Options<SettlementServiceGetSettlementStatementData, ThrowOnError>): RequestResult<SettlementServiceGetSettlementStatementResponses, SettlementServiceGetSettlementStatementErrors, ThrowOnError> => (options.client ?? client).get<SettlementServiceGetSettlementStatementResponses, SettlementServiceGetSettlementStatementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/settlementStatements/{settlementStatement}',
    ...options
});

/**
 * Holds a statement (`settlement:hold`)
 *
 * Holds a statement (`settlement:hold`).
 */
export const settlementServiceHoldStatement = <ThrowOnError extends boolean = false>(options: Options<SettlementServiceHoldStatementData, ThrowOnError>): RequestResult<SettlementServiceHoldStatementResponses, SettlementServiceHoldStatementErrors, ThrowOnError> => (options.client ?? client).post<SettlementServiceHoldStatementResponses, SettlementServiceHoldStatementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/settlementStatements/{settlementStatement}:hold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Releases a held statement (`settlement:hold`)
 *
 * Releases a held statement (`settlement:hold`).
 */
export const settlementServiceReleaseStatement = <ThrowOnError extends boolean = false>(options: Options<SettlementServiceReleaseStatementData, ThrowOnError>): RequestResult<SettlementServiceReleaseStatementResponses, SettlementServiceReleaseStatementErrors, ThrowOnError> => (options.client ?? client).post<SettlementServiceReleaseStatementResponses, SettlementServiceReleaseStatementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/settlementStatements/{settlementStatement}:release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Calculates statements for one window from Clearing evidence
 *
 * Calculates statements for one window from Clearing evidence
 * (`settlement:calculate`).
 */
export const settlementServiceCalculateWindow = <ThrowOnError extends boolean = false>(options: Options<SettlementServiceCalculateWindowData, ThrowOnError>): RequestResult<SettlementServiceCalculateWindowResponses, SettlementServiceCalculateWindowErrors, ThrowOnError> => (options.client ?? client).post<SettlementServiceCalculateWindowResponses, SettlementServiceCalculateWindowErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settlement/settlementWindows:calculateWindow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a new store under a merchant (AIP-133)
 *
 * Create a new store under a merchant (AIP-133).
 */
export const storeServiceCreateStore = <ThrowOnError extends boolean = false>(options: Options<StoreServiceCreateStoreData, ThrowOnError>): RequestResult<StoreServiceCreateStoreResponses, StoreServiceCreateStoreErrors, ThrowOnError> => (options.client ?? client).post<StoreServiceCreateStoreResponses, StoreServiceCreateStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/merchants/{merchant}/stores',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List stores with filtering and pagination (AIP-132 / AIP-158). Scope to one
 *
 * List stores with filtering and pagination (AIP-132 / AIP-158). Scope to one
 * merchant by passing the `parent` query parameter.
 */
export const storeServiceListStores = <ThrowOnError extends boolean = false>(options?: Options<StoreServiceListStoresData, ThrowOnError>): RequestResult<StoreServiceListStoresResponses, StoreServiceListStoresErrors, ThrowOnError> => (options?.client ?? client).get<StoreServiceListStoresResponses, StoreServiceListStoresErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores',
    ...options
});

/**
 * Get store by resource name (AIP-131)
 *
 * Get store by resource name (AIP-131).
 */
export const storeServiceGetStore = <ThrowOnError extends boolean = false>(options: Options<StoreServiceGetStoreData, ThrowOnError>): RequestResult<StoreServiceGetStoreResponses, StoreServiceGetStoreErrors, ThrowOnError> => (options.client ?? client).get<StoreServiceGetStoreResponses, StoreServiceGetStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}',
    ...options
});

/**
 * Partially update store details (AIP-134)
 *
 * Partially update store details (AIP-134).
 */
export const storeServiceUpdateStore = <ThrowOnError extends boolean = false>(options: Options<StoreServiceUpdateStoreData, ThrowOnError>): RequestResult<StoreServiceUpdateStoreResponses, StoreServiceUpdateStoreErrors, ThrowOnError> => (options.client ?? client).patch<StoreServiceUpdateStoreResponses, StoreServiceUpdateStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Configure a channel for a store
 *
 * Configure a channel for a store.
 */
export const storeServiceConfigureChannel = <ThrowOnError extends boolean = false>(options: Options<StoreServiceConfigureChannelData, ThrowOnError>): RequestResult<StoreServiceConfigureChannelResponses, StoreServiceConfigureChannelErrors, ThrowOnError> => (options.client ?? client).post<StoreServiceConfigureChannelResponses, StoreServiceConfigureChannelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}/channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply or update a store policy override revision (AIP-136 / Custom Resource)
 *
 * Apply or update a store policy override revision (AIP-136 / Custom Resource).
 */
export const storeServiceApplyPolicyOverride = <ThrowOnError extends boolean = false>(options: Options<StoreServiceApplyPolicyOverrideData, ThrowOnError>): RequestResult<StoreServiceApplyPolicyOverrideResponses, StoreServiceApplyPolicyOverrideErrors, ThrowOnError> => (options.client ?? client).post<StoreServiceApplyPolicyOverrideResponses, StoreServiceApplyPolicyOverrideErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}/policyOverrides',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate a DRAFT store after policy and qualification checks (AIP-136 Custom Method)
 *
 * Activate a DRAFT store after policy and qualification checks (AIP-136 Custom Method).
 */
export const storeServiceActivateStore = <ThrowOnError extends boolean = false>(options: Options<StoreServiceActivateStoreData, ThrowOnError>): RequestResult<StoreServiceActivateStoreResponses, StoreServiceActivateStoreErrors, ThrowOnError> => (options.client ?? client).post<StoreServiceActivateStoreResponses, StoreServiceActivateStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}:activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gracefully close store (AIP-136 Custom Method)
 *
 * Gracefully close store (AIP-136 Custom Method).
 */
export const storeServiceCloseStore = <ThrowOnError extends boolean = false>(options: Options<StoreServiceCloseStoreData, ThrowOnError>): RequestResult<StoreServiceCloseStoreResponses, StoreServiceCloseStoreErrors, ThrowOnError> => (options.client ?? client).post<StoreServiceCloseStoreResponses, StoreServiceCloseStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}:close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pause store operations temporarily (AIP-136 Custom Method)
 *
 * Pause store operations temporarily (AIP-136 Custom Method).
 */
export const storeServicePauseStore = <ThrowOnError extends boolean = false>(options: Options<StoreServicePauseStoreData, ThrowOnError>): RequestResult<StoreServicePauseStoreResponses, StoreServicePauseStoreErrors, ThrowOnError> => (options.client ?? client).post<StoreServicePauseStoreResponses, StoreServicePauseStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}:pause',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume paused store operations back to ACTIVE (AIP-136 Custom Method)
 *
 * Resume paused store operations back to ACTIVE (AIP-136 Custom Method).
 */
export const storeServiceResumeStore = <ThrowOnError extends boolean = false>(options: Options<StoreServiceResumeStoreData, ThrowOnError>): RequestResult<StoreServiceResumeStoreResponses, StoreServiceResumeStoreErrors, ThrowOnError> => (options.client ?? client).post<StoreServiceResumeStoreResponses, StoreServiceResumeStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}:resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Emergency suspend store operations (AIP-136 Custom Method)
 *
 * Emergency suspend store operations (AIP-136 Custom Method).
 */
export const storeServiceSuspendStore = <ThrowOnError extends boolean = false>(options: Options<StoreServiceSuspendStoreData, ThrowOnError>): RequestResult<StoreServiceSuspendStoreResponses, StoreServiceSuspendStoreErrors, ThrowOnError> => (options.client ?? client).post<StoreServiceSuspendStoreResponses, StoreServiceSuspendStoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/store/stores/{store}:suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves a request host or store slug into a signed, short-lived
 *
 * Resolves a request host or store slug into a signed, short-lived
 * StoreContext. Unknown or inactive stores return NOT_FOUND; suspended
 * stores resolve with `store_state = SUSPENDED` so the consumer can
 * render a safe notice instead of catalog data.
 */
export const storefrontServiceResolveStoreContext = <ThrowOnError extends boolean = false>(options?: Options<StorefrontServiceResolveStoreContextData, ThrowOnError>): RequestResult<StorefrontServiceResolveStoreContextResponses, StorefrontServiceResolveStoreContextErrors, ThrowOnError> => (options?.client ?? client).get<StorefrontServiceResolveStoreContextResponses, StorefrontServiceResolveStoreContextErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/storefront/storeContexts:resolveStoreContext',
    ...options
});

/**
 * Returns the composed store-home projection: store description,
 *
 * Returns the composed store-home projection: store description,
 * category cards and featured offer cards. Fragments degrade
 * independently; price facts on offer cards are display hints, never
 * payable totals.
 */
export const storefrontServiceOpenStorefrontHome = <ThrowOnError extends boolean = false>(options: Options<StorefrontServiceOpenStorefrontHomeData, ThrowOnError>): RequestResult<StorefrontServiceOpenStorefrontHomeResponses, StorefrontServiceOpenStorefrontHomeErrors, ThrowOnError> => (options.client ?? client).get<StorefrontServiceOpenStorefrontHomeResponses, StorefrontServiceOpenStorefrontHomeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/storefront/stores/{store}/home:open',
    ...options
});

/**
 * Returns the PDP projection for one offer. Price and availability are
 *
 * Returns the PDP projection for one offer. Price and availability are
 * hard-required fragments: when either is DEGRADED the consumer must
 * render the degraded state and must not invent price or stock values.
 */
export const storefrontServiceOpenOfferView = <ThrowOnError extends boolean = false>(options: Options<StorefrontServiceOpenOfferViewData, ThrowOnError>): RequestResult<StorefrontServiceOpenOfferViewResponses, StorefrontServiceOpenOfferViewErrors, ThrowOnError> => (options.client ?? client).get<StorefrontServiceOpenOfferViewResponses, StorefrontServiceOpenOfferViewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/storefront/stores/{store}/offers/{offer}/view:open',
    ...options
});

/**
 * Issues an immutable credit note reversing one invoice
 *
 * Issues an immutable credit note reversing one invoice
 * (`tax:invoice`).
 */
export const taxServiceIssueCreditNote = <ThrowOnError extends boolean = false>(options: Options<TaxServiceIssueCreditNoteData, ThrowOnError>): RequestResult<TaxServiceIssueCreditNoteResponses, TaxServiceIssueCreditNoteErrors, ThrowOnError> => (options.client ?? client).post<TaxServiceIssueCreditNoteResponses, TaxServiceIssueCreditNoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/creditNotes:issueCreditNote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issues an immutable invoice for a finalized transaction
 *
 * Issues an immutable invoice for a finalized transaction
 * (`tax:invoice`); body lives in ZAsset.
 */
export const taxServiceIssueInvoice = <ThrowOnError extends boolean = false>(options: Options<TaxServiceIssueInvoiceData, ThrowOnError>): RequestResult<TaxServiceIssueInvoiceResponses, TaxServiceIssueInvoiceErrors, ThrowOnError> => (options.client ?? client).post<TaxServiceIssueInvoiceResponses, TaxServiceIssueInvoiceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/invoices:issueInvoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pure deterministic determination over registrations and rule versions
 *
 * Pure deterministic determination over registrations and rule versions
 * (`tax:calculate`); freezes inputs, rates and liability.
 */
export const taxServiceCalculateTax = <ThrowOnError extends boolean = false>(options: Options<TaxServiceCalculateTaxData, ThrowOnError>): RequestResult<TaxServiceCalculateTaxResponses, TaxServiceCalculateTaxErrors, ThrowOnError> => (options.client ?? client).post<TaxServiceCalculateTaxResponses, TaxServiceCalculateTaxErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/taxQuotes:calculateTax',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates or updates a seller registration (`tax:registration.manage`)
 *
 * Creates or updates a seller registration (`tax:registration.manage`).
 */
export const taxServiceUpsertRegistration = <ThrowOnError extends boolean = false>(options: Options<TaxServiceUpsertRegistrationData, ThrowOnError>): RequestResult<TaxServiceUpsertRegistrationResponses, TaxServiceUpsertRegistrationErrors, ThrowOnError> => (options.client ?? client).post<TaxServiceUpsertRegistrationResponses, TaxServiceUpsertRegistrationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/taxRegistrations:upsertRegistration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publishes an immutable rule version (`tax:rule.publish`)
 *
 * Publishes an immutable rule version (`tax:rule.publish`).
 */
export const taxServicePublishRuleVersion = <ThrowOnError extends boolean = false>(options: Options<TaxServicePublishRuleVersionData, ThrowOnError>): RequestResult<TaxServicePublishRuleVersionResponses, TaxServicePublishRuleVersionErrors, ThrowOnError> => (options.client ?? client).post<TaxServicePublishRuleVersionResponses, TaxServicePublishRuleVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/taxRuleVersions:publishRuleVersion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the caller tenant's finalized transactions in creation order,
 *
 * Lists the caller tenant's finalized transactions in creation order,
 * optionally filtered by source key (`tax:finalize`).
 */
export const taxServiceListTaxTransactions = <ThrowOnError extends boolean = false>(options?: Options<TaxServiceListTaxTransactionsData, ThrowOnError>): RequestResult<TaxServiceListTaxTransactionsResponses, TaxServiceListTaxTransactionsErrors, ThrowOnError> => (options?.client ?? client).get<TaxServiceListTaxTransactionsResponses, TaxServiceListTaxTransactionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/taxTransactions',
    ...options
});

/**
 * Reads one finalized transaction (`tax:finalize`)
 *
 * Reads one finalized transaction (`tax:finalize`).
 */
export const taxServiceGetTaxTransaction = <ThrowOnError extends boolean = false>(options: Options<TaxServiceGetTaxTransactionData, ThrowOnError>): RequestResult<TaxServiceGetTaxTransactionResponses, TaxServiceGetTaxTransactionErrors, ThrowOnError> => (options.client ?? client).get<TaxServiceGetTaxTransactionResponses, TaxServiceGetTaxTransactionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/taxTransactions/{taxTransaction}',
    ...options
});

/**
 * Finalizes a quote against a paid Trade source
 *
 * Finalizes a quote against a paid Trade source
 * (`tax:finalize`, source-idempotent).
 */
export const taxServiceFinalizeTaxTransaction = <ThrowOnError extends boolean = false>(options: Options<TaxServiceFinalizeTaxTransactionData, ThrowOnError>): RequestResult<TaxServiceFinalizeTaxTransactionResponses, TaxServiceFinalizeTaxTransactionErrors, ThrowOnError> => (options.client ?? client).post<TaxServiceFinalizeTaxTransactionResponses, TaxServiceFinalizeTaxTransactionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tax/taxTransactions:finalizeTaxTransaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists notification templates with cursor pagination (AIP-132, AIP-158)
 *
 * Lists notification templates with cursor pagination (AIP-132, AIP-158).
 */
export const notificationServiceListTemplates = <ThrowOnError extends boolean = false>(options?: Options<NotificationServiceListTemplatesData, ThrowOnError>): RequestResult<NotificationServiceListTemplatesResponses, NotificationServiceListTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<NotificationServiceListTemplatesResponses, NotificationServiceListTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates',
    ...options
});

/**
 * Creates a notification template (AIP-133)
 *
 * Creates a notification template (AIP-133).
 */
export const notificationServiceCreateTemplate = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceCreateTemplateData, ThrowOnError>): RequestResult<NotificationServiceCreateTemplateResponses, NotificationServiceCreateTemplateErrors, ThrowOnError> => (options.client ?? client).post<NotificationServiceCreateTemplateResponses, NotificationServiceCreateTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes / archives a template (AIP-135)
 *
 * Deletes / archives a template (AIP-135).
 */
export const notificationServiceDeleteTemplate = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceDeleteTemplateData, ThrowOnError>): RequestResult<NotificationServiceDeleteTemplateResponses, NotificationServiceDeleteTemplateErrors, ThrowOnError> => (options.client ?? client).delete<NotificationServiceDeleteTemplateResponses, NotificationServiceDeleteTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template}',
    ...options
});

/**
 * Retrieves a notification template by resource name (AIP-131)
 *
 * Retrieves a notification template by resource name (AIP-131).
 */
export const notificationServiceGetTemplate = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceGetTemplateData, ThrowOnError>): RequestResult<NotificationServiceGetTemplateResponses, NotificationServiceGetTemplateErrors, ThrowOnError> => (options.client ?? client).get<NotificationServiceGetTemplateResponses, NotificationServiceGetTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template}',
    ...options
});

/**
 * Updates a notification template (AIP-134)
 *
 * Updates a notification template (AIP-134).
 */
export const notificationServiceUpdateTemplate = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceUpdateTemplateData, ThrowOnError>): RequestResult<NotificationServiceUpdateTemplateResponses, NotificationServiceUpdateTemplateErrors, ThrowOnError> => (options.client ?? client).patch<NotificationServiceUpdateTemplateResponses, NotificationServiceUpdateTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates an immutable template version (AIP-133)
 *
 * Creates an immutable template version (AIP-133).
 */
export const notificationServiceCreateTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceCreateTemplateVersionData, ThrowOnError>): RequestResult<NotificationServiceCreateTemplateVersionResponses, NotificationServiceCreateTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<NotificationServiceCreateTemplateVersionResponses, NotificationServiceCreateTemplateVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves an immutable template version by resource name (AIP-131)
 *
 * Retrieves an immutable template version by resource name (AIP-131).
 */
export const notificationServiceGetTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceGetTemplateVersionData, ThrowOnError>): RequestResult<NotificationServiceGetTemplateVersionResponses, NotificationServiceGetTemplateVersionErrors, ThrowOnError> => (options.client ?? client).get<NotificationServiceGetTemplateVersionResponses, NotificationServiceGetTemplateVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template}/versions/{version}',
    ...options
});

/**
 * Publishes an immutable template version as active (AIP-136)
 *
 * Publishes an immutable template version as active (AIP-136).
 */
export const notificationServicePublishTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<NotificationServicePublishTemplateVersionData, ThrowOnError>): RequestResult<NotificationServicePublishTemplateVersionResponses, NotificationServicePublishTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<NotificationServicePublishTemplateVersionResponses, NotificationServicePublishTemplateVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template}/versions/{version}:publish',
    ...options
});

/**
 * Renders a template with provided variables for preview (AIP-136)
 *
 * Renders a template with provided variables for preview (AIP-136).
 */
export const notificationServicePreviewTemplate = <ThrowOnError extends boolean = false>(options: Options<NotificationServicePreviewTemplateData, ThrowOnError>): RequestResult<NotificationServicePreviewTemplateResponses, NotificationServicePreviewTemplateErrors, ThrowOnError> => (options.client ?? client).post<NotificationServicePreviewTemplateResponses, NotificationServicePreviewTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template}:preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List tenants with pagination and filtering (AIP-132 / AIP-158)
 *
 * List tenants with pagination and filtering (AIP-132 / AIP-158).
 */
export const tenantServiceListTenants = <ThrowOnError extends boolean = false>(options?: Options<TenantServiceListTenantsData, ThrowOnError>): RequestResult<TenantServiceListTenantsResponses, TenantServiceListTenantsErrors, ThrowOnError> => (options?.client ?? client).get<TenantServiceListTenantsResponses, TenantServiceListTenantsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants',
    ...options
});

/**
 * Create a new tenant with initial provisioning state (AIP-133)
 *
 * Create a new tenant with initial provisioning state (AIP-133).
 */
export const tenantServiceCreateTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceCreateTenantData, ThrowOnError>): RequestResult<TenantServiceCreateTenantResponses, TenantServiceCreateTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceCreateTenantResponses, TenantServiceCreateTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get tenant by resource name (AIP-131)
 *
 * Get tenant by resource name (AIP-131).
 */
export const tenantServiceGetTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceGetTenantData, ThrowOnError>): RequestResult<TenantServiceGetTenantResponses, TenantServiceGetTenantErrors, ThrowOnError> => (options.client ?? client).get<TenantServiceGetTenantResponses, TenantServiceGetTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}',
    ...options
});

/**
 * Partially update mutable tenant metadata (AIP-134)
 *
 * Partially update mutable tenant metadata (AIP-134).
 */
export const tenantServiceUpdateTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceUpdateTenantData, ThrowOnError>): RequestResult<TenantServiceUpdateTenantResponses, TenantServiceUpdateTenantErrors, ThrowOnError> => (options.client ?? client).patch<TenantServiceUpdateTenantResponses, TenantServiceUpdateTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List policy versions for a tenant (AIP-132 / AIP-158)
 *
 * List policy versions for a tenant (AIP-132 / AIP-158).
 */
export const tenantServiceListPolicyVersions = <ThrowOnError extends boolean = false>(options: Options<TenantServiceListPolicyVersionsData, ThrowOnError>): RequestResult<TenantServiceListPolicyVersionsResponses, TenantServiceListPolicyVersionsErrors, ThrowOnError> => (options.client ?? client).get<TenantServiceListPolicyVersionsResponses, TenantServiceListPolicyVersionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}/policies',
    ...options
});

/**
 * Create a new Draft policy version under a tenant (AIP-133)
 *
 * Create a new Draft policy version under a tenant (AIP-133).
 */
export const tenantServiceCreatePolicyVersion = <ThrowOnError extends boolean = false>(options: Options<TenantServiceCreatePolicyVersionData, ThrowOnError>): RequestResult<TenantServiceCreatePolicyVersionResponses, TenantServiceCreatePolicyVersionErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceCreatePolicyVersionResponses, TenantServiceCreatePolicyVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}/policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a specific policy version by resource name (AIP-131)
 *
 * Get a specific policy version by resource name (AIP-131).
 */
export const tenantServiceGetPolicyVersion = <ThrowOnError extends boolean = false>(options: Options<TenantServiceGetPolicyVersionData, ThrowOnError>): RequestResult<TenantServiceGetPolicyVersionResponses, TenantServiceGetPolicyVersionErrors, ThrowOnError> => (options.client ?? client).get<TenantServiceGetPolicyVersionResponses, TenantServiceGetPolicyVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}/policies/{policy}',
    ...options
});

/**
 * Atomically activate a validated policy version (AIP-136 Custom Method)
 *
 * Atomically activate a validated policy version (AIP-136 Custom Method).
 */
export const tenantServiceActivatePolicyVersion = <ThrowOnError extends boolean = false>(options: Options<TenantServiceActivatePolicyVersionData, ThrowOnError>): RequestResult<TenantServiceActivatePolicyVersionResponses, TenantServiceActivatePolicyVersionErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceActivatePolicyVersionResponses, TenantServiceActivatePolicyVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}/policies/{policy}:activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch get or list quota allocations for tenant
 *
 * Batch get or list quota allocations for tenant.
 */
export const tenantServiceListQuotas = <ThrowOnError extends boolean = false>(options: Options<TenantServiceListQuotasData, ThrowOnError>): RequestResult<TenantServiceListQuotasResponses, TenantServiceListQuotasErrors, ThrowOnError> => (options.client ?? client).get<TenantServiceListQuotasResponses, TenantServiceListQuotasErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}/quotas',
    ...options
});

/**
 * Initiate tenant decommissioning and graceful closure (AIP-136 Custom Method)
 *
 * Initiate tenant decommissioning and graceful closure (AIP-136 Custom Method).
 */
export const tenantServiceCloseTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceCloseTenantData, ThrowOnError>): RequestResult<TenantServiceCloseTenantResponses, TenantServiceCloseTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceCloseTenantResponses, TenantServiceCloseTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}:close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume suspended tenant back to ACTIVE state (AIP-136 Custom Method)
 *
 * Resume suspended tenant back to ACTIVE state (AIP-136 Custom Method).
 */
export const tenantServiceResumeTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceResumeTenantData, ThrowOnError>): RequestResult<TenantServiceResumeTenantResponses, TenantServiceResumeTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceResumeTenantResponses, TenantServiceResumeTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}:resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suspend tenant due to risk or compliance actions (AIP-136 Custom Method)
 *
 * Suspend tenant due to risk or compliance actions (AIP-136 Custom Method).
 */
export const tenantServiceSuspendTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceSuspendTenantData, ThrowOnError>): RequestResult<TenantServiceSuspendTenantResponses, TenantServiceSuspendTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceSuspendTenantResponses, TenantServiceSuspendTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tenant/tenants/{tenant}:suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 列出 Todos
 *
 * 列出 Todos
 */
export const todoServiceListTodos = <ThrowOnError extends boolean = false>(options?: Options<TodoServiceListTodosData, ThrowOnError>): RequestResult<TodoServiceListTodosResponses, TodoServiceListTodosErrors, ThrowOnError> => (options?.client ?? client).get<TodoServiceListTodosResponses, TodoServiceListTodosErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos',
    ...options
});

/**
 * 创建 Todo - 成功返回 Todo 对象
 *
 * 创建 Todo - 成功返回 Todo 对象
 */
export const todoServiceCreateTodo = <ThrowOnError extends boolean = false>(options: Options<TodoServiceCreateTodoData, ThrowOnError>): RequestResult<TodoServiceCreateTodoResponses, TodoServiceCreateTodoErrors, ThrowOnError> => (options.client ?? client).post<TodoServiceCreateTodoResponses, TodoServiceCreateTodoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 批量更新
 *
 * 批量更新
 */
export const todoServiceBatchUpdateTodos = <ThrowOnError extends boolean = false>(options: Options<TodoServiceBatchUpdateTodosData, ThrowOnError>): RequestResult<TodoServiceBatchUpdateTodosResponses, TodoServiceBatchUpdateTodosErrors, ThrowOnError> => (options.client ?? client).post<TodoServiceBatchUpdateTodosResponses, TodoServiceBatchUpdateTodosErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 删除 Todo
 *
 * 删除 Todo
 */
export const todoServiceDeleteTodo = <ThrowOnError extends boolean = false>(options: Options<TodoServiceDeleteTodoData, ThrowOnError>): RequestResult<TodoServiceDeleteTodoResponses, TodoServiceDeleteTodoErrors, ThrowOnError> => (options.client ?? client).delete<TodoServiceDeleteTodoResponses, TodoServiceDeleteTodoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{id}',
    ...options
});

/**
 * 获取 Todo
 *
 * 获取 Todo
 */
export const todoServiceGetTodo = <ThrowOnError extends boolean = false>(options: Options<TodoServiceGetTodoData, ThrowOnError>): RequestResult<TodoServiceGetTodoResponses, TodoServiceGetTodoErrors, ThrowOnError> => (options.client ?? client).get<TodoServiceGetTodoResponses, TodoServiceGetTodoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{id}',
    ...options
});

/**
 * 更新 Todo — PATCH partial update (spec D12)
 *
 * 更新 Todo — PATCH partial update (spec D12).
 */
export const todoServiceUpdateTodo = <ThrowOnError extends boolean = false>(options: Options<TodoServiceUpdateTodoData, ThrowOnError>): RequestResult<TodoServiceUpdateTodoResponses, TodoServiceUpdateTodoErrors, ThrowOnError> => (options.client ?? client).patch<TodoServiceUpdateTodoResponses, TodoServiceUpdateTodoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * M3: 指派 Todo（owner-only, spec 14-collaboration §2.4）
 *
 * M3: 指派 Todo（owner-only, spec 14-collaboration §2.4）
 */
export const todoServiceAssignTodo = <ThrowOnError extends boolean = false>(options: Options<TodoServiceAssignTodoData, ThrowOnError>): RequestResult<TodoServiceAssignTodoResponses, TodoServiceAssignTodoErrors, ThrowOnError> => (options.client ?? client).post<TodoServiceAssignTodoResponses, TodoServiceAssignTodoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{id}:assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * M3: 取消指派（owner-only）
 *
 * M3: 取消指派（owner-only）
 */
export const todoServiceUnassignTodo = <ThrowOnError extends boolean = false>(options: Options<TodoServiceUnassignTodoData, ThrowOnError>): RequestResult<TodoServiceUnassignTodoResponses, TodoServiceUnassignTodoErrors, ThrowOnError> => (options.client ?? client).post<TodoServiceUnassignTodoResponses, TodoServiceUnassignTodoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{id}:unassign',
    ...options
});

/**
 * M3: 活动时间线
 *
 * M3: 活动时间线
 */
export const todoServiceListActivity = <ThrowOnError extends boolean = false>(options: Options<TodoServiceListActivityData, ThrowOnError>): RequestResult<TodoServiceListActivityResponses, TodoServiceListActivityErrors, ThrowOnError> => (options.client ?? client).get<TodoServiceListActivityResponses, TodoServiceListActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{todoId}/activity',
    ...options
});

/**
 * M3: 列出评论
 *
 * M3: 列出评论
 */
export const todoServiceListComments = <ThrowOnError extends boolean = false>(options: Options<TodoServiceListCommentsData, ThrowOnError>): RequestResult<TodoServiceListCommentsResponses, TodoServiceListCommentsErrors, ThrowOnError> => (options.client ?? client).get<TodoServiceListCommentsResponses, TodoServiceListCommentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{todoId}/comments',
    ...options
});

/**
 * M3: 创建评论
 *
 * M3: 创建评论
 */
export const todoServiceCreateComment = <ThrowOnError extends boolean = false>(options: Options<TodoServiceCreateCommentData, ThrowOnError>): RequestResult<TodoServiceCreateCommentResponses, TodoServiceCreateCommentErrors, ThrowOnError> => (options.client ?? client).post<TodoServiceCreateCommentResponses, TodoServiceCreateCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{todoId}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * M3: 删除评论（author or todo owner）
 *
 * M3: 删除评论（author or todo owner）
 */
export const todoServiceDeleteComment = <ThrowOnError extends boolean = false>(options: Options<TodoServiceDeleteCommentData, ThrowOnError>): RequestResult<TodoServiceDeleteCommentResponses, TodoServiceDeleteCommentErrors, ThrowOnError> => (options.client ?? client).delete<TodoServiceDeleteCommentResponses, TodoServiceDeleteCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{todoId}/comments/{commentId}',
    ...options
});

/**
 * M3: 更新评论（author-only）
 *
 * M3: 更新评论（author-only）
 */
export const todoServiceUpdateComment = <ThrowOnError extends boolean = false>(options: Options<TodoServiceUpdateCommentData, ThrowOnError>): RequestResult<TodoServiceUpdateCommentResponses, TodoServiceUpdateCommentErrors, ThrowOnError> => (options.client ?? client).patch<TodoServiceUpdateCommentResponses, TodoServiceUpdateCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/todos/{todoId}/comments/{commentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Internal adapter: applies an Order fact (workload identity + inbox)
 *
 * Internal adapter: applies an Order fact (workload identity + inbox).
 */
export const tradeServiceApplyOrderFact = <ThrowOnError extends boolean = false>(options: Options<TradeServiceApplyOrderFactData, ThrowOnError>): RequestResult<TradeServiceApplyOrderFactResponses, TradeServiceApplyOrderFactErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceApplyOrderFactResponses, TradeServiceApplyOrderFactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/facts:applyOrderFact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Internal adapter: applies a Pay fact (workload identity + inbox)
 *
 * Internal adapter: applies a Pay fact (workload identity + inbox).
 */
export const tradeServiceApplyPaymentFact = <ThrowOnError extends boolean = false>(options: Options<TradeServiceApplyPaymentFactData, ThrowOnError>): RequestResult<TradeServiceApplyPaymentFactResponses, TradeServiceApplyPaymentFactErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceApplyPaymentFactResponses, TradeServiceApplyPaymentFactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/facts:applyPaymentFact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Internal adapter: applies an Inventory reservation fact (inbox)
 *
 * Internal adapter: applies an Inventory reservation fact (inbox).
 */
export const tradeServiceApplyReservationFact = <ThrowOnError extends boolean = false>(options: Options<TradeServiceApplyReservationFactData, ThrowOnError>): RequestResult<TradeServiceApplyReservationFactResponses, TradeServiceApplyReservationFactErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceApplyReservationFactResponses, TradeServiceApplyReservationFactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/facts:applyReservationFact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reads one quote (`trade:buyer`)
 *
 * Reads one quote (`trade:buyer`).
 */
export const tradeServiceGetQuote = <ThrowOnError extends boolean = false>(options: Options<TradeServiceGetQuoteData, ThrowOnError>): RequestResult<TradeServiceGetQuoteResponses, TradeServiceGetQuoteErrors, ThrowOnError> => (options.client ?? client).get<TradeServiceGetQuoteResponses, TradeServiceGetQuoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/quotes/{quote}',
    ...options
});

/**
 * Generates a quote over a cart handoff (`trade:buyer`)
 *
 * Generates a quote over a cart handoff (`trade:buyer`).
 */
export const tradeServiceGenerateQuote = <ThrowOnError extends boolean = false>(options: Options<TradeServiceGenerateQuoteData, ThrowOnError>): RequestResult<TradeServiceGenerateQuoteResponses, TradeServiceGenerateQuoteErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceGenerateQuoteResponses, TradeServiceGenerateQuoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/quotes:generateQuote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists trades (`trade:buyer`, `trade:merchant.read`)
 *
 * Lists trades (`trade:buyer`, `trade:merchant.read`).
 */
export const tradeServiceListTrades = <ThrowOnError extends boolean = false>(options?: Options<TradeServiceListTradesData, ThrowOnError>): RequestResult<TradeServiceListTradesResponses, TradeServiceListTradesErrors, ThrowOnError> => (options?.client ?? client).get<TradeServiceListTradesResponses, TradeServiceListTradesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/trades',
    ...options
});

/**
 * Reads one trade (`trade:buyer`)
 *
 * Reads one trade (`trade:buyer`).
 */
export const tradeServiceGetTrade = <ThrowOnError extends boolean = false>(options: Options<TradeServiceGetTradeData, ThrowOnError>): RequestResult<TradeServiceGetTradeResponses, TradeServiceGetTradeErrors, ThrowOnError> => (options.client ?? client).get<TradeServiceGetTradeResponses, TradeServiceGetTradeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/trades/{trade}',
    ...options
});

/**
 * Returns one workflow step outcome (`trade:buyer` ownership,
 *
 * Returns one workflow step outcome (`trade:buyer` ownership,
 * `trade:merchant.read`, `trade:ops.recover`); step ids come from
 * `Trade.steps[]`.
 */
export const tradeServiceGetActionOutcome = <ThrowOnError extends boolean = false>(options: Options<TradeServiceGetActionOutcomeData, ThrowOnError>): RequestResult<TradeServiceGetActionOutcomeResponses, TradeServiceGetActionOutcomeErrors, ThrowOnError> => (options.client ?? client).get<TradeServiceGetActionOutcomeResponses, TradeServiceGetActionOutcomeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/trades/{trade}/steps/{step}',
    ...options
});

/**
 * Cancels a trade not yet paid (`trade:buyer`)
 *
 * Cancels a trade not yet paid (`trade:buyer`).
 */
export const tradeServiceCancelTrade = <ThrowOnError extends boolean = false>(options: Options<TradeServiceCancelTradeData, ThrowOnError>): RequestResult<TradeServiceCancelTradeResponses, TradeServiceCancelTradeErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceCancelTradeResponses, TradeServiceCancelTradeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/trades/{trade}:cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves manual review with an allowed command (`trade:ops.resolve`)
 *
 * Resolves manual review with an allowed command (`trade:ops.resolve`).
 */
export const tradeServiceResolveManualReview = <ThrowOnError extends boolean = false>(options: Options<TradeServiceResolveManualReviewData, ThrowOnError>): RequestResult<TradeServiceResolveManualReviewResponses, TradeServiceResolveManualReviewErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceResolveManualReviewResponses, TradeServiceResolveManualReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/trades/{trade}:resolveManualReview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-runs the durable step with an unknown outcome (`trade:ops.recover`)
 *
 * Re-runs the durable step with an unknown outcome (`trade:ops.recover`).
 */
export const tradeServiceRetryUnknownStep = <ThrowOnError extends boolean = false>(options: Options<TradeServiceRetryUnknownStepData, ThrowOnError>): RequestResult<TradeServiceRetryUnknownStepResponses, TradeServiceRetryUnknownStepErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceRetryUnknownStepResponses, TradeServiceRetryUnknownStepErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/trades/{trade}:retryUnknownStep',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submits the checkout workflow (`trade:buyer`)
 *
 * Submits the checkout workflow (`trade:buyer`).
 */
export const tradeServiceSubmitTrade = <ThrowOnError extends boolean = false>(options: Options<TradeServiceSubmitTradeData, ThrowOnError>): RequestResult<TradeServiceSubmitTradeResponses, TradeServiceSubmitTradeErrors, ThrowOnError> => (options.client ?? client).post<TradeServiceSubmitTradeResponses, TradeServiceSubmitTradeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trade/trades:submitTrade',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists in-app inbox items for a user (AIP-132, AIP-158)
 *
 * Lists in-app inbox items for a user (AIP-132, AIP-158).
 */
export const notificationServiceListInboxNotifications = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceListInboxNotificationsData, ThrowOnError>): RequestResult<NotificationServiceListInboxNotificationsResponses, NotificationServiceListInboxNotificationsErrors, ThrowOnError> => (options.client ?? client).get<NotificationServiceListInboxNotificationsResponses, NotificationServiceListInboxNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user}/inbox',
    ...options
});

/**
 * Retrieves a single inbox notification item (AIP-131)
 *
 * Retrieves a single inbox notification item (AIP-131).
 */
export const notificationServiceGetInboxItem = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceGetInboxItemData, ThrowOnError>): RequestResult<NotificationServiceGetInboxItemResponses, NotificationServiceGetInboxItemErrors, ThrowOnError> => (options.client ?? client).get<NotificationServiceGetInboxItemResponses, NotificationServiceGetInboxItemErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user}/inbox/{inbox}',
    ...options
});

/**
 * Marks a single inbox notification as read (AIP-136)
 *
 * Marks a single inbox notification as read (AIP-136).
 */
export const notificationServiceMarkInboxNotificationRead = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceMarkInboxNotificationReadData, ThrowOnError>): RequestResult<NotificationServiceMarkInboxNotificationReadResponses, NotificationServiceMarkInboxNotificationReadErrors, ThrowOnError> => (options.client ?? client).post<NotificationServiceMarkInboxNotificationReadResponses, NotificationServiceMarkInboxNotificationReadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user}/inbox/{inbox}:markRead',
    ...options
});

/**
 * Batch marks inbox notifications as read (AIP-136)
 *
 * Batch marks inbox notifications as read (AIP-136).
 */
export const notificationServiceBatchMarkInboxRead = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceBatchMarkInboxReadData, ThrowOnError>): RequestResult<NotificationServiceBatchMarkInboxReadResponses, NotificationServiceBatchMarkInboxReadErrors, ThrowOnError> => (options.client ?? client).post<NotificationServiceBatchMarkInboxReadResponses, NotificationServiceBatchMarkInboxReadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user}/inbox:batchMarkRead',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reads one address; cross-owner access is `NOT_FOUND`
 *
 * Reads one address; cross-owner access is `NOT_FOUND`.
 */
export const memberServiceGetAddress = <ThrowOnError extends boolean = false>(options: Options<MemberServiceGetAddressData, ThrowOnError>): RequestResult<MemberServiceGetAddressResponses, MemberServiceGetAddressErrors, ThrowOnError> => (options.client ?? client).get<MemberServiceGetAddressResponses, MemberServiceGetAddressErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/member/members/{member}/addresses/{address}',
    ...options
});
